import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from 'react-to-print';
import axios from 'axios';
import { BASE_URL } from '../../../config/axios';
import { AddBreakdownOfCosts, AddContingencies, AddDutyTravel, AddEmployeeBOQ, AddOfficeFurniture, AddOfficeFurnitureHeading, AddOfficeRent, AddOfficeSupplies, AddReportsPrinting, AddRoadSurveyEquipment, AddTransportation, DeleteBreakdownOfCosts, DeleteEmployeeBOQ, DeleteIDutyTravel, DeleteITransportation, DeleteOfficeFurniture, DeleteOfficeRent, DeleteOfficeSupplies, DeleteReportsPrinting, DeleteRoadSurveyEquipment, DeleteSubprofessionalStaff, DeleteSupportStaff, DeleteUpdateContingenciest, UpdateAddOfficeFurnitureHeading, UpdateBreakdownOfCosts, UpdateContingenciest, UpdateDutyTravel, UpdateEmployeeBOQ, UpdateOfficeFurniture, UpdateOfficeRent, UpdateOfficeSupplies, UpdateReportsPrinting, UpdateRoadSurveyEquipment, UpdateTransportation } from './InvoiceModel';
import { useParams } from 'react-router-dom';
import usePermission from "../../../config/permissions";
import { calculateTotal, CSSForFilterDropdown, CSSForSelectModern15VWWidth, formatCurrencyIndian, handleErrorToast } from "../../CustomFunctions";
import { BulkUpdateEmployeeBOQ, BulkUpdateTransportData, BulkUpdateutyTravelData, BulkUpdateOfficeRentData, BulkUpdateOfficeSuppliesData, BulkUpdateOfficeFurnitureData, BulkUpdateReportsData, BulkUpdateRoadSurveyData, BulkUpdateContieneous } from "./BulkUpdateBOQ"
import { ToastContainer, toast } from "react-toastify";
import EmployeeBOQinBulk from "../../uploadBOQBulk/EmployeeBOQinBulk";
import TransportationBOQBulk from "../../uploadBOQBulk/TransportationBOQBulk";
import DeleteButtonforBOQlog from "../../uploadBOQBulk/DeleteButtonforBOQlog";
import { formatDateDD_MM_YYYY } from "../../Date";
import AddDescription from "./AddDescription";
import Select from "react-select";
import DescriptionList from "./DescriptionList";

import './boqCss/employeeBOQ.css';






const SummaryTable = ({ projectData, costData, subTotal, tax, totalCost, length, eotTotals, eotWithGST, eotGST }) => (

    // <div className="table-css-background">

    //     <div className='heads-div'>
    //         <div className='heading-conslt'>
    //             <div className='flex-column'>
    //                 <div>
    //                     <h3 style={{ fontSize: "15px", textAlign: "justify" }}>{projectData?.project_name}</h3>
    //                 </div>
    //                 <div className='flex-row justify-between' style={{ width: "90vw" }}>

    //                     <div className='consultant-heading'>
    //                         <h6>Client Name:{projectData?.client_name}</h6>
    //                         <h6>Consultant (AE):{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</h6>
    //                         <h6>GSTIN No:{projectData?.gst_no}</h6>
    //                         <h6>PAN No:{projectData?.pan_no}</h6>
    //                         <h6>Bid Due Submission Date:{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</h6>
    //                         <div className='flex-row justify-between' style={{ width: "86vw" }}>
    //                             <div>
    //                                 <h6>Agreement Date:{formatDateDD_MM_YYYY(projectData?.agreement_date)}</h6>
    //                                 <h6>Project Start Date:{formatDateDD_MM_YYYY(projectData?.commencement_date)}</h6>
    //                             </div>


    //                         </div>
    //                     </div>

    //                 </div>
    //                 <th className="text-center">Summary of Costs</th>

    //             </div>
    //             {/* <AddSupportStaff id={id} getSupportStaff={getBreakdownCost}/> */}
    //         </div>
    //     </div>
    //     <table className="nested-table-lightblue">
    //         <thead>
    //             <tr>
    //                 <th rowSpan="2" style={{ borderBottom: '1px solid #ddd' }}>No.</th>
    //                 <th rowSpan="2" style={{ borderBottom: '1px solid #ddd' }}>Description</th>
    //                 <th rowSpan="2" style={{ borderBottom: '1px solid #ddd' }} className="align-right">Amount (Rs.)</th>
    //                 {length > 0 &&
    //                     <th colSpan={length} style={{ borderBottom: '1px solid #ddd' }} className="text-center">Revised Contractor Amount (Rs.)</th>
    //                 }
    //             </tr>
    //             {length > 0 &&
    //                 <tr>
    //                     {Array.from({ length: length }).map((_, idx) => (
    //                         <th
    //                             key={idx}
    //                             style={{ borderBottom: '1px solid #ddd' }}
    //                             className="align-right"
    //                         >
    //                             Revised Amount{" "} {idx + 1}
    //                         </th>
    //                     ))}
    //                 </tr>
    //             }
    //         </thead>

    //         <>
    //             <tbody>
    //                 {costData.map((item, index) => (
    //                     <tr key={index}>
    //                         <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>{index + 1}</td>
    //                         <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>{item.description}</td>
    //                         <td style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>₹{formatCurrencyIndian(item.amount)}</td>

    //                         {Array.from({ length: length }).map((_, idx) => (
    //                             <td style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'right' }} key={idx}>
    //                                 {item?.eot?.[idx] !== undefined
    //                                     ? `₹${formatCurrencyIndian(item.eot[idx])}`
    //                                     : "-"}
    //                             </td>
    //                         ))}

    //                     </tr>
    //                 ))}
    //             </tbody>
    //             <tfoot>
    //                 <tr>
    //                     <td colSpan="2" style={{ textAlign: 'right', padding: '8px', fontWeight: 'bold' }}></td>
    //                     <td style={{ padding: '8px', textAlign: 'right' }}>₹{formatCurrencyIndian(subTotal)}</td>
    //                     {eotTotals.map((val, idx) => (
    //                         <td
    //                             key={idx}
    //                             style={{
    //                                 borderTop: "2px solid #000",

    //                                 textAlign: "right",
    //                                 padding: "8px"
    //                             }}
    //                         >
    //                             ₹{formatCurrencyIndian(val)}
    //                         </td>
    //                     ))}
    //                 </tr>
    //                 <tr>
    //                     <td colSpan="2" style={{ textAlign: 'right', padding: '8px', fontWeight: 'bold' }}>Goods and Services Tax:</td>
    //                     <td style={{ padding: '8px', textAlign: 'right' }}>₹{formatCurrencyIndian(tax)}</td>
    //                     {eotGST.map((val, idx) => (
    //                         <td
    //                             key={idx}
    //                             style={{
    //                                 borderTop: "2px solid #000",

    //                                 textAlign: "right",
    //                                 padding: "8px"
    //                             }}
    //                         >
    //                             ₹{formatCurrencyIndian(Number(val.toFixed(0)))}
    //                         </td>
    //                     ))}
    //                 </tr>
    //                 <tr>
    //                     <td colSpan="2" style={{ textAlign: 'right', padding: '8px', fontWeight: 'bold' }}>Total Cost (Including Tax):</td>
    //                     <td style={{ padding: '8px', textAlign: 'right' }}><b>₹{formatCurrencyIndian(totalCost)}</b></td>
    //                     {eotWithGST.map((val, idx) => (
    //                         <td
    //                             key={idx}
    //                             style={{
    //                                 borderTop: "2px solid #000",
    //                                 fontWeight: "bold",
    //                                 textAlign: "right",
    //                                 padding: "8px"
    //                             }}
    //                         >
    //                             ₹{formatCurrencyIndian(Number(val.toFixed(0)))}
    //                         </td>
    //                     ))}
    //                 </tr>


    //             </tfoot>
    //         </>

    //     </table>
    // </div>

    <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>
        <div className="boc-modern-card">

            {/* ===== HEADER SECTION ===== */}
            <div className="boc-modern-header bocx-modern-footer-total">
                <div className="boc-modern-header-content">
                    <div className="boc-modern-project-info">
                        <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
                        <div className="boc-modern-project-meta">
                            <div className="boc-modern-meta-item">
                                <span className="boc-modern-meta-label">Client:</span>
                                <span className="boc-modern-meta-value">{projectData?.client_name}</span>
                            </div>
                            <div className="boc-modern-meta-divider"></div>
                            <div className="boc-modern-meta-item">
                                <span className="boc-modern-meta-label">Consultant (AE):</span>
                                <span className="boc-modern-meta-value">
                                    {projectData?.lead}
                                    {projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}
                                    {projectData?.association ? ` Association with ${projectData?.association}` : ""}
                                </span>
                            </div>
                            <div className="boc-modern-meta-divider"></div>
                            <div className="boc-modern-meta-item">
                                <span className="boc-modern-meta-label">GSTIN:</span>
                                <span className="boc-modern-meta-value">{projectData?.gst_no}</span>
                            </div>
                            <div className="boc-modern-meta-divider"></div>
                            <div className="boc-modern-meta-item">
                                <span className="boc-modern-meta-label">PAN:</span>
                                <span className="boc-modern-meta-value">{projectData?.pan_no}</span>
                            </div>
                            <div className="boc-modern-meta-divider"></div>
                            <div className="boc-modern-meta-item">
                                <span className="boc-modern-meta-label">Bid Due:</span>
                                <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span>
                            </div>
                            <div className="boc-modern-meta-divider"></div>
                            <div className="boc-modern-meta-item">
                                <span className="boc-modern-meta-label">Agreement:</span>
                                <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span>
                            </div>
                            <div className="boc-modern-meta-divider"></div>
                            <div className="boc-modern-meta-item">
                                <span className="boc-modern-meta-label">Start:</span>
                                <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ===== CONTROLS SECTION ===== */}
            <div className="boc-modern-controls-wrapper">
                <div className="boc-modern-controls">
                    <div className="boc-modern-controls-left">
                        <h3 className="boc-modern-main-heading">Summary of Costs</h3>
                    </div>
                </div>
            </div>

            {/* ===== TABLE SECTION ===== */}
            <div className="boc-modern-table-wrapper">
                <div className="boc-modern-table-scroll">
                    <table className="boc-modern-table">
                        <thead>
                            <tr className="boc-modern-table-header">
                                <th className="boc-modern-th text-center" rowSpan="2">Sr.No</th>
                                <th className="boc-modern-th text-center" rowSpan="2">Description</th>
                                <th className="boc-modern-th text-right" rowSpan="2">Amount (Rs.)</th>
                                {length > 0 && (
                                    <th className="boc-modern-th text-center" colSpan={length}>
                                        Revised Contractor Amount (Rs.)
                                    </th>
                                )}
                            </tr>
                            {length > 0 && (
                                <tr className="boc-modern-table-subheader">
                                    {Array.from({ length: length }).map((_, idx) => (
                                        <th key={idx} className="boc-modern-th text-right">
                                            Revised Amount {idx + 1}
                                        </th>
                                    ))}
                                </tr>
                            )}
                        </thead>
                        <tbody>
                            {costData.map((item, index) => (
                                <tr key={index} className="boc-modern-row">
                                    <td className="boc-modern-td text-center">{index + 1}</td>
                                    <td className="boc-modern-td">{item.description}</td>
                                    <td className="boc-modern-td text-right boc-modern-currency ">
                                        ₹{formatCurrencyIndian(item.amount)}
                                    </td>
                                    {Array.from({ length: length }).map((_, idx) => (
                                        <td key={idx} className="boc-modern-td text-right boc-modern-currency">
                                            {item?.eot?.[idx] !== undefined
                                                ? `₹${formatCurrencyIndian(item.eot[idx])}`
                                                : "-"}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            {/* Sub Total Row */}
                            <tr className="boc-modern-footer">
                                <td colSpan="2" className="boc-modern-footer-label text-right"></td>
                                <td className="boc-modern-td text-right boc-modern-currency bocx-modern-footer-total">
                                    ₹{formatCurrencyIndian(subTotal)}
                                </td>
                                {eotTotals.map((val, idx) => (
                                    <td key={idx} className="boc-modern-td text-right boc-modern-currency bocx-modern-footer-total">
                                        ₹{formatCurrencyIndian(val)}
                                    </td>
                                ))}
                            </tr>

                            {/* GST Row */}
                            <tr className="boc-modern-footer">
                                <td colSpan="2" className="boc-modern-footer-label text-right">
                                    Goods and Services Tax:
                                </td>
                                <td className="boc-modern-td text-right boc-modern-currency bocx-modern-footer-total">
                                    ₹{formatCurrencyIndian(tax)}
                                </td>
                                {eotGST.map((val, idx) => (
                                    <td key={idx} className="boc-modern-td text-right boc-modern-currency bocx-modern-footer-total">
                                        ₹{formatCurrencyIndian(Number(val.toFixed(0)))}
                                    </td>
                                ))}
                            </tr>

                            {/* Total Cost (Including Tax) Row */}
                            <tr className="boc-modern-footer">
                                <td colSpan="2" className="boc-modern-footer-label text-right">
                                    Total Cost (Including Tax):
                                </td>
                                <td className="boc-modern-td text-right boc-modern-currency bocx-modern-footer-total">
                                    <b>₹{formatCurrencyIndian(totalCost)}</b>
                                </td>
                                {eotWithGST.map((val, idx) => (
                                    <td key={idx} className="boc-modern-td text-right boc-modern-currency bocx-modern-footer-total">
                                        <b>₹{formatCurrencyIndian(Number(val.toFixed(0)))}</b>
                                    </td>
                                ))}
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

        </div>
    </div>

);




// const BreakdownOfCosts = ({ id, props, breakdown, getBreakdownCost, logData }) => {
//     const role = sessionStorage.getItem('sitemanagement_role');
//     const [logid, setLogId] = useState("null");


//     const brakdownList = breakdown.filter(e => e.professional_type === "Key Professional");
//     const breakdownIds = brakdownList.map(e => e.id);


//     const keyProfessional = logData.filter(
//         i => i.data.professional_type === "Key Professional" && breakdownIds.includes(i.object_id)
//     );

//     function createLatestLogMap(logDataSorted, selectedIndex) {
//         const latestMap = {};
//         for (let i = selectedIndex; i >= 0; i--) {
//             const log = logDataSorted[i];
//             if (log && !latestMap[log.object_id]) {
//                 latestMap[log.object_id] = log;
//             }
//         }
//         return latestMap;
//     }


//     let merged = [];



//     if (logid !== "null") {
//         const selectedIndex = logData.findIndex((log) => log.id === logid);
//         const selectedLog = logData[selectedIndex];

//         if (!selectedLog) {
//             // fallback if selected log not found
//             console.warn("⚠️ selectedLog not found, showing breakdown only");
//             merged = brakdownList;
//         } else {
//             const selectedObjectId = selectedLog.object_id;

//             const logsUpToSelected = logData
//                 .filter(log => log.data.professional_type === "Key Professional")
//                 .slice(0, selectedIndex + 1);

//             const latestLogMap = createLatestLogMap(logsUpToSelected, selectedIndex);

//             merged.push(selectedLog);

//             brakdownList.forEach(breakItem => {
//                 if (breakItem.id === selectedObjectId) return;

//                 const matchedLog = latestLogMap[breakItem.id];
//                 merged.push(matchedLog ? matchedLog : breakItem);
//             });
//         }
//     } else {
//         merged = brakdownList;
//     }



//     return (
//         <div className="table-css-background" >
//             <div className='heading-div'>
//                 <h3 className="main-heading"> Appendix C-3: Breakdown of Costs</h3>
//                 {role !== "SiteManagement" &&

//                     <div className="hide-on-print flex-row justify-between">
//                         {(breakdown.length > 0 && keyProfessional.length >= 1) &&
//                             <>
//                                 <select
//                                     type="text"
//                                     value={logid}
//                                     onChange={(e) => setLogId(e.target.value)}
//                                     className="dropdown font-size-subheading navbar-inputt"
//                                 >
//                                     <option value="null">BOQ {keyProfessional.length + 1}</option>

//                                     {Object.entries(
//                                         keyProfessional.reduce((acc, item) => {
//                                             const groupKey = item.data.random_value_of_changes;
//                                             if (!acc[groupKey]) acc[groupKey] = [];
//                                             acc[groupKey].push(item);
//                                             return acc;
//                                         }, {})
//                                     )
//                                         .sort((a, b) => new Date(b[0]) - new Date(a[0])) // Sort groups by random_value_of_changes DESC
//                                         .map(([randomChangeTime, group], groupIndex, groupedArray) => (
//                                             <optgroup
//                                                 key={randomChangeTime}
//                                                 label={`BOQ ${groupedArray.length - groupIndex} - ${new Date(randomChangeTime).toLocaleString()}`}
//                                             >
//                                                 {group.map((i) => (
//                                                     <option key={i.id} value={i.id}>
//                                                         {i.designation_name} - {i.employee_name || "TBN"}
//                                                     </option>
//                                                 ))}
//                                             </optgroup>
//                                         ))}
//                                 </select>



//                             </>
//                             // <select
//                             //     type="text"
//                             //     value={logid}
//                             //     onChange={(e) => setLogId(e.target.value)}
//                             //     className="dropdown font-size-subheading   navbar-inputt">
//                             //     <option value="null"> BOQ {keyProfessional.length + 1}</option>

//                             //     {keyProfessional.sort((a, b) => new Date(b.changed_at) - new Date(a.changed_at)).map((i, index) => (
//                             //         <option value={i.id}>BOQ {keyProfessional.length - index}</option>
//                             //     ))}
//                             // </select>

//                         }
//                         <AddBreakdownOfCosts id={id} getBreakdowncost={getBreakdownCost} />
//                         <BulkUpdateEmployeeBOQ boqEmployeeList={merged} id={id} getData={getBreakdownCost} value="Key Professional" />
//                     </div>
//                 }

//             </div>
//             <th className="">1. REMUNEATION FOR LOCAL PROFESSIONAL STAFF</th>
//             <table className="nested-table-lightblue">
//                 <thead>
//                     <div className='pre-heading flex-row justify-between' style={{ width: "100%" }}>
//                         <div className="">
//                             A. Key Professional
//                         </div>
//                     </div>
//                     <tr>
//                         <th>Sr.No</th>
//                         <th>Key Professional</th>
//                         <th>Name</th>
//                         <th className=''>MM Construction Period</th>
//                         <th className=''>MM OM Period</th>
//                         <th className=''>No. of Man-Months</th>
//                         <th className=''>Rate (Rs.)</th>
//                         <th className=''>Amount (Rs.)</th>
//                         {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
//                             <th className="hide-on-print align-center">Action</th>
//                         }
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {/* {breakdown.filter((e) => e.professional_type === "Key Professional") */}
//                     {merged.map((item, index) => (
//                         <React.Fragment key={index}>
//                             <tr>
//                                 <td>{index + 1}</td>
//                                 <td>{item.designation_name}</td>
//                                 <td>
//                                     <>
//                                         {
//                                             item.employee_name ? item.employee_name :
//                                                 <>

//                                                     {item.employee_name_details && item.employee_name_details.length > 0
//                                                         ? item.employee_name_details.map((e, index) => (
//                                                             <React.Fragment key={index}>
//                                                                 <span>{e.name}</span>
//                                                                 {index < item.employee_name_details.length - 1 ? ", " : ""}
//                                                             </React.Fragment>
//                                                         ))
//                                                         : "TBN"
//                                                     }
//                                                 </>
//                                         }
//                                     </>
//                                 </td>
//                                 {/* <td>{item.professional_type}</td> */}
//                                 <td>{item.MM_construction_period ? item.MM_construction_period : item.data.MM_construction_period}</td>
//                                 <td>{item.MM_OM_period ? item.MM_OM_period : item.data.MM_OM_period}</td>

//                                 <td>{(item.MM_construction_period ? Number(item.MM_construction_period) : Number(item.data.MM_construction_period)) + (item.MM_OM_period ? Number(item.MM_OM_period) : Number(item.data.MM_OM_period))}</td>
//                                 <td className="align-right">₹{formatCurrencyIndian(Number(item.rate ? item.rate : item.data.rate))}</td>
//                                 <td className="align-right">₹{formatCurrencyIndian(
//                                     (
//                                         (item.MM_construction_period ? Number(item.MM_construction_period) : Number(item.data?.MM_construction_period)) +
//                                         (item.MM_OM_period ? Number(item.MM_OM_period) : Number(item.data?.MM_OM_period))
//                                     ) * (item.rate ? Number(item.rate) : Number(item.data.rate))
//                                 )}
//                                 </td>
//                                 {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
//                                     <td className="hide-on-print flex-row  border-single">
//                                         <UpdateBreakdownOfCosts i={item} id={id} getBreakdownCost={getBreakdownCost} />
//                                         {role === "BD" || role === "Account" ? "" :
//                                             <DeleteBreakdownOfCosts i={item} getBreakdownCost={getBreakdownCost} />
//                                         }
//                                     </td>
//                                 }
//                             </tr>
//                         </React.Fragment>
//                     ))}
//                 </tbody>
//                 <tfoot>
//                     <tr>
//                         <td colSpan="7" className="total-label"></td>
//                         <td className="align-right">
//                             {
//                                 formatCurrencyIndian(
//                                     merged
//                                         .reduce((total, item, index) => {
//                                             const rate = Number(item.rate ?? item.data?.rate ?? 0);
//                                             const mmConstruction = Number(item.MM_construction_period ?? item.data?.MM_construction_period ?? 0);
//                                             const mmOM = Number(item.MM_OM_period ?? item.data?.MM_OM_period ?? 0);
//                                             const amount = rate * (mmConstruction + mmOM);

//                                             return total + amount;
//                                         }, 0)
//                                 )
//                             }
//                         </td>
//                         {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
//                             <td className="hide-on-print"></td>
//                         }
//                     </tr>
//                 </tfoot>
//             </table>
//         </div>
//     );
// };




const BreakdownOfCosts = ({ i, idDescription, descriptionData, projectData, id, props, breakdown, getBreakdownCost, logData, getLogData, logid, setLogId, buffer, setIndex }) => {
    const role = sessionStorage.getItem('sitemanagement_role');

    const brakdownList = breakdown.filter(e => e.professional_type === "Key Professional");
    const brakdownSubList = breakdown.filter(e => e.professional_type === "Sub Professional");
    const brakdownStaff = breakdown.filter(e => e.professional_type === "Support Staff");
    const breakdownIds = breakdown.map(e => e.id);
    const breakdownIds2 = brakdownList.map(e => e.id);
    const breakdownreason = breakdown[0]?.reason_of_change || "";
    const keyprofessional = logData.filter(
        i => i.data.professional_type === "Key Professional" && breakdownIds2.includes(i.object_id)
    );

    const employeeData = logData.filter(item =>
        breakdownIds.includes(item.object_id)
    );

    const groupedByRandomChange = Object.entries(
        employeeData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));
    const groupedByRandomChange2 = Object.entries(
        keyprofessional.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup = logid === "null" ? brakdownList : groupedByRandomChange2[parseInt(logid)]?.[1] || [];
    const selectedGroup2 = logid === "null" ? breakdown : groupedByRandomChange[parseInt(logid)]?.[1] || [];


    const isEotDataTrue = selectedGroup.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );

    const bocModernSelectStyles = {
        control: (base, state) => ({
            ...base,
            border: '2px solid #e2e8f0',
            borderRadius: '8px',
            padding: '1px 4px',
            minHeight: '38px',
            boxShadow: state.isFocused ? '0 0 0 3px rgba(66, 153, 225, 0.15)' : 'none',
            '&:hover': {
                borderColor: '#4299e1'
            },
            fontSize: '13px',
            fontWeight: '500',
        }),
        placeholder: (base) => ({
            ...base,
            color: '#a0aec0',
            fontSize: '13px'
        }),
        singleValue: (base) => ({
            ...base,
            color: '#2d3748',
            fontWeight: '500'
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: '#4a5568',
            padding: '4px',
            '&:hover': {
                color: '#4299e1'
            }
        }),
        clearIndicator: (base) => ({
            ...base,
            color: '#4a5568',
            padding: '4px',
            '&:hover': {
                color: '#fc8181'
            }
        }),
        menu: (base) => ({
            ...base,
            background: '#ffffff',
            borderRadius: '8px',
            boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
            marginTop: '4px',
            border: '1px solid #e2e8f0'
        }),
        menuList: (base) => ({
            ...base,
            padding: '4px',
            maxHeight: '200px',
        }),
        option: (base, { isFocused, isSelected }) => ({
            ...base,
            backgroundColor: isSelected ? '#4299e1' : isFocused ? '#ebf8ff' : 'white',
            color: isSelected ? 'white' : '#2d3748',
            padding: '8px 12px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: isSelected ? '600' : '400',
            '&:active': {
                backgroundColor: '#3182ce'
            }
        }),
        indicatorSeparator: (base) => ({
            ...base,
            backgroundColor: '#e2e8f0'
        })
    };



    const eotLengths = Math.max(
        ...selectedGroup.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );




    console.log("eotLengths")
    console.log(eotLengths);

    const eotData = selectedGroup.map(i =>
        i.eot_details?.length ? i.eot_details : (i.data?.eot_details || [])
    );


    const descriptionOption = descriptionData.map((i) => ({
        value: i.id,
        label: i.description_name
    }));

    console.log("descriptionOption", descriptionOption);
    console.log("DESCRIPTIONdATA", descriptionData);


    const [filterDescription, setFilterDescription] = useState("null");

    useEffect(() => {
        if (descriptionOption.length > 0 && filterDescription === "null") {
            setFilterDescription(descriptionOption[descriptionOption.length - 1].value);
        }
    }, [descriptionOption]);

    const handleSelectedDescription = (selectionOption) => {
        if (!selectionOption) {
            setFilterDescription("null");
        }
        else {
            setFilterDescription(selectionOption.value)
        }
    }
    const [data, setData] = useState("");

    useEffect(() => {
        if (!filterDescription || filterDescription === "null") {
            setData("");
        }
        else {
            const filteredData = descriptionData.find((item) => item.id === filterDescription);

            console.log("filteredData", filteredData);
            const descriptionText = filteredData.description_details
            if (filteredData) {
                setData(descriptionText);
            } else {
                setData("");
            }
        }



    }, [filterDescription, descriptionData]);

    console.log(data, "DescriptionDATA")
    console.log(filterDescription, "filterDescription")
    console.log(idDescription, "idDescription")


    const selectedGroupReasons = logid !== "null" && groupedByRandomChange[logid]
        ? [...new Set(
            groupedByRandomChange[logid][1]
                .map(i => i.data?.reason_of_change)
                .filter(reason =>
                    reason !== null &&
                    reason !== "null" &&
                    reason?.trim() !== ""
                )
        )]
        : [];

    const hasReason = selectedGroupReasons.length > 0;

    setIndex(hasReason);


    return (

        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>
                <div className="boc-modern-card">

                    {/* ===== HEADER SECTION ===== */}
                    <div className="boc-modern-header bocx-modern-footer-total">
                        <div className="boc-modern-header-content">
                            <div className="boc-modern-project-info">
                                <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
                                <div className="boc-modern-project-meta">
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Client:</span>
                                        <span className="boc-modern-meta-value">{projectData?.client_name}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Consultant (AE):</span>
                                        <span className="boc-modern-meta-value">
                                            {projectData?.lead}
                                            {projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}
                                            {projectData?.association ? ` Association with ${projectData?.association}` : ""}
                                        </span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">GSTIN:</span>
                                        <span className="boc-modern-meta-value">{projectData?.gst_no}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">PAN:</span>
                                        <span className="boc-modern-meta-value">{projectData?.pan_no}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Bid Due:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Agreement:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Start:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ===== CONTROLS SECTION ===== */}
                    <div className="boc-modern-controls-wrapper">
                        <div className="boc-modern-controls">
                            <div className="boc-modern-controls-left">
                                <h3 className="boc-modern-main-heading">Appendix C-3: Breakdown of Costs</h3>
                            </div>
                            {role !== "SiteManagement" && (
                                <div className="boc-modern-controls-right justify-end" style={{ width: "100%" }}>
                                    <div className="flex-row justify-end" style={{ width: "25%" }}>
                                        {(breakdown.length > 0 && employeeData.length >= 1) ? (
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label">BOQ Version</label>
                                                <select
                                                    value={logid}
                                                    onChange={(e) => setLogId(e.target.value)}
                                                    className="boc-modern-select"
                                                >
                                                    <option value="null">
                                                        BOQ {groupedByRandomChange.length + 1}- {breakdownreason}
                                                    </option>
                                                    {groupedByRandomChange.map(([groupKey, items], index) => {
                                                        const reasons = [...new Set(
                                                            items
                                                                .map(i => i.data?.reason_of_change)
                                                                .filter(reason =>
                                                                    reason !== null &&
                                                                    reason !== "null" &&
                                                                    reason?.trim() !== ""
                                                                )
                                                        )];
                                                        return (
                                                            <option key={groupKey} value={index}>
                                                                BOQ {groupedByRandomChange2.length - index}
                                                                {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        ) :
                                            <div className="boc-modern-control-group">
                                            </div>
                                        }



                                    </div>



                                    <div className="boc-modern-action-buttons" style={{ float: "right" }}>
                                        <div className="boc-modern-control-group">
                                            <label className="boc-modern-control-label">Description</label>
                                            <Select
                                                options={descriptionOption}
                                                value={
                                                    filterDescription !== "null"
                                                        ? descriptionOption.find((item) => item.value === filterDescription)
                                                        : "null"
                                                }
                                                onChange={handleSelectedDescription}
                                                isClearable
                                                placeholder="Select Description"
                                                styles={CSSForSelectModern15VWWidth}
                                            />
                                        </div>
                                        {logid === "null" && (
                                            <>
                                                <div className="boc-modern-control-group" >
                                                    <label className="boc-modern-control-label " style={{ marginBottom: '15px' }}></label>
                                                    <AddDescription
                                                        idDescription={idDescription}
                                                        descriptionList={descriptionData}
                                                        usedFor="Employee"
                                                        descriptionType="BOQEmployee"
                                                        projectId={id}
                                                    />
                                                </div>
                                                <div className="boc-modern-control-group" >
                                                    <label className="boc-modern-control-label " style={{ marginBottom: '15px' }}></label>
                                                    <EmployeeBOQinBulk
                                                        id={id}
                                                        getBreakdowncost={getBreakdownCost}
                                                        breakDownList={breakdown}
                                                        breakDownSubProfessional={brakdownSubList}
                                                        breakDownSupport={brakdownStaff}
                                                    />
                                                </div>
                                                {(role !== "SiteManagement" && breakdown.length !== 0) && (
                                                    <div className="boc-modern-control-group" >
                                                        <label className="boc-modern-control-label " style={{ marginBottom: '15px' }}></label>

                                                        <BulkUpdateEmployeeBOQ
                                                            boqEmployeeList={selectedGroup2}
                                                            id={id}
                                                            getData={getBreakdownCost}
                                                            getLogData={getLogData}
                                                            value="Key Professional"
                                                            usedFor="KP"
                                                        />
                                                    </div>
                                                )}
                                            </>
                                        )}

                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* ===== DESCRIPTION SECTION ===== */}
                    <div className="boc-modern-description-section" style={{ padding: "10px 10px" }}>
                        <div className="boc-modern-section-label">1. REMUNERATION FOR LOCAL PROFESSIONAL STAFF</div>
                        <DescriptionList data={data} />
                    </div>

                    {/* ===== TABLE SECTION ===== */}
                    <div className="boc-modern-table-wrapper">
                        <div className="boc-modern-table-scroll">
                            <table className="boc-modern-table">
                                <thead>
                                    <tr className="boc-modern-table-subheader">
                                        <td colSpan="8" className="boc-modern-pre-heading" style={{ background: "transparent" }}>
                                            <span className="boc-modern-pre-heading-text">A. Key Professional</span>
                                        </td>
                                    </tr>
                                    <tr className="boc-modern-table-header">
                                        <th className="boc-modern-th text-center" rowSpan="4">Sr.No</th>
                                        <th className="boc-modern-th text-center" rowSpan="4">Key Professional</th>
                                        <th className="boc-modern-th text-center" rowSpan="4">Name</th>
                                        <th className="boc-modern-th text-center" colSpan="5">Contract Values</th>
                                        {isEotDataTrue && (
                                            <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>
                                                Revised Contract Values (after COS/EOT)
                                            </th>
                                        )}
                                        {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                            <th className="boc-modern-th text-center" rowSpan="4">Action</th>
                                        )}
                                    </tr>
                                    <tr className="boc-modern-table-subheader">
                                        <th rowSpan="2" className="boc-modern-th">Const</th>
                                        <th rowSpan="2" className="boc-modern-th">Maint</th>
                                        <th rowSpan="2" className="boc-modern-th">Const & Maint</th>
                                        <th rowSpan="2" className="boc-modern-th">Rate</th>
                                        <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                        {Array.from({ length: eotLengths }).map((_, idx) => (
                                            <th key={idx} className="boc-modern-th text-center" colSpan={5}>
                                                {`EOT ${idx + 1}`}
                                            </th>
                                        ))}
                                    </tr>
                                    <tr className="boc-modern-table-subheader">
                                        {Array.from({ length: eotLengths }).map((_, idx) => (
                                            <React.Fragment key={idx}>
                                                <th rowSpan="2" className="boc-modern-th">Const</th>
                                                <th rowSpan="2" className="boc-modern-th">Maint</th>
                                                <th rowSpan="2" className="boc-modern-th">Const & Maint</th>
                                                <th rowSpan="2" className="boc-modern-th">Rate</th>
                                                <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                </thead>
                                {buffer ? (
                                    <tbody>
                                        <tr>
                                            <td colSpan="20">
                                                <div className="boc-modern-loading">
                                                    <div className="boc-modern-spinner"></div>
                                                    <span>Loading data...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                ) : (
                                    <>
                                        <tbody>
                                            {selectedGroup.sort((a, b) => a.rank - b.rank).map((item, index) => (
                                                <tr key={item.id} className="boc-modern-row">
                                                    <td className="boc-modern-td text-center">{index + 1}</td>
                                                    <td className="boc-modern-td">{item.designation_name}</td>
                                                    <td className="boc-modern-td">
                                                        {item.employee_name || (
                                                            item.employee_name_details?.length > 0
                                                                ? item.employee_name_details.map((e, i) => (
                                                                    <React.Fragment key={i}>
                                                                        <span className="boc-modern-employee-name">{e.name}</span>
                                                                        {i < item.employee_name_details.length - 1 ? ", " : ""}
                                                                    </React.Fragment>
                                                                ))
                                                                : <span className="boc-modern-tbn">TBN</span>
                                                        )}
                                                    </td>
                                                    <td className="boc-modern-td text-right">
                                                        {item.MM_construction_period ?? item.data?.MM_construction_period}
                                                    </td>
                                                    <td className="boc-modern-td text-right">
                                                        {item.MM_OM_period ?? item.data?.MM_OM_period}
                                                    </td>
                                                    <td className="boc-modern-td text-right">
                                                        {Number(item.MM_construction_period ?? item.data?.MM_construction_period) +
                                                            Number(item.MM_OM_period ?? item.data?.MM_OM_period)}
                                                    </td>
                                                    <td className="boc-modern-td text-right boc-modern-currency">
                                                        ₹{formatCurrencyIndian(Number(item.rate ?? item.data?.rate))}
                                                    </td>
                                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-total-highlight">
                                                        ₹{formatCurrencyIndian(
                                                            (Number(item.MM_construction_period ?? item.data?.MM_construction_period) +
                                                                Number(item.MM_OM_period ?? item.data?.MM_OM_period)) *
                                                            Number(item.rate ?? item.data?.rate)
                                                        )}
                                                    </td>
                                                    {item?.eot_details?.length > 0 ? (
                                                        item.eot_details?.map((eot, idx) => (
                                                            <React.Fragment key={idx}>
                                                                <td className="boc-modern-td text-right">{eot.cp}</td>
                                                                <td className="boc-modern-td text-right">{eot.dlp}</td>
                                                                <td className="boc-modern-td text-right">{eot.t_month}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(eot.rate)}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(eot.total_amount)}</td>
                                                            </React.Fragment>
                                                        ))
                                                    ) : (
                                                        item.data?.eot_details?.map((eot, idx) => (
                                                            <React.Fragment key={idx}>
                                                                <td className="boc-modern-td text-right">{eot.cp}</td>
                                                                <td className="boc-modern-td text-right">{eot.dlp}</td>
                                                                <td className="boc-modern-td text-right">{eot.t_month}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(eot.rate)}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(eot.total_amount)}</td>
                                                            </React.Fragment>
                                                        ))
                                                    )}
                                                    {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                        <td className="boc-modern-td text-center">
                                                            {role !== "BD" && role !== "Account" && (
                                                                <DeleteBreakdownOfCosts
                                                                    usedFor="KP"
                                                                    i={item}
                                                                    getBreakdownCost={getBreakdownCost}
                                                                    getLogData={getLogData}
                                                                />
                                                            )}
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>

                                        <tfoot>
                                            <tr className="boc-modern-footer">
                                                <td colSpan="7" className="boc-modern-footer-label">Total</td>
                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                    ₹{formatCurrencyIndian(
                                                        selectedGroup.reduce((total, item) => {
                                                            const rate = Number(item.rate ?? item.data?.rate ?? 0);
                                                            const mmConstruction = Number(item.MM_construction_period ?? item.data?.MM_construction_period ?? 0);
                                                            const mmOM = Number(item.MM_OM_period ?? item.data?.MM_OM_period ?? 0);
                                                            return total + rate * (mmConstruction + mmOM);
                                                        }, 0)
                                                    )}
                                                </td>
                                                {isEotDataTrue && (
                                                    <>
                                                        {Array.from({ length: eotLengths }).map((_, eotIdx) => {
                                                            const subTotal = selectedGroup.reduce((sum, emp) => {
                                                                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                                                                const eot = details[eotIdx];
                                                                return sum + (Number(eot?.total_amount) || 0);
                                                            }, 0);
                                                            return (
                                                                <React.Fragment key={eotIdx}>
                                                                    <td colSpan="4" className="boc-modern-footer-label"></td>
                                                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                                        ₹{formatCurrencyIndian(subTotal)}
                                                                    </td>
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </>
                                                )}
                                                {(role !== "SiteManagement" && logid !== "null" && role !== "Checker" && hasReason) && (
                                                    <td className="boc-modern-td"></td>
                                                )}
                                            </tr>
                                        </tfoot>
                                    </>
                                )}
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </>

    );
};



const SubprofessionalStaff = ({ index, id, props, breakdown, getBreakdownCost, logData, getLogData, logid, setLogId }) => {
    const role = sessionStorage.getItem('sitemanagement_role');


    const brakdownList = breakdown.filter(e => e.professional_type === "Sub Professional");
    const breakdownIds = brakdownList.map(e => e.id);
    const breakdownreason = brakdownList[0]?.reason_of_change || "";


    const subProfessional = logData.filter(
        i => i.data.professional_type === "Sub Professional" && breakdownIds.includes(i.object_id)
    );

    const groupedByRandomChange = Object.entries(
        subProfessional.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup = logid === "null"
        ? brakdownList
        : groupedByRandomChange[parseInt(logid)]?.[1] || [];
    const nullGroupItems = subProfessional.filter(
        item =>
            !item.data?.random_value_of_changes ||
            item.data?.random_value_of_changes === "null" ||
            item.data?.random_value_of_changes.trim() === ""
    );

    const isEotDataTrue = selectedGroup.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );





    const eotLengths = Math.max(
        ...selectedGroup.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );




    // return (


    //     <div className="table-css-background">
    //         {/* <h3 className="main-heading"> Appendix C-3: Breakdown of Costs</h3> */}
    //         <div className="flex-row justify-between">

    //             <th className="">B. Sub-professional Staff</th>



    //         </div>

    //         <table className="nested-table-lightblue">
    //             <thead>
    //                 <tr className='theading'>
    //                     <th className='table-heading-text text-center' rowSpan="4">Sr.No</th>
    //                     <th className='table-heading-text text-center' rowSpan="4">Sub Professional</th>
    //                     <th className='table-heading-text text-center' rowSpan="4">Name</th>
    //                     <th className='table-heading-text text-center' colSpan="5">Contract Values</th>
    //                     {isEotDataTrue &&

    //                         <th
    //                             className="table-heading-text text-center"
    //                             colSpan={eotLengths * 5 || 1}
    //                         >
    //                             Revised Contract Values (after COS/EOT)
    //                         </th>
    //                     }

    //                     {(role !== "SiteManagement" && logid !== "null" && role !== "Checker" && index) &&
    //                         <th className="hide-on-print align-center" rowSpan="4">Action</th>
    //                     }
    //                 </tr>
    //                 <tr className='nested-heading'>
    //                     <th rowSpan="2" className='table-heading-text'>Const</th>
    //                     <th rowSpan="2" className='table-heading-text'>Maint</th>
    //                     <th rowSpan="2" className='table-heading-text'>Const & Maint</th>
    //                     <th rowSpan="2" className='table-heading-text'>Rate</th>
    //                     <th rowSpan="2" className='table-heading-text'>Total Amount</th>

    //                     {/* Dynamically add EOT headers */}
    //                     {Array.from({ length: eotLengths }).map((_, idx) => (
    //                         <th key={idx} className="table-heading-text text-center" colSpan={5}>
    //                             {`EOT ${idx + 1}`}
    //                         </th>
    //                     ))}

    //                 </tr>

    //                 <tr className='nested-heading'>
    //                     {Array.from({ length: eotLengths }).map((_, idx) => (
    //                         <React.Fragment key={idx}>
    //                             <th rowSpan="2" className='table-heading-text'>Const</th>
    //                             <th rowSpan="2" className='table-heading-text'>Maint</th>
    //                             <th rowSpan="2" className='table-heading-text'>Const & Maint</th>
    //                             <th rowSpan="2" className='table-heading-text'>Rate</th>
    //                             <th rowSpan="2" className='table-heading-text'>Total Amount</th>
    //                         </React.Fragment>
    //                     ))}

    //                 </tr>
    //                 {/* <div className='pre-heading'>
    //                     A. Key Personal
    //                 </div> */}
    //             </thead>
    //             <tbody>
    //                 {selectedGroup.sort((a, b) => a.rank - b.rank).map((item, idx) => (
    //                     <tr key={item.id}>
    //                         <td>{idx + 1}</td>
    //                         <td>{item.designation_name}</td>
    //                         <td>
    //                             {item.employee_name || (
    //                                 item.employee_name_details?.length > 0
    //                                     ? item.employee_name_details.map((e, i) => (
    //                                         <React.Fragment key={i}>
    //                                             <span>{e.name}</span>
    //                                             {i < item.employee_name_details.length - 1 ? ", " : ""}
    //                                         </React.Fragment>
    //                                     ))
    //                                     : "TBN"
    //                             )}
    //                         </td>
    //                         <td>{item.MM_construction_period ?? item.data?.MM_construction_period}</td>
    //                         <td>{item.MM_OM_period ?? item.data?.MM_OM_period}</td>
    //                         <td>
    //                             {Number(item.MM_construction_period ?? item.data?.MM_construction_period) +
    //                                 Number(item.MM_OM_period ?? item.data?.MM_OM_period)}
    //                         </td>
    //                         <td className="align-right">₹{formatCurrencyIndian(Number(item.rate ?? item.data?.rate))}</td>
    //                         <td className="align-right">₹{formatCurrencyIndian(
    //                             (Number(item.MM_construction_period ?? item.data?.MM_construction_period) +
    //                                 Number(item.MM_OM_period ?? item.data?.MM_OM_period)) *
    //                             Number(item.rate ?? item.data?.rate)
    //                         )}</td>
    //                         {item.eot_details?.length > 0 ?
    //                             <>
    //                                 {item.eot_details?.map((i) => (
    //                                     <>
    //                                         <td className="align-right">{i.cp} </td>
    //                                         <td className="align-right">{i.dlp} </td>
    //                                         <td className="align-right">{i.t_month} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.rate)} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
    //                                     </>
    //                                 ))}
    //                             </> :
    //                             <>
    //                                 {item.data?.eot_details?.map((i) => (
    //                                     <>
    //                                         <td className="align-right">{i.cp} </td>
    //                                         <td className="align-right">{i.dlp} </td>
    //                                         <td className="align-right">{i.t_month} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.rate)} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
    //                                     </>
    //                                 ))}
    //                             </>
    //                         }
    //                         {(role !== "SiteManagement" && logid !== "null" && role !== "Checker" && index) &&
    //                             <td className="hide-on-print flex-row border-single">
    //                                 {(breakdown.length > 0 && subProfessional.length >= 1) &&
    //                                     // ✅ Hide delete when reason.length is 0
    //                                     <DeleteButtonforBOQlog usedFor="SP" i={item} getData={getBreakdownCost} getLogData={getLogData} />
    //                                 }
    //                                 {breakdown.length === 0 && subProfessional.length === 0 &&
    //                                     <DeleteBreakdownOfCosts usedFor="SP" i={item} getBreakdownCost={getBreakdownCost} getLogData={getLogData} />
    //                                 }
    //                             </td>
    //                         }
    //                     </tr>
    //                 ))}
    //             </tbody>

    //             <tfoot>
    //                 <tr>
    //                     <td colSpan="7" className="total-label">Total</td>
    //                     <td className="align-right">

    //                         ₹{formatCurrencyIndian(
    //                             selectedGroup.reduce((total, item) => {
    //                                 const rate = Number(item.rate ?? item.data?.rate ?? 0);
    //                                 const mmConstruction = Number(item.MM_construction_period ?? item.data?.MM_construction_period ?? 0);
    //                                 const mmOM = Number(item.MM_OM_period ?? item.data?.MM_OM_period ?? 0);
    //                                 return total + rate * (mmConstruction + mmOM);
    //                             }, 0)
    //                         )}
    //                     </td>
    //                     {isEotDataTrue && (
    //                         <>
    //                             {Array.from({ length: eotLengths }).map((_, eotIdx) => {
    //                                 // sum this EOT index across all employees
    //                                 const subTotal = selectedGroup.reduce((sum, emp) => {
    //                                     const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
    //                                     const eot = details[eotIdx];
    //                                     return sum + (Number(eot?.total_amount) || 0);
    //                                 }, 0);

    //                                 return (
    //                                     <React.Fragment key={eotIdx}>
    //                                         <td colSpan="4" className="total-label"></td>
    //                                         <td className="align-right">
    //                                             ₹{formatCurrencyIndian(subTotal)}
    //                                         </td>
    //                                     </React.Fragment>
    //                                 );
    //                             })}
    //                         </>
    //                     )}



    //                     {(role !== "SiteManagement" && logid !== "null" && role !== "Checker" && index) &&
    //                         <td className="hide-on-print"></td>
    //                     }
    //                 </tr>
    //             </tfoot>
    //         </table>
    //     </div>
    // );

    return (
        <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>
            <div className="boc-modern-card">
                <div className="boc-modern-table-wrapper">
                    <div className="flex-row justify-between">
                    </div>
                    <div className="boc-modern-table-scroll">
                        <table className="boc-modern-table">
                            <thead>
                                <tr className="boc-modern-table-subheader">
                                    <td colSpan="8" className="boc-modern-pre-heading" style={{ background: "transparent" }}>
                                        <span className="boc-modern-pre-heading-text">B. Sub-professional Staff</span>
                                    </td>
                                </tr>
                                <tr className="boc-modern-table-header">
                                    <th className="boc-modern-th text-center" rowSpan="4">Sr.No</th>
                                    <th className="boc-modern-th text-center" rowSpan="4">Sub Professional</th>
                                    <th className="boc-modern-th text-center" rowSpan="4">Name</th>
                                    <th className="boc-modern-th text-center" colSpan="5">Contract Values</th>
                                    {isEotDataTrue && (
                                        <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>
                                            Revised Contract Values (after COS/EOT)
                                        </th>
                                    )}
                                    {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                        <th className="boc-modern-th text-center" rowSpan="4">Action</th>
                                    )}
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    <th rowSpan="2" className="boc-modern-th">Const</th>
                                    <th rowSpan="2" className="boc-modern-th">Maint</th>
                                    <th rowSpan="2" className="boc-modern-th">Const & Maint</th>
                                    <th rowSpan="2" className="boc-modern-th">Rate</th>
                                    <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <th key={idx} className="boc-modern-th text-center" colSpan={5}>
                                            {`EOT ${idx + 1}`}
                                        </th>
                                    ))}
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <React.Fragment key={idx}>
                                            <th rowSpan="2" className="boc-modern-th">Const</th>
                                            <th rowSpan="2" className="boc-modern-th">Maint</th>
                                            <th rowSpan="2" className="boc-modern-th">Const & Maint</th>
                                            <th rowSpan="2" className="boc-modern-th">Rate</th>
                                            <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {selectedGroup.sort((a, b) => a.rank - b.rank).map((item, idx) => (
                                    <tr key={item.id} className="boc-modern-row">
                                        <td className="boc-modern-td text-center">{idx + 1}</td>
                                        <td className="boc-modern-td">{item.designation_name}</td>
                                        <td className="boc-modern-td">
                                            {item.employee_name || (
                                                item.employee_name_details?.length > 0
                                                    ? item.employee_name_details.map((e, i) => (
                                                        <React.Fragment key={i}>
                                                            <span className="boc-modern-employee-name">{e.name}</span>
                                                            {i < item.employee_name_details.length - 1 ? ", " : ""}
                                                        </React.Fragment>
                                                    ))
                                                    : <span className="boc-modern-tbn">TBN</span>
                                            )}
                                        </td>
                                        <td className="boc-modern-td text-right">
                                            {item.MM_construction_period ?? item.data?.MM_construction_period}
                                        </td>
                                        <td className="boc-modern-td text-right">
                                            {item.MM_OM_period ?? item.data?.MM_OM_period}
                                        </td>
                                        <td className="boc-modern-td text-right">
                                            {Number(item.MM_construction_period ?? item.data?.MM_construction_period) +
                                                Number(item.MM_OM_period ?? item.data?.MM_OM_period)}
                                        </td>
                                        <td className="boc-modern-td text-right boc-modern-currency">
                                            ₹{formatCurrencyIndian(Number(item.rate ?? item.data?.rate))}
                                        </td>
                                        <td className="boc-modern-td text-right boc-modern-currency boc-modern-total-highlight">
                                            ₹{formatCurrencyIndian(
                                                (Number(item.MM_construction_period ?? item.data?.MM_construction_period) +
                                                    Number(item.MM_OM_period ?? item.data?.MM_OM_period)) *
                                                Number(item.rate ?? item.data?.rate)
                                            )}
                                        </td>
                                        {item?.eot_details?.length > 0 ? (
                                            item.eot_details.map((eot, i) => (
                                                <React.Fragment key={i}>
                                                    <td className="boc-modern-td text-right">{eot.cp}</td>
                                                    <td className="boc-modern-td text-right">{eot.dlp}</td>
                                                    <td className="boc-modern-td text-right">{eot.t_month}</td>
                                                    <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(eot.rate)}</td>
                                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(eot.total_amount)}</td>
                                                </React.Fragment>
                                            ))
                                        ) : (
                                            item.data?.eot_details?.map((eot, i) => (
                                                <React.Fragment key={i}>
                                                    <td className="boc-modern-td text-right">{eot.cp}</td>
                                                    <td className="boc-modern-td text-right">{eot.dlp}</td>
                                                    <td className="boc-modern-td text-right">{eot.t_month}</td>
                                                    <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(eot.rate)}</td>
                                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(eot.total_amount)}</td>
                                                </React.Fragment>
                                            ))
                                        )}
                                        {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                            <td className="boc-modern-td text-center">
                                                {role !== "BD" && role !== "Account" && (
                                                    <DeleteBreakdownOfCosts usedFor="SP" i={item} getBreakdownCost={getBreakdownCost} getLogData={getLogData} />

                                                )}
                                            </td>
                                        )}

                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr className="boc-modern-footer">
                                    <td colSpan="7" className="boc-modern-footer-label">Total</td>
                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                        ₹{formatCurrencyIndian(
                                            selectedGroup.reduce((total, item) => {
                                                const rate = Number(item.rate ?? item.data?.rate ?? 0);
                                                const mmConstruction = Number(item.MM_construction_period ?? item.data?.MM_construction_period ?? 0);
                                                const mmOM = Number(item.MM_OM_period ?? item.data?.MM_OM_period ?? 0);
                                                return total + rate * (mmConstruction + mmOM);
                                            }, 0)
                                        )}
                                    </td>
                                    {isEotDataTrue && (
                                        <>
                                            {Array.from({ length: eotLengths }).map((_, eotIdx) => {
                                                const subTotal = selectedGroup.reduce((sum, emp) => {
                                                    const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                                                    const eot = details[eotIdx];
                                                    return sum + (Number(eot?.total_amount) || 0);
                                                }, 0);
                                                return (
                                                    <React.Fragment key={eotIdx}>
                                                        <td colSpan="4" className="boc-modern-footer-label"></td>
                                                        <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                            ₹{formatCurrencyIndian(subTotal)}
                                                        </td>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </>
                                    )}
                                    {(role !== "SiteManagement" && logid !== "null" && role !== "Checker" && index) && (
                                        <td className="boc-modern-td"></td>
                                    )}
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>


        </div>
    );
};


const SupportStaff = ({ index, id, props, breakdown, getBreakdownCost, logData, getLogData, logid, setLogId }) => {

    const role = sessionStorage.getItem('sitemanagement_role');



    const brakdownList = breakdown.filter(e => e.professional_type === "Support Staff");
    const breakdownIds = brakdownList.map(e => e.id);
    const breakdownreason = brakdownList[0]?.reason_of_change || "";


    const subProfessional = logData.filter(
        i => i.data.professional_type === "Support Staff" && breakdownIds.includes(i.object_id)
    );

    const groupedByRandomChange = Object.entries(
        subProfessional.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup = logid === "null"
        ? brakdownList
        : groupedByRandomChange[parseInt(logid)]?.[1] || [];


    const isEotDataTrue = selectedGroup.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );





    const eotLengths = Math.max(
        ...selectedGroup.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );



    // return (
    //     <div className="table-css-background">
    //         {/* <th className="">1. REMUNEATION FOR LOCAL PROFESSIONAL STAFF</th> */}
    //         <div className='heads-div'>
    //             <th className="">2. Support Staff</th>

    //         </div>
    //         <table className="nested-table-lightblue">
    //             <thead>
    //                 <tr className='theading'>
    //                     <th className='table-heading-text text-center' rowSpan="4">Sr.No</th>
    //                     <th className='table-heading-text text-center' rowSpan="4">Support Staff</th>
    //                     <th className='table-heading-text text-center' rowSpan="4">Name</th>
    //                     <th className='table-heading-text text-center' colSpan="5">Contract Values</th>
    //                     {isEotDataTrue &&

    //                         <th
    //                             className="table-heading-text text-center"
    //                             colSpan={eotLengths * 5 || 1}
    //                         >
    //                             Revised Contract Values (after COS/EOT)
    //                         </th>
    //                     }

    //                     {(role !== "SiteManagement" && logid !== "null" && role !== "Checker" && index) &&
    //                         <th className="hide-on-print align-center" rowSpan="4">Action</th>
    //                     }
    //                 </tr>
    //                 <tr className='nested-heading'>
    //                     <th rowSpan="2" className='table-heading-text'>Const</th>
    //                     <th rowSpan="2" className='table-heading-text'>Maint</th>
    //                     <th rowSpan="2" className='table-heading-text'>Const & Maint</th>
    //                     <th rowSpan="2" className='table-heading-text'>Rate</th>
    //                     <th rowSpan="2" className='table-heading-text'>Total Amount</th>

    //                     {/* Dynamically add EOT headers */}
    //                     {Array.from({ length: eotLengths }).map((_, idx) => (
    //                         <th key={idx} className="table-heading-text text-center" colSpan={5}>
    //                             {`EOT ${idx + 1}`}
    //                         </th>
    //                     ))}

    //                 </tr>

    //                 <tr className='nested-heading'>
    //                     {Array.from({ length: eotLengths }).map((_, idx) => (
    //                         <React.Fragment key={idx}>
    //                             <th rowSpan="2" className='table-heading-text'>Const</th>
    //                             <th rowSpan="2" className='table-heading-text'>Maint</th>
    //                             <th rowSpan="2" className='table-heading-text'>Const & Maint</th>
    //                             <th rowSpan="2" className='table-heading-text'>Rate</th>
    //                             <th rowSpan="2" className='table-heading-text'>Total Amount</th>
    //                         </React.Fragment>
    //                     ))}

    //                 </tr>
    //                 {/* <div className='pre-heading'>
    //                     A. Key Personal
    //                 </div> */}
    //             </thead>
    //             <tbody>
    //                 {selectedGroup.sort((a, b) => a.rank - b.rank).map((item, idx) => (
    //                     <tr key={item.id}>
    //                         <td>{idx + 1}</td>
    //                         <td>{item.designation_name}</td>
    //                         <td>
    //                             {item.employee_name || (
    //                                 item.employee_name_details?.length > 0
    //                                     ? item.employee_name_details.map((e, i) => (
    //                                         <React.Fragment key={i}>
    //                                             <span>{e.name}</span>
    //                                             {i < item.employee_name_details.length - 1 ? ", " : ""}
    //                                         </React.Fragment>
    //                                     ))
    //                                     : "TBN"
    //                             )}
    //                         </td>
    //                         <td>{item.MM_construction_period ?? item.data?.MM_construction_period}</td>
    //                         <td>{item.MM_OM_period ?? item.data?.MM_OM_period}</td>
    //                         <td>
    //                             {Number(item.MM_construction_period ?? item.data?.MM_construction_period) +
    //                                 Number(item.MM_OM_period ?? item.data?.MM_OM_period)}
    //                         </td>
    //                         <td className="align-right">₹{formatCurrencyIndian(Number(item.rate ?? item.data?.rate))}</td>
    //                         <td className="align-right">₹{formatCurrencyIndian(
    //                             (Number(item.MM_construction_period ?? item.data?.MM_construction_period) +
    //                                 Number(item.MM_OM_period ?? item.data?.MM_OM_period)) *
    //                             Number(item.rate ?? item.data?.rate)
    //                         )}</td>
    //                         {item.eot_details?.length > 0 ?
    //                             <>
    //                                 {item.eot_details?.map((i) => (
    //                                     <>
    //                                         <td className="align-right">{i.cp} </td>
    //                                         <td className="align-right">{i.dlp} </td>
    //                                         <td className="align-right">{i.t_month} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.rate)} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
    //                                     </>
    //                                 ))}
    //                             </> :
    //                             <>
    //                                 {item.data?.eot_details?.map((i) => (
    //                                     <>
    //                                         <td className="align-right">{i.cp} </td>
    //                                         <td className="align-right">{i.dlp} </td>
    //                                         <td className="align-right">{i.t_month} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.rate)} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
    //                                     </>
    //                                 ))}
    //                             </>
    //                         }
    //                         {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
    //                             <td className="boc-modern-td text-center">
    //                                 {role !== "BD" && role !== "Account" && (
    //                                     <DeleteBreakdownOfCosts i={item} getBreakdownCost={getBreakdownCost} getLogData={getLogData} />

    //                                 )}
    //                             </td>
    //                         )}

    //                     </tr>
    //                 ))}
    //             </tbody>
    //             <tfoot>
    //                 <tr>
    //                     <td colSpan="7" className="total-label">Total</td>
    //                     <td className="align-right">

    //                         ₹{formatCurrencyIndian(
    //                             selectedGroup.reduce((total, item) => {
    //                                 const rate = Number(item.rate ?? item.data?.rate ?? 0);
    //                                 const mmConstruction = Number(item.MM_construction_period ?? item.data?.MM_construction_period ?? 0);
    //                                 const mmOM = Number(item.MM_OM_period ?? item.data?.MM_OM_period ?? 0);
    //                                 return total + rate * (mmConstruction + mmOM);
    //                             }, 0)
    //                         )}
    //                     </td>
    //                     {isEotDataTrue && (
    //                         <>
    //                             {Array.from({ length: eotLengths }).map((_, eotIdx) => {
    //                                 // sum this EOT index across all employees
    //                                 const subTotal = selectedGroup.reduce((sum, emp) => {
    //                                     const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
    //                                     const eot = details[eotIdx];
    //                                     return sum + (Number(eot?.total_amount) || 0);
    //                                 }, 0);

    //                                 return (
    //                                     <React.Fragment key={eotIdx}>
    //                                         <td colSpan="4" className="total-label"></td>
    //                                         <td className="align-right">
    //                                             ₹{formatCurrencyIndian(subTotal)}
    //                                         </td>
    //                                     </React.Fragment>
    //                                 );
    //                             })}
    //                         </>
    //                     )}



    //                     {(role !== "SiteManagement" && logid !== "null" && role !== "Checker" && index) &&
    //                         <td className="hide-on-print"></td>
    //                     }
    //                 </tr>
    //             </tfoot>
    //         </table>
    //     </div>
    // );

    return (
        <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>
            <div className="boc-modern-card">
                <div className="boc-modern-table-wrapper">
                    <div className="boc-modern-table-scroll">
                        <table className="boc-modern-table">
                            <thead>
                                <tr className="boc-modern-table-subheader">
                                    <td colSpan="8" className="boc-modern-pre-heading" style={{ background: "transparent" }}>
                                        <span className="boc-modern-pre-heading-text">2. Support Staff</span>
                                    </td>
                                </tr>
                                <tr className="boc-modern-table-header">
                                    <th className="boc-modern-th text-center" rowSpan="4">Sr.No</th>
                                    <th className="boc-modern-th text-center" rowSpan="4">Support Staff</th>
                                    <th className="boc-modern-th text-center" rowSpan="4">Name</th>
                                    <th className="boc-modern-th text-center" colSpan="5">Contract Values</th>
                                    {isEotDataTrue && (
                                        <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>
                                            Revised Contract Values (after COS/EOT)
                                        </th>
                                    )}
                                    {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                        <th className="boc-modern-th text-center" rowSpan="4">Action</th>
                                    )}
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    <th rowSpan="2" className="boc-modern-th">Const</th>
                                    <th rowSpan="2" className="boc-modern-th">Maint</th>
                                    <th rowSpan="2" className="boc-modern-th">Const & Maint</th>
                                    <th rowSpan="2" className="boc-modern-th">Rate</th>
                                    <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <th key={idx} className="boc-modern-th text-center" colSpan={5}>
                                            {`EOT ${idx + 1}`}
                                        </th>
                                    ))}
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <React.Fragment key={idx}>
                                            <th rowSpan="2" className="boc-modern-th">Const</th>
                                            <th rowSpan="2" className="boc-modern-th">Maint</th>
                                            <th rowSpan="2" className="boc-modern-th">Const & Maint</th>
                                            <th rowSpan="2" className="boc-modern-th">Rate</th>
                                            <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {selectedGroup.sort((a, b) => a.rank - b.rank).map((item, idx) => (
                                    <tr key={item.id} className="boc-modern-row">
                                        <td className="boc-modern-td text-center">{idx + 1}</td>
                                        <td className="boc-modern-td">{item.designation_name}</td>
                                        <td className="boc-modern-td">
                                            {item.employee_name || (
                                                item.employee_name_details?.length > 0
                                                    ? item.employee_name_details.map((e, i) => (
                                                        <React.Fragment key={i}>
                                                            <span className="boc-modern-employee-name">{e.name}</span>
                                                            {i < item.employee_name_details.length - 1 ? ", " : ""}
                                                        </React.Fragment>
                                                    ))
                                                    : <span className="boc-modern-tbn">TBN</span>
                                            )}
                                        </td>
                                        <td className="boc-modern-td text-right">
                                            {item.MM_construction_period ?? item.data?.MM_construction_period}
                                        </td>
                                        <td className="boc-modern-td text-right">
                                            {item.MM_OM_period ?? item.data?.MM_OM_period}
                                        </td>
                                        <td className="boc-modern-td text-right">
                                            {Number(item.MM_construction_period ?? item.data?.MM_construction_period) +
                                                Number(item.MM_OM_period ?? item.data?.MM_OM_period)}
                                        </td>
                                        <td className="boc-modern-td text-right boc-modern-currency">
                                            ₹{formatCurrencyIndian(Number(item.rate ?? item.data?.rate))}
                                        </td>
                                        <td className="boc-modern-td text-right boc-modern-currency boc-modern-total-highlight">
                                            ₹{formatCurrencyIndian(
                                                (Number(item.MM_construction_period ?? item.data?.MM_construction_period) +
                                                    Number(item.MM_OM_period ?? item.data?.MM_OM_period)) *
                                                Number(item.rate ?? item.data?.rate)
                                            )}
                                        </td>
                                        {item?.eot_details?.length > 0 ? (
                                            item.eot_details.map((eot, i) => (
                                                <React.Fragment key={i}>
                                                    <td className="boc-modern-td text-right">{eot.cp}</td>
                                                    <td className="boc-modern-td text-right">{eot.dlp}</td>
                                                    <td className="boc-modern-td text-right">{eot.t_month}</td>
                                                    <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(eot.rate)}</td>
                                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(eot.total_amount)}</td>
                                                </React.Fragment>
                                            ))
                                        ) : (
                                            item.data?.eot_details?.map((eot, i) => (
                                                <React.Fragment key={i}>
                                                    <td className="boc-modern-td text-right">{eot.cp}</td>
                                                    <td className="boc-modern-td text-right">{eot.dlp}</td>
                                                    <td className="boc-modern-td text-right">{eot.t_month}</td>
                                                    <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(eot.rate)}</td>
                                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(eot.total_amount)}</td>
                                                </React.Fragment>
                                            ))
                                        )}
                                        {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                            <td className="boc-modern-td text-center">
                                                {role !== "BD" && role !== "Account" && (
                                                    <DeleteBreakdownOfCosts i={item} getBreakdownCost={getBreakdownCost} getLogData={getLogData} />
                                                )}
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr className="boc-modern-footer">
                                    <td colSpan="7" className="boc-modern-footer-label">Total</td>
                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                        ₹{formatCurrencyIndian(
                                            selectedGroup.reduce((total, item) => {
                                                const rate = Number(item.rate ?? item.data?.rate ?? 0);
                                                const mmConstruction = Number(item.MM_construction_period ?? item.data?.MM_construction_period ?? 0);
                                                const mmOM = Number(item.MM_OM_period ?? item.data?.MM_OM_period ?? 0);
                                                return total + rate * (mmConstruction + mmOM);
                                            }, 0)
                                        )}
                                    </td>
                                    {isEotDataTrue && (
                                        <>
                                            {Array.from({ length: eotLengths }).map((_, eotIdx) => {
                                                const subTotal = selectedGroup.reduce((sum, emp) => {
                                                    const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                                                    const eot = details[eotIdx];
                                                    return sum + (Number(eot?.total_amount) || 0);
                                                }, 0);
                                                return (
                                                    <React.Fragment key={eotIdx}>
                                                        <td colSpan="4" className="boc-modern-footer-label"></td>
                                                        <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                            ₹{formatCurrencyIndian(subTotal)}
                                                        </td>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </>
                                    )}
                                    {(role !== "SiteManagement" && logid !== "null" && role !== "Checker" && index) && (
                                        <td className="boc-modern-td"></td>
                                    )}
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );

};



const Transportation = ({ idDescription, descriptionData, projectData, props, transportation, getTransportation, id, getLogData, logData, logid, setLogId, groupedByRandomChange, selectedGroup, buffer }) => {

    const role = sessionStorage.getItem('sitemanagement_role');
    const transportID = transportation.map(e => e.id);
    const transportChangeReason = transportation[0]?.reason_of_change || "";


    const transportData = logData.filter(item =>
        transportID.includes(item.object_id)
    );
    const nullGroupItems = transportData.filter(
        item =>
            !item.data?.random_value_of_changes ||
            item.data?.random_value_of_changes === "null" ||
            item.data?.random_value_of_changes.trim() === ""
    );


    const isEotDataTrue = selectedGroup.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );





    const eotLengths = Math.max(
        ...selectedGroup.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );

    const descriptionOption = descriptionData.map((i) => ({
        value: i.id,
        label: i.description_name
    }));

    console.log("descriptionOption", descriptionOption);
    console.log("DESCRIPTIONdATA", descriptionData);


    const [filterDescription, setFilterDescription] = useState("null");

    useEffect(() => {
        if (descriptionOption.length > 0 && filterDescription === "null") {
            setFilterDescription(descriptionOption[descriptionOption.length - 1].value);
        }
    }, [descriptionOption]);

    const handleSelectedDescription = (selectionOption) => {
        if (!selectionOption) {
            setFilterDescription("null");
        }
        else {
            setFilterDescription(selectionOption.value)
        }
    }
    const [data, setData] = useState("");

    useEffect(() => {
        if (!filterDescription || filterDescription === "null") {
            setData("");
        }
        else {
            const filteredData = descriptionData.find((item) => item.id === filterDescription);

            console.log("filteredData", filteredData);
            const descriptionText = filteredData.description_details
            if (filteredData) {
                setData(descriptionText);
            } else {
                setData("");
            }
        }



    }, [filterDescription, descriptionData]);



    // return (
    //     <div className="table-css-background">
    //         <div className='heading-conslt'>
    //             <div className='flex-column'>
    //                 <div>
    //                     <h3 style={{ fontSize: "15px", textAlign: "justify" }}>{projectData?.project_name}</h3>
    //                 </div>
    //                 <div className='flex-row justify-between' style={{ width: "90vw" }}>

    //                     <div className='consultant-heading'>
    //                         <h6>Client Name:{projectData?.client_name}</h6>
    //                         <h6>Consultant (AE):{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</h6>
    //                         <h6>GSTIN No:{projectData?.gst_no}</h6>
    //                         <h6>PAN No:{projectData?.pan_no}</h6>
    //                         <h6>Bid Due Submission Date:{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</h6>
    //                         <div className='flex-row justify-between' style={{ width: "86vw" }}>
    //                             <div>
    //                                 <h6>Agreement Date:{formatDateDD_MM_YYYY(projectData?.agreement_date)}</h6>
    //                                 <h6>Project Start Date:{formatDateDD_MM_YYYY(projectData?.commencement_date)}</h6>
    //                             </div>


    //                         </div>
    //                     </div>

    //                 </div>

    //             </div>
    //             {/* <AddSupportStaff id={id} getSupportStaff={getBreakdownCost}/> */}
    //         </div>
    //         <h2 className="font-size-1-5rem">3. Transportation (Fixed rate on rental basis)</h2>

    //         <div className='heads-div'>

    //             <div style={{ width: "100%" }} className="flex-row hide-on-print justify-end">
    //                 <div>
    //                     {(transportation.length > 0 && transportData.length >= 1) && (
    //                         <select
    //                             value={logid}
    //                             onChange={(e) => setLogId(e.target.value)}
    //                             className="dropdown font-size-subheading navbar-inputt"
    //                         >
    //                             <option value="null">
    //                                 BOQ {groupedByRandomChange.length + 1}- {transportChangeReason}
    //                             </option>

    //                             {groupedByRandomChange.map(([groupKey, items], index) => {
    //                                 const reasons = [...new Set(
    //                                     items
    //                                         .map(i => i.data?.reason_of_change)
    //                                         .filter(reason =>
    //                                             reason !== null &&
    //                                             reason !== "null" &&
    //                                             reason?.trim() !== ""
    //                                         )
    //                                 )];

    //                                 return (
    //                                     <option key={groupKey} value={index}>
    //                                         BOQ {groupedByRandomChange.length - index}
    //                                         {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
    //                                     </option>
    //                                 );
    //                             })}




    //                         </select>
    //                     )}

    //                 </div>

    //                 {role !== "SiteManagement" &&
    //                     <div className=" flex-row">
    //                         <Select
    //                             options={descriptionOption}
    //                             value={
    //                                 filterDescription !== "null"
    //                                     ? descriptionOption.find((item) => item.value === filterDescription)
    //                                     : "null"  // ✅ null instead of "null" - React Select expects null for empty state
    //                             }
    //                             onChange={handleSelectedDescription}
    //                             isClearable
    //                             placeholder="Select Description"
    //                             styles={CSSForFilterDropdown}
    //                         />
    //                         <AddDescription idDescription={idDescription} descriptionList={descriptionData} usedFor="Transportation" descriptionType="BOQTransportation" projectId={id} />

    //                         <TransportationBOQBulk id={id} getTransportation={getTransportation} transportationList={transportation} />
    //                         <BulkUpdateTransportData boqtransportList={selectedGroup} id={id} getData={getTransportation} getLogData={getLogData} />

    //                     </div>
    //                 }
    //             </div>
    //         </div>
    //         <p>
    //             The vehicles provided by the Consultants shall include the cost for rental, drivers, operation, maintenance, repairs, insurance, etc. for all complete approx. 3000km/month run.
    //         </p>
    //         <DescriptionList data={data} />

    //         <table className="nested-table-lightblue">
    //             <thead>
    //                 <tr>
    //                     <th rowSpan="4">Sr.No</th>
    //                     <th rowSpan="4">Description of Vehicles</th>

    //                     <th className='table-heading-text text-center' colSpan="5">Contract Values</th>
    //                     {isEotDataTrue &&

    //                         <th
    //                             className="table-heading-text text-center"
    //                             colSpan={eotLengths * 5 || 1}
    //                         >
    //                             Revised Contract Values (after COS/EOT)
    //                         </th>
    //                     }
    //                     {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                         <th rowSpan="4" className="hide-on-print align-center">Action</th>
    //                     }
    //                 </tr>
    //                 <tr className='nested-heading'>
    //                     <th rowSpan="2" className='table-heading-text'>Const</th>
    //                     <th rowSpan="2" className='table-heading-text'>Maint</th>
    //                     <th rowSpan="2" className='table-heading-text'>Const & Maint</th>
    //                     <th rowSpan="2" className='table-heading-text'>Rate</th>
    //                     <th rowSpan="2" className='table-heading-text'>Total Amount</th>

    //                     {/* Dynamically add EOT headers */}
    //                     {Array.from({ length: eotLengths }).map((_, idx) => (
    //                         <th key={idx} className="table-heading-text text-center" colSpan={5}>
    //                             {`EOT ${idx + 1}`}
    //                         </th>
    //                     ))}

    //                 </tr>
    //                 <tr className='nested-heading'>
    //                     {Array.from({ length: eotLengths }).map((_, idx) => (
    //                         <React.Fragment key={idx}>
    //                             <th rowSpan="2" className='table-heading-text'>Const</th>
    //                             <th rowSpan="2" className='table-heading-text'>Maint</th>
    //                             <th rowSpan="2" className='table-heading-text'>Const & Maint</th>
    //                             <th rowSpan="2" className='table-heading-text'>Rate</th>
    //                             <th rowSpan="2" className='table-heading-text'>Total Amount</th>
    //                         </React.Fragment>
    //                     ))}

    //                 </tr>
    //             </thead>
    //             {buffer ? (
    //                 <div className="spinner-bgdatil"></div>
    //             ) : (
    //                 <>
    //                     <tbody>
    //                         {selectedGroup.map((item, index) => (

    //                             <tr key={item.id}>
    //                                 <td>{index + 1}</td>
    //                                 <td>{item.vehicle_description ?? item.data?.vehicle_description}</td>
    //                                 <td>{item.during_construction_period ?? item.data?.during_construction_period}</td>
    //                                 <td>{item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period}</td>
    //                                 <td>{Number(item.during_construction_period ?? item.data?.during_construction_period) + Number(item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period)}</td>
    //                                 <td className="align-right">₹{formatCurrencyIndian(Number(item.rate ?? item.data?.rate))}</td>

    //                                 <td className="align-right">₹{formatCurrencyIndian(
    //                                     (Number(item.during_construction_period ?? item.data?.during_construction_period) +
    //                                         Number(item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period)) *
    //                                     Number(item.rate ?? item.data?.rate)
    //                                 )}</td>
    //                                 {item.eot_details?.length > 0 ?
    //                                     <>
    //                                         {item.eot_details?.map((i) => (
    //                                             <>
    //                                                 <td className="align-right">{i.cp} </td>
    //                                                 <td className="align-right">{i.dlp} </td>
    //                                                 <td className="align-right">{i.t_month} </td>
    //                                                 <td className="align-right">₹{formatCurrencyIndian(i.rate)} </td>
    //                                                 <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
    //                                             </>
    //                                         ))}
    //                                     </> :
    //                                     <>
    //                                         {item.data?.eot_details?.map((i) => (
    //                                             <>
    //                                                 <td className="align-right">{i.cp} </td>
    //                                                 <td className="align-right">{i.dlp} </td>
    //                                                 <td className="align-right">{i.t_month} </td>
    //                                                 <td className="align-right">₹{formatCurrencyIndian(i.rate)} </td>
    //                                                 <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
    //                                             </>
    //                                         ))}
    //                                     </>
    //                                 }
    //                                 {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                                     <td className="hide-on-print flex-row  border-single">
    //                                         {role === "BD" || role === "Account" ? "" :
    //                                             <DeleteITransportation i={item} getTransportation={getTransportation} />
    //                                         }
    //                                     </td>
    //                                 }
    //                             </tr>
    //                         ))}
    //                     </tbody>
    //                     <tfoot>
    //                         <tr>
    //                             <td colSpan="6" className="total-label">Total:</td>
    //                             <td className="align-right">
    //                                 ₹{formatCurrencyIndian(
    //                                     selectedGroup.reduce((total, item) => {
    //                                         const rate = Number(item.rate ?? item.data?.rate ?? 0);
    //                                         const mmConstruction = Number(item.during_construction_period ?? item.data?.during_construction_period ?? 0);
    //                                         const mmOM = Number(item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period ?? 0);
    //                                         return total + rate * (mmConstruction + mmOM);
    //                                     }, 0)
    //                                 )}
    //                             </td>
    //                             {isEotDataTrue && (
    //                                 <>
    //                                     {Array.from({ length: eotLengths }).map((_, eotIdx) => {
    //                                         // sum this EOT index across all employees
    //                                         const subTotal = selectedGroup.reduce((sum, emp) => {
    //                                             const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
    //                                             const eot = details[eotIdx];
    //                                             return sum + (Number(eot?.total_amount) || 0);
    //                                         }, 0);

    //                                         return (
    //                                             <React.Fragment key={eotIdx}>
    //                                                 <td colSpan="4" className="total-label"></td>
    //                                                 <td className="align-right">
    //                                                     ₹{formatCurrencyIndian(subTotal)}
    //                                                 </td>
    //                                             </React.Fragment>
    //                                         );
    //                                     })}
    //                                 </>
    //                             )}
    //                             {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                                 <td className="hide-on-print"></td>
    //                             }
    //                         </tr>
    //                     </tfoot>
    //                 </>
    //             )}
    //         </table>
    //     </div>
    // );

    return (
        <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>

            <div className="boc-modern-card">

                {/* ===== HEADER SECTION ===== */}
                <div className="boc-modern-header bocx-modern-footer-total">
                    <div className="boc-modern-header-content">
                        <div className="boc-modern-project-info">
                            <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
                            <div className="boc-modern-project-meta">
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Client:</span>
                                    <span className="boc-modern-meta-value">{projectData?.client_name}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Consultant (AE):</span>
                                    <span className="boc-modern-meta-value">
                                        {projectData?.lead}
                                        {projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}
                                        {projectData?.association ? ` Association with ${projectData?.association}` : ""}
                                    </span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">GSTIN:</span>
                                    <span className="boc-modern-meta-value">{projectData?.gst_no}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">PAN:</span>
                                    <span className="boc-modern-meta-value">{projectData?.pan_no}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Bid Due:</span>
                                    <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Agreement:</span>
                                    <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Start:</span>
                                    <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ===== CONTROLS SECTION ===== */}
                <div className="boc-modern-controls-wrapper">
                    <div className="boc-modern-controls">
                        <div className="boc-modern-controls-left">
                            <h3 className="boc-modern-main-heading">3. Transportation (Fixed rate on rental basis)</h3>
                        </div>
                        {role !== "SiteManagement" && (
                            <div className="boc-modern-controls-right justify-end" style={{ width: "100%" }}>
                                <div className="flex-row justify-end" style={{ width: "24%" }}>
                                    {(transportation.length > 0 && transportData.length >= 1) ? (
                                        <div className="boc-modern-control-group">
                                            <label className="boc-modern-control-label">BOQ Version</label>
                                            <select
                                                value={logid}
                                                onChange={(e) => setLogId(e.target.value)}
                                                className="boc-modern-select"
                                            >
                                                <option value="null">
                                                    BOQ {groupedByRandomChange.length + 1}- {transportChangeReason}
                                                </option>
                                                {groupedByRandomChange.map(([groupKey, items], index) => {
                                                    const reasons = [...new Set(
                                                        items
                                                            .map(i => i.data?.reason_of_change)
                                                            .filter(reason =>
                                                                reason !== null &&
                                                                reason !== "null" &&
                                                                reason?.trim() !== ""
                                                            )
                                                    )];
                                                    return (
                                                        <option key={groupKey} value={index}>
                                                            BOQ {groupedByRandomChange.length - index}
                                                            {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    ) : (
                                        <div className="boc-modern-control-group"></div>
                                    )}
                                </div>


                                <div className="boc-modern-action-buttons" style={{ float: "right" }}>
                                    <div className="boc-modern-control-group">
                                        <label className="boc-modern-control-label">Description</label>
                                        <Select
                                            options={descriptionOption}
                                            value={
                                                filterDescription !== "null"
                                                    ? descriptionOption.find((item) => item.value === filterDescription)
                                                    : "null"
                                            }
                                            onChange={handleSelectedDescription}
                                            isClearable
                                            placeholder="Select Description"
                                            styles={CSSForSelectModern15VWWidth}
                                        />
                                    </div>

                                    {logid === "null" && (
                                        <>
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                <AddDescription
                                                    idDescription={idDescription}
                                                    descriptionList={descriptionData}
                                                    usedFor="Transportation"
                                                    descriptionType="BOQTransportation"
                                                    projectId={id}
                                                />
                                            </div>
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                <TransportationBOQBulk
                                                    id={id}
                                                    getTransportation={getTransportation}
                                                    transportationList={transportation}
                                                />
                                            </div>
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                <BulkUpdateTransportData
                                                    boqtransportList={selectedGroup}
                                                    id={id}
                                                    getData={getTransportation}
                                                    getLogData={getLogData}
                                                />
                                            </div>
                                        </>
                                    )}


                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ===== DESCRIPTION SECTION ===== */}
                <div className="boc-modern-description-section" style={{ padding: "10px 10px" }}>
                    <p className="boc-modern-transport-note">
                        The vehicles provided by the Consultants shall include the cost for rental, drivers, operation,
                        maintenance, repairs, insurance, etc. for all complete approx. 3000km/month run.
                    </p>
                    <DescriptionList data={data} />
                </div>

                {/* ===== TABLE SECTION ===== */}
                <div className="boc-modern-table-wrapper">
                    <div className="boc-modern-table-scroll">
                        <table className="boc-modern-table">
                            <thead>
                                <tr className="boc-modern-table-header">
                                    <th className="boc-modern-th text-center" rowSpan="4">Sr.No</th>
                                    <th className="boc-modern-th text-center" rowSpan="4">Description of Vehicles</th>
                                    <th className="boc-modern-th text-center" colSpan="5">Contract Values</th>
                                    {isEotDataTrue && (
                                        <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>
                                            Revised Contract Values (after COS/EOT)
                                        </th>
                                    )}
                                    {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                        <th className="boc-modern-th text-center" rowSpan="4">Action</th>
                                    )}
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    <th rowSpan="2" className="boc-modern-th">Const</th>
                                    <th rowSpan="2" className="boc-modern-th">Maint</th>
                                    <th rowSpan="2" className="boc-modern-th">Const & Maint</th>
                                    <th rowSpan="2" className="boc-modern-th">Rate</th>
                                    <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <th key={idx} className="boc-modern-th text-center" colSpan={5}>
                                            {`EOT ${idx + 1}`}
                                        </th>
                                    ))}
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <React.Fragment key={idx}>
                                            <th rowSpan="2" className="boc-modern-th">Const</th>
                                            <th rowSpan="2" className="boc-modern-th">Maint</th>
                                            <th rowSpan="2" className="boc-modern-th">Const & Maint</th>
                                            <th rowSpan="2" className="boc-modern-th">Rate</th>
                                            <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>
                            {buffer ? (
                                <tbody>
                                    <tr>
                                        <td colSpan="20">
                                            <div className="boc-modern-loading">
                                                <div className="boc-modern-spinner"></div>
                                                <span>Loading data...</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            ) : (
                                <>
                                    <tbody>
                                        {selectedGroup.map((item, index) => (
                                            <tr key={item.id} className="boc-modern-row">
                                                <td className="boc-modern-td text-center">{index + 1}</td>
                                                <td className="boc-modern-td">{item.vehicle_description ?? item.data?.vehicle_description}</td>
                                                <td className="boc-modern-td text-right">
                                                    {item.during_construction_period ?? item.data?.during_construction_period}
                                                </td>
                                                <td className="boc-modern-td text-right">
                                                    {item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period}
                                                </td>
                                                <td className="boc-modern-td text-right">
                                                    {Number(item.during_construction_period ?? item.data?.during_construction_period) +
                                                        Number(item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period)}
                                                </td>
                                                <td className="boc-modern-td text-right boc-modern-currency">
                                                    ₹{formatCurrencyIndian(Number(item.rate ?? item.data?.rate))}
                                                </td>
                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-total-highlight">
                                                    ₹{formatCurrencyIndian(
                                                        (Number(item.during_construction_period ?? item.data?.during_construction_period) +
                                                            Number(item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period)) *
                                                        Number(item.rate ?? item.data?.rate)
                                                    )}
                                                </td>
                                                {item?.eot_details?.length > 0 ? (
                                                    item.eot_details.map((eot, i) => (
                                                        <React.Fragment key={i}>
                                                            <td className="boc-modern-td text-right">{eot.cp}</td>
                                                            <td className="boc-modern-td text-right">{eot.dlp}</td>
                                                            <td className="boc-modern-td text-right">{eot.t_month}</td>
                                                            <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(eot.rate)}</td>
                                                            <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(eot.total_amount)}</td>
                                                        </React.Fragment>
                                                    ))
                                                ) : (
                                                    item.data?.eot_details?.map((eot, i) => (
                                                        <React.Fragment key={i}>
                                                            <td className="boc-modern-td text-right">{eot.cp}</td>
                                                            <td className="boc-modern-td text-right">{eot.dlp}</td>
                                                            <td className="boc-modern-td text-right">{eot.t_month}</td>
                                                            <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(eot.rate)}</td>
                                                            <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(eot.total_amount)}</td>
                                                        </React.Fragment>
                                                    ))
                                                )}
                                                {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                    <td className="boc-modern-td text-center">
                                                        {role !== "BD" && role !== "Account" && (
                                                            <DeleteITransportation i={item} getTransportation={getTransportation} />
                                                        )}
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr className="boc-modern-footer">
                                            <td colSpan="6" className="boc-modern-footer-label">Total:</td>
                                            <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(
                                                    selectedGroup.reduce((total, item) => {
                                                        const rate = Number(item.rate ?? item.data?.rate ?? 0);
                                                        const mmConstruction = Number(item.during_construction_period ?? item.data?.during_construction_period ?? 0);
                                                        const mmOM = Number(item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period ?? 0);
                                                        return total + rate * (mmConstruction + mmOM);
                                                    }, 0)
                                                )}
                                            </td>
                                            {isEotDataTrue && (
                                                <>
                                                    {Array.from({ length: eotLengths }).map((_, eotIdx) => {
                                                        const subTotal = selectedGroup.reduce((sum, emp) => {
                                                            const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                                                            const eot = details[eotIdx];
                                                            return sum + (Number(eot?.total_amount) || 0);
                                                        }, 0);
                                                        return (
                                                            <React.Fragment key={eotIdx}>
                                                                <td colSpan="4" className="boc-modern-footer-label"></td>
                                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                                    ₹{formatCurrencyIndian(subTotal)}
                                                                </td>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </>
                                            )}
                                            {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                <td className="boc-modern-td"></td>
                                            )}
                                        </tr>
                                    </tfoot>
                                </>
                            )}
                        </table>
                    </div>
                </div>

            </div>
        </div>
    );
};


const DutyTravel = ({ idDescription, descriptionData, projectData, props, id, dutyTravel, getDutyTravel, logData, getLogData, logid, setLogId, groupedByRandomChange, selectedGroup, buffer }) => {

    const role = sessionStorage.getItem('sitemanagement_role');

    const dutyTravelID = dutyTravel.map(e => e.id);
    const dutyChangeReason = dutyTravel[0]?.reason_of_change || "";


    const dutyTravelData = logData.filter(item =>
        dutyTravelID.includes(item.object_id)
    );

    const isEotDataTrue = selectedGroup.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );





    const eotLengths = Math.max(
        ...selectedGroup.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );


    const descriptionOption = descriptionData.map((i) => ({
        value: i.id,
        label: i.description_name
    }));


    const [filterDescription, setFilterDescription] = useState("null");

    useEffect(() => {
        if (descriptionOption.length > 0 && filterDescription === "null") {
            setFilterDescription(descriptionOption[descriptionOption.length - 1].value);
        }
    }, [descriptionOption]);

    const handleSelectedDescription = (selectionOption) => {
        if (!selectionOption) {
            setFilterDescription("null");
        }
        else {
            setFilterDescription(selectionOption.value)
        }
    }
    const [data, setData] = useState("");

    useEffect(() => {
        if (!filterDescription || filterDescription === "null") {
            setData("");
        }
        else {
            const filteredData = descriptionData.find((item) => item.id === filterDescription);

            console.log("filteredData", filteredData);
            const descriptionText = filteredData.description_details
            if (filteredData) {
                setData(descriptionText);
            } else {
                setData("");
            }
        }



    }, [filterDescription, descriptionData]);


    // return (
    //     <>
    //         <div className="table-css-background ">
    //             <div className='heading-conslt'>
    //                 <div className='flex-column'>
    //                     <div>
    //                         <h3 style={{ fontSize: "15px", textAlign: "justify" }}>{projectData?.project_name}</h3>
    //                     </div>
    //                     <div className='flex-row justify-between' style={{ width: "90vw" }}>

    //                         <div className='consultant-heading'>
    //                             <h6>Client Name:{projectData?.client_name}</h6>
    //                             <h6>Consultant (AE):{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</h6>
    //                             <h6>GSTIN No:{projectData?.gst_no}</h6>
    //                             <h6>PAN No:{projectData?.pan_no}</h6>
    //                             <h6>Bid Due Submission Date:{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</h6>
    //                             <div className='flex-row justify-between' style={{ width: "86vw" }}>
    //                                 <div>
    //                                     <h6>Agreement Date:{formatDateDD_MM_YYYY(projectData?.agreement_date)}</h6>
    //                                     <h6>Project Start Date:{formatDateDD_MM_YYYY(projectData?.commencement_date)}</h6>
    //                                 </div>


    //                             </div>
    //                         </div>

    //                     </div>

    //                 </div>
    //                 {/* <AddSupportStaff id={id} getSupportStaff={getBreakdownCost}/> */}
    //             </div>
    //             <h2 className="font-size-1-5rem">4. Duty Travel to Site (Fixed Costs) (For all Lengths of projects):</h2>
    //             <p>Professional and Sub-Professional Staff</p>
    //             <div className='heads-div'>

    //                 <div style={{ width: "100%" }} className="flex-row justify-end hide-on-print">

    //                     <div>
    //                         {(dutyTravel.length > 0 && dutyTravelData.length >= 1) && (
    //                             <select
    //                                 value={logid}
    //                                 onChange={(e) => setLogId(e.target.value)}
    //                                 className="dropdown font-size-subheading navbar-inputt"
    //                             >
    //                                 <option value="null">
    //                                     BOQ {groupedByRandomChange.length + 1}- {dutyChangeReason}
    //                                 </option>

    //                                 {groupedByRandomChange.map(([groupKey, items], index) => {
    //                                     const reasons = [...new Set(
    //                                         items
    //                                             .map(i => i.data?.reason_of_change)
    //                                             .filter(reason =>
    //                                                 reason !== null &&
    //                                                 reason !== "null" &&
    //                                                 reason?.trim() !== ""
    //                                             )
    //                                     )];

    //                                     return (
    //                                         <option key={groupKey} value={index}>
    //                                             BOQ {groupedByRandomChange.length - index}
    //                                             {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
    //                                         </option>
    //                                     );
    //                                 })}




    //                             </select>
    //                         )}
    //                     </div>
    //                     {role !== "SiteManagement" &&


    //                         <div className="hide-on-print flex-row">
    //                             <Select
    //                                 options={descriptionOption}
    //                                 value={
    //                                     filterDescription !== "null"
    //                                         ? descriptionOption.find((item) => item.value === filterDescription)
    //                                         : "null"  // ✅ null instead of "null" - React Select expects null for empty state
    //                                 }
    //                                 onChange={handleSelectedDescription}
    //                                 isClearable
    //                                 placeholder="Select Description"
    //                                 styles={CSSForFilterDropdown}
    //                             />
    //                             <AddDescription idDescription={idDescription} descriptionList={descriptionData} usedFor="DutyTravel" descriptionType="BOQDutyTravel" projectId={id} />

    //                             <AddDutyTravel id={id} getDutyTravel={getDutyTravel} dutytravelList={dutyTravel} />
    //                             <BulkUpdateutyTravelData boqDutyTravelList={selectedGroup} id={id} getData={getDutyTravel} getLogData={getLogData} />

    //                         </div>
    //                     }
    //                 </div>
    //                 <p></p>
    //             </div>
    //             <DescriptionList data={data} />

    //             <table className="nested-table-lightblue">
    //                 <thead>

    //                     <tr className='theading'>
    //                         <th className='table-heading-text text-center' rowSpan="4">Sr.No</th>
    //                         <th className='table-heading-text text-center' rowSpan="4">Description of Trips</th>
    //                         <th className='table-heading-text text-center' colSpan="3">Contract Values</th>
    //                         {isEotDataTrue &&

    //                             <th
    //                                 className="table-heading-text text-center"
    //                                 colSpan={eotLengths * 3 || 1}
    //                             >
    //                                 Revised Contract Values (after COS/EOT)
    //                             </th>
    //                         }


    //                         {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                             <th className="hide-on-print align-center" rowSpan="4">Action</th>
    //                         }
    //                     </tr>
    //                     <tr className='nested-heading'>
    //                         <th rowSpan="2" className='table-heading-text'>Total Trips</th>
    //                         <th rowSpan="2" className='table-heading-text'>Rate per trip (Rs.)</th>
    //                         <th rowSpan="2" className='table-heading-text'>Total Amount (Rs.)</th>
    //                         {/* Dynamically add EOT headers */}
    //                         {Array.from({ length: eotLengths }).map((_, idx) => (
    //                             <th key={idx} className="table-heading-text text-center" colSpan={3}>
    //                                 {`EOT ${idx + 1}`}
    //                             </th>
    //                         ))}

    //                     </tr>
    //                     <tr className='nested-heading'>
    //                         {Array.from({ length: eotLengths }).map((_, idx) => (
    //                             <React.Fragment key={idx}>
    //                                 <th rowSpan="2" className='table-heading-text'>Total Trips</th>
    //                                 <th rowSpan="2" className='table-heading-text'>Rate per trip (Rs.)</th>
    //                                 <th rowSpan="2" className='table-heading-text'>Total Amount (Rs.)</th>
    //                             </React.Fragment>
    //                         ))}

    //                     </tr>

    //                 </thead>
    //                 {buffer ? (
    //                     <div className="spinner-bgdatil"></div>
    //                 ) : (
    //                     <>
    //                         <tbody>
    //                             {selectedGroup.map((item, index) => (
    //                                 <tr key={item.id}>
    //                                     <td>{index + 1}</td>
    //                                     <td>{item.trips ?? item.data?.trips}</td>
    //                                     <td>{item.num_of_min_trip ?? item.data?.num_of_min_trip}</td>
    //                                     <td className="align-right">₹{formatCurrencyIndian(Number(item.rate_per_trip ?? item.data?.rate_per_trip))}</td>
    //                                     <td className="align-right">₹{formatCurrencyIndian(
    //                                         (Number(item.num_of_min_trip ?? item.data?.num_of_min_trip) * Number(item.rate_per_trip ?? item.data?.rate_per_trip)
    //                                         ))}</td>

    //                                     {item.eot_details?.length > 0 ?
    //                                         <>
    //                                             {item.eot_details?.map((i) => (
    //                                                 <>
    //                                                     <td className="align-right">{i.t_trips} </td>
    //                                                     <td className="align-right">₹{formatCurrencyIndian(i.rate)} </td>
    //                                                     <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
    //                                                 </>
    //                                             ))}
    //                                         </> :
    //                                         <>
    //                                             {item.data?.eot_details?.map((i) => (
    //                                                 <>
    //                                                     <td className="align-right">{i.t_trips} </td>
    //                                                     <td className="align-right">₹{formatCurrencyIndian(i.rate)} </td>
    //                                                     <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
    //                                                 </>
    //                                             ))}
    //                                         </>
    //                                     }
    //                                     {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                                         <td className="hide-on-print flex-row  border-single justify-center">
    //                                             {role === "BD" || role === "Account" ? "" :
    //                                                 <DeleteIDutyTravel i={item} getDutyTravel={getDutyTravel} />
    //                                             }
    //                                         </td>
    //                                     }
    //                                 </tr>
    //                             ))}
    //                         </tbody>
    //                         <tfoot>
    //                             <tr>
    //                                 <td colSpan="4" className="total-label">Total</td>
    //                                 <td className="align-right">
    //                                     ₹{formatCurrencyIndian(
    //                                         selectedGroup.reduce((total, item) => {
    //                                             const rate = Number(item.rate_per_trip ?? item.data?.rate_per_trip ?? 0);
    //                                             const totalTrips = Number(item.num_of_min_trip ?? item.data?.num_of_min_trip ?? 0);
    //                                             return total + (rate * totalTrips);
    //                                         }, 0)
    //                                     )}

    //                                 </td>
    //                                 {isEotDataTrue && (
    //                                     <>
    //                                         {Array.from({ length: eotLengths }).map((_, eotIdx) => {
    //                                             // sum this EOT index across all employees
    //                                             const subTotal = selectedGroup.reduce((sum, emp) => {
    //                                                 const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
    //                                                 const eot = details[eotIdx];
    //                                                 return sum + (Number(eot?.total_amount) || 0);
    //                                             }, 0);

    //                                             return (
    //                                                 <React.Fragment key={eotIdx}>
    //                                                     <td colSpan="2" className="total-label"></td>
    //                                                     <td className="align-right">
    //                                                         ₹{formatCurrencyIndian(subTotal)}
    //                                                     </td>
    //                                                 </React.Fragment>
    //                                             );
    //                                         })}
    //                                     </>
    //                                 )}

    //                                 {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                                     <td className="hide-on-print"></td>
    //                                 }
    //                             </tr>
    //                         </tfoot>
    //                     </>
    //                 )}
    //             </table>
    //             <p className="note">
    //                 * Rate quoted includes Hotel charges, travel cost etc. complete.
    //             </p>
    //         </div>
    //     </>
    // );

    return (
        <>
            <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>

                <div className="boc-modern-card">

                    {/* ===== HEADER SECTION ===== */}
                    <div className="boc-modern-header bocx-modern-footer-total">
                        <div className="boc-modern-header-content">
                            <div className="boc-modern-project-info">
                                <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
                                <div className="boc-modern-project-meta">
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Client:</span>
                                        <span className="boc-modern-meta-value">{projectData?.client_name}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Consultant (AE):</span>
                                        <span className="boc-modern-meta-value">
                                            {projectData?.lead}
                                            {projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}
                                            {projectData?.association ? ` Association with ${projectData?.association}` : ""}
                                        </span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">GSTIN:</span>
                                        <span className="boc-modern-meta-value">{projectData?.gst_no}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">PAN:</span>
                                        <span className="boc-modern-meta-value">{projectData?.pan_no}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Bid Due:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Agreement:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Start:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ===== CONTROLS SECTION ===== */}
                    <div className="boc-modern-controls-wrapper">
                        <div className="boc-modern-controls">
                            <div className="boc-modern-controls-left">
                                <h3 className="boc-modern-main-heading">4. Duty Travel to Site (Fixed Costs) (For all Lengths of projects):</h3>
                            </div>
                            {role !== "SiteManagement" && (
                                <div className="boc-modern-controls-right justify-end" style={{ width: "100%" }}>
                                    <div className="flex-row justify-end" style={{ width: "24%" }}>
                                        {(dutyTravel.length > 0 && dutyTravelData.length >= 1) ? (
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label">BOQ Version</label>
                                                <select
                                                    value={logid}
                                                    onChange={(e) => setLogId(e.target.value)}
                                                    className="boc-modern-select"
                                                >
                                                    <option value="null">
                                                        BOQ {groupedByRandomChange.length + 1}- {dutyChangeReason}
                                                    </option>
                                                    {groupedByRandomChange.map(([groupKey, items], index) => {
                                                        const reasons = [...new Set(
                                                            items
                                                                .map(i => i.data?.reason_of_change)
                                                                .filter(reason =>
                                                                    reason !== null &&
                                                                    reason !== "null" &&
                                                                    reason?.trim() !== ""
                                                                )
                                                        )];
                                                        return (
                                                            <option key={groupKey} value={index}>
                                                                BOQ {groupedByRandomChange.length - index}
                                                                {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        ) : (
                                            <div className="boc-modern-control-group"></div>
                                        )}
                                    </div>

                                    <div className="boc-modern-action-buttons" style={{ float: "right" }}>
                                        <div className="boc-modern-control-group">
                                            <label className="boc-modern-control-label">Description</label>
                                            <Select
                                                options={descriptionOption}
                                                value={
                                                    filterDescription !== "null"
                                                        ? descriptionOption.find((item) => item.value === filterDescription)
                                                        : "null"
                                                }
                                                onChange={handleSelectedDescription}
                                                isClearable
                                                placeholder="Select Description"
                                                styles={CSSForSelectModern15VWWidth}
                                            />
                                        </div>

                                        {logid === "null" && (
                                            <>
                                                <div className="boc-modern-control-group">
                                                    <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                    <AddDescription
                                                        idDescription={idDescription}
                                                        descriptionList={descriptionData}
                                                        usedFor="DutyTravel"
                                                        descriptionType="BOQDutyTravel"
                                                        projectId={id}
                                                    />
                                                </div>
                                                <div className="boc-modern-control-group">
                                                    <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                    <AddDutyTravel id={id} getDutyTravel={getDutyTravel} dutytravelList={dutyTravel} />
                                                </div>
                                                <div className="boc-modern-control-group">
                                                    <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                    <BulkUpdateutyTravelData
                                                        boqDutyTravelList={selectedGroup}
                                                        id={id}
                                                        getData={getDutyTravel}
                                                        getLogData={getLogData}
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* ===== DESCRIPTION SECTION ===== */}
                    <div className="boc-modern-description-section" style={{ padding: "10px 10px" }}>
                        <p className="boc-modern-transport-note">
                            Professional and Sub-Professional Staff
                        </p>
                        <DescriptionList data={data} />
                    </div>

                    {/* ===== TABLE SECTION ===== */}
                    <div className="boc-modern-table-wrapper">
                        <div className="boc-modern-table-scroll">
                            <table className="boc-modern-table">
                                <thead>
                                    <tr className="boc-modern-table-header">
                                        <th className="boc-modern-th text-center" rowSpan="4">Sr.No</th>
                                        <th className="boc-modern-th text-center" rowSpan="4">Description of Trips</th>
                                        <th className="boc-modern-th text-center" colSpan="3">Contract Values</th>
                                        {isEotDataTrue && (
                                            <th className="boc-modern-th text-center" colSpan={eotLengths * 3 || 1}>
                                                Revised Contract Values (after COS/EOT)
                                            </th>
                                        )}
                                        {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                            <th className="boc-modern-th text-center" rowSpan="4">Action</th>
                                        )}
                                    </tr>
                                    <tr className="boc-modern-table-subheader">
                                        <th rowSpan="2" className="boc-modern-th">Total Trips</th>
                                        <th rowSpan="2" className="boc-modern-th">Rate per trip (Rs.)</th>
                                        <th rowSpan="2" className="boc-modern-th">Total Amount (Rs.)</th>
                                        {Array.from({ length: eotLengths }).map((_, idx) => (
                                            <th key={idx} className="boc-modern-th text-center" colSpan={3}>
                                                {`EOT ${idx + 1}`}
                                            </th>
                                        ))}
                                    </tr>
                                    <tr className="boc-modern-table-subheader">
                                        {Array.from({ length: eotLengths }).map((_, idx) => (
                                            <React.Fragment key={idx}>
                                                <th rowSpan="2" className="boc-modern-th">Total Trips</th>
                                                <th rowSpan="2" className="boc-modern-th">Rate per trip (Rs.)</th>
                                                <th rowSpan="2" className="boc-modern-th">Total Amount (Rs.)</th>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                </thead>
                                {buffer ? (
                                    <tbody>
                                        <tr>
                                            <td colSpan="20">
                                                <div className="boc-modern-loading">
                                                    <div className="boc-modern-spinner"></div>
                                                    <span>Loading data...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                ) : (
                                    <>
                                        <tbody>
                                            {selectedGroup.map((item, index) => (
                                                <tr key={item.id} className="boc-modern-row">
                                                    <td className="boc-modern-td text-center">{index + 1}</td>
                                                    <td className="boc-modern-td">{item.trips ?? item.data?.trips}</td>
                                                    <td className="boc-modern-td text-right">
                                                        {item.num_of_min_trip ?? item.data?.num_of_min_trip}
                                                    </td>
                                                    <td className="boc-modern-td text-right boc-modern-currency">
                                                        ₹{formatCurrencyIndian(Number(item.rate_per_trip ?? item.data?.rate_per_trip))}
                                                    </td>
                                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-total-highlight">
                                                        ₹{formatCurrencyIndian(
                                                            Number(item.num_of_min_trip ?? item.data?.num_of_min_trip) *
                                                            Number(item.rate_per_trip ?? item.data?.rate_per_trip)
                                                        )}
                                                    </td>
                                                    {item.eot_details?.length > 0 ? (
                                                        item.eot_details.map((i, idx) => (
                                                            <React.Fragment key={idx}>
                                                                <td className="boc-modern-td text-right">{i.t_trips}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(i.rate)}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(i.total_amount)}</td>
                                                            </React.Fragment>
                                                        ))
                                                    ) : (
                                                        item.data?.eot_details?.map((i, idx) => (
                                                            <React.Fragment key={idx}>
                                                                <td className="boc-modern-td text-right">{i.t_trips}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(i.rate)}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(i.total_amount)}</td>
                                                            </React.Fragment>
                                                        ))
                                                    )}
                                                    {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                        <td className="boc-modern-td text-center">
                                                            {role !== "BD" && role !== "Account" && (
                                                                <DeleteIDutyTravel i={item} getDutyTravel={getDutyTravel} />
                                                            )}
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr className="boc-modern-footer">
                                                <td colSpan="4" className="boc-modern-footer-label">Total</td>
                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                    ₹{formatCurrencyIndian(
                                                        selectedGroup.reduce((total, item) => {
                                                            const rate = Number(item.rate_per_trip ?? item.data?.rate_per_trip ?? 0);
                                                            const totalTrips = Number(item.num_of_min_trip ?? item.data?.num_of_min_trip ?? 0);
                                                            return total + (rate * totalTrips);
                                                        }, 0)
                                                    )}
                                                </td>
                                                {isEotDataTrue && (
                                                    <>
                                                        {Array.from({ length: eotLengths }).map((_, eotIdx) => {
                                                            const subTotal = selectedGroup.reduce((sum, emp) => {
                                                                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                                                                const eot = details[eotIdx];
                                                                return sum + (Number(eot?.total_amount) || 0);
                                                            }, 0);
                                                            return (
                                                                <React.Fragment key={eotIdx}>
                                                                    <td colSpan="2" className="boc-modern-footer-label"></td>
                                                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                                        ₹{formatCurrencyIndian(subTotal)}
                                                                    </td>
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </>
                                                )}
                                                {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                    <td className="boc-modern-td"></td>
                                                )}
                                            </tr>
                                        </tfoot>
                                    </>
                                )}
                            </table>
                        </div>
                    </div>

                    <p className="note">
                        * Rate quoted includes Hotel charges, travel cost etc. complete.
                    </p>

                </div>
            </div>
        </>
    );

};



// const OfficeRent = ({ idDescription, descriptionData, projectData, props, id, getOfficeRent, officeRent, logData, getLogData, logid, setLogId, groupedByRandomChange, selectedGroup, buffer }) => {

//     const role = sessionStorage.getItem('sitemanagement_role');

//     const officeRentId = officeRent.map(e => e.id);
//     const rentChangeReason = officeRent[0]?.reason_of_change || "";


//     const officeRentData = logData.filter(item =>
//         officeRentId.includes(item.object_id)
//     );

//     const isEotDataTrue = selectedGroup.some(i =>
//         (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
//     );





//     const eotLengths = Math.max(
//         ...selectedGroup.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
//         0
//     );

//     const descriptionOption = descriptionData.map((i) => ({
//         value: i.id,
//         label: i.description_name
//     }));


//     const [filterDescription, setFilterDescription] = useState("null");

//     useEffect(() => {
//         if (descriptionOption.length > 0 && filterDescription === "null") {
//             setFilterDescription(descriptionOption[descriptionOption.length - 1].value);
//         }
//     }, [descriptionOption]);

//     const handleSelectedDescription = (selectionOption) => {
//         if (!selectionOption) {
//             setFilterDescription("null");
//         }
//         else {
//             setFilterDescription(selectionOption.value)
//         }
//     }
//     const [data, setData] = useState("");

//     useEffect(() => {
//         if (!filterDescription || filterDescription === "null") {
//             setData("");
//         }
//         else {
//             const filteredData = descriptionData.find((item) => item.id === filterDescription);

//             console.log("filteredData", filteredData);
//             const descriptionText = filteredData.description_details
//             if (filteredData) {
//                 setData(descriptionText);
//             } else {
//                 setData("");
//             }
//         }



//     }, [filterDescription, descriptionData]);

//     return (
//         <div className="table-css-background">
//             <div className='heading-conslt'>
//                 <div className='flex-column'>
//                     <div>
//                         <h3 style={{ fontSize: "15px", textAlign: "justify" }}>{projectData?.project_name}</h3>
//                     </div>
//                     <div className='flex-row justify-between' style={{ width: "90vw" }}>

//                         <div className='consultant-heading'>
//                             <h6>Client Name:{projectData?.client_name}</h6>
//                             <h6>Consultant (AE):{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</h6>
//                             <h6>GSTIN No:{projectData?.gst_no}</h6>
//                             <h6>PAN No:{projectData?.pan_no}</h6>
//                             <h6>Bid Due Submission Date:{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</h6>
//                             <div className='flex-row justify-between' style={{ width: "86vw" }}>
//                                 <div>
//                                     <h6>Agreement Date:{formatDateDD_MM_YYYY(projectData?.agreement_date)}</h6>
//                                     <h6>Project Start Date:{formatDateDD_MM_YYYY(projectData?.commencement_date)}</h6>
//                                 </div>


//                             </div>
//                         </div>

//                     </div>

//                 </div>
//                 {/* <AddSupportStaff id={id} getSupportStaff={getBreakdownCost}/> */}
//             </div>
//             <div style={{ width: "50%" }}>
//                 <h2 className="font-size-1-5rem">5. Office Rent (Fixed Costs)</h2>
//                 <p>
//                     (Minimum 200 sqm area of office shall be rented. The rent cost includes electricity and water charges, maintenance, cleaning, repairs, etc. complete.)
//                 </p>
//             </div>
//             <div className='heads-div'>

//                 <div style={{ width: "100%" }} className="flex-row justify-end hide-on-print">

//                     <div>
//                         {(officeRent.length > 0 && officeRentData.length >= 1) && (
//                             <select
//                                 value={logid}
//                                 onChange={(e) => setLogId(e.target.value)}
//                                 className="dropdown font-size-subheading navbar-inputt"
//                             >
//                                 <option value="null">
//                                     BOQ {groupedByRandomChange.length + 1}- {rentChangeReason}
//                                 </option>

//                                 {groupedByRandomChange.map(([groupKey, items], index) => {
//                                     const reasons = [...new Set(
//                                         items
//                                             .map(i => i.data?.reason_of_change)
//                                             .filter(reason =>
//                                                 reason !== null &&
//                                                 reason !== "null" &&
//                                                 reason?.trim() !== ""
//                                             )
//                                     )];

//                                     return (
//                                         <option key={groupKey} value={index}>
//                                             BOQ {groupedByRandomChange.length - index}
//                                             {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
//                                         </option>
//                                     );
//                                 })}




//                             </select>
//                         )}
//                     </div>
//                     {role !== "SiteManagement" &&
//                         <div className="hide-on-print flex-row">
//                             <Select
//                                 options={descriptionOption}
//                                 value={
//                                     filterDescription !== "null"
//                                         ? descriptionOption.find((item) => item.value === filterDescription)
//                                         : "null"  // ✅ null instead of "null" - React Select expects null for empty state
//                                 }
//                                 onChange={handleSelectedDescription}
//                                 isClearable
//                                 placeholder="Select Description"
//                                 styles={CSSForFilterDropdown}
//                             />
//                             <AddDescription idDescription={idDescription} descriptionList={descriptionData} usedFor="Office Rent" descriptionType="BOQOfficeRent" projectId={id} />

//                             <AddOfficeRent id={id} getOfficeRent={getOfficeRent} officeRentList={officeRent} />
//                             <BulkUpdateOfficeRentData boqOfficeRentList={selectedGroup} id={id} getData={getOfficeRent} getLogData={getLogData} />

//                         </div>
//                     }
//                 </div>
//             </div>
//             <DescriptionList data={data} />

//             <table className="nested-table-lightblue">
//                 <thead>
//                     <tr className='theading'>
//                         <th className='table-heading-text text-center' rowSpan="4">Sr.No</th>
//                         <th className='table-heading-text text-center' colSpan="5">Contract Values</th>
//                         {isEotDataTrue &&

//                             <th
//                                 className="table-heading-text text-center"
//                                 colSpan={eotLengths * 5 || 1}
//                             >
//                                 Revised Contract Values (after COS/EOT)
//                             </th>
//                         }

//                         {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
//                             <th className="hide-on-print align-center" rowSpan="4">Action</th>
//                         }
//                     </tr>
//                     <tr className='nested-heading'>
//                         <th rowSpan="2" className='table-heading-text'>Const</th>
//                         <th rowSpan="2" className='table-heading-text'>Maint</th>
//                         <th rowSpan="2" className='table-heading-text'>Const & Maint</th>
//                         <th rowSpan="2" className='table-heading-text'>Rate</th>
//                         <th rowSpan="2" className='table-heading-text'>Total Amount</th>

//                         {/* Dynamically add EOT headers */}
//                         {Array.from({ length: eotLengths }).map((_, idx) => (
//                             <th key={idx} className="table-heading-text text-center" colSpan={5}>
//                                 {`EOT ${idx + 1}`}
//                             </th>
//                         ))}

//                     </tr>

//                     <tr className='nested-heading'>
//                         {Array.from({ length: eotLengths }).map((_, idx) => (
//                             <React.Fragment key={idx}>
//                                 <th rowSpan="2" className='table-heading-text'>Const</th>
//                                 <th rowSpan="2" className='table-heading-text'>Maint</th>
//                                 <th rowSpan="2" className='table-heading-text'>Const & Maint</th>
//                                 <th rowSpan="2" className='table-heading-text'>Rate</th>
//                                 <th rowSpan="2" className='table-heading-text'>Total Amount</th>
//                             </React.Fragment>
//                         ))}

//                     </tr>
//                     {/* <div className='pre-heading'>
//                         A. Key Personal
//                     </div> */}
//                 </thead>

//                 {buffer ? (
//                     <div className="spinner-bgdatil"></div>
//                 ) : (
//                     <>
//                         <tbody>
//                             {selectedGroup.map((item, index) => (
//                                 <tr key={item.id}>
//                                     <td>{index + 1}</td>
//                                     <td>{item.during_construction_period ?? item.data?.during_construction_period}</td>
//                                     <td>{item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period}</td>
//                                     <td>{item.num_of_months ?? item.data?.num_of_months}</td>
//                                     <td className="align-right">₹{formatCurrencyIndian(Number(item.rate_per_month ?? item.data?.rate_per_month))}</td>
//                                     <td className="align-right">₹{formatCurrencyIndian(
//                                         (Number(item.num_of_months ?? item.data?.num_of_months) * Number(item.rate_per_month ?? item.data?.rate_per_month)
//                                         ))}</td>
//                                     {item.eot_details?.length > 0 ?
//                                         <>
//                                             {item.eot_details?.map((i) => (
//                                                 <>
//                                                     <td className="align-right">{i.cp} </td>
//                                                     <td className="align-right">{i.dlp} </td>
//                                                     <td className="align-right">{i.t_month} </td>
//                                                     <td className="align-right">₹{formatCurrencyIndian(i.rate)} </td>
//                                                     <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
//                                                 </>
//                                             ))}
//                                         </> :
//                                         <>
//                                             {item.data?.eot_details?.map((i) => (
//                                                 <>
//                                                     <td className="align-right">{i.cp} </td>
//                                                     <td className="align-right">{i.dlp} </td>
//                                                     <td className="align-right">{i.t_month} </td>
//                                                     <td className="align-right">₹{formatCurrencyIndian(i.rate)} </td>
//                                                     <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
//                                                 </>
//                                             ))}
//                                         </>
//                                     }
//                                     {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
//                                         <td className="hide-on-print flex-row border-single justify-center">
//                                             {role === "BD" || role === "Account" ? "" :
//                                                 <DeleteOfficeRent i={item} getOfficeRent={getOfficeRent} />
//                                             }
//                                         </td>
//                                     }
//                                 </tr>
//                             ))}
//                         </tbody>
//                         <tfoot>
//                             <tr>
//                                 <td colSpan="5" className="total-label">Total:</td>
//                                 <td className="align-right">
//                                     ₹{formatCurrencyIndian(
//                                         selectedGroup.reduce((total, item) => {
//                                             const rate = Number(item.rate_per_month ?? item.data?.rate_per_month ?? 0);
//                                             const months = Number(item.num_of_months ?? item.data?.num_of_months ?? 0);
//                                             return total + (rate * months);
//                                         }, 0)
//                                     )}
//                                 </td>
//                                 {isEotDataTrue && (
//                                     <>
//                                         {Array.from({ length: eotLengths }).map((_, eotIdx) => {
//                                             // sum this EOT index across all employees
//                                             const subTotal = selectedGroup.reduce((sum, emp) => {
//                                                 const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
//                                                 const eot = details[eotIdx];
//                                                 return sum + (Number(eot?.total_amount) || 0);
//                                             }, 0);

//                                             return (
//                                                 <React.Fragment key={eotIdx}>
//                                                     <td colSpan="4" className="total-label"></td>
//                                                     <td className="align-right">
//                                                         ₹{formatCurrencyIndian(subTotal)}
//                                                     </td>
//                                                 </React.Fragment>
//                                             );
//                                         })}
//                                     </>
//                                 )}
//                                 {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
//                                     <td className="hide-on-print"></td>
//                                 }
//                             </tr>
//                         </tfoot>
//                     </>
//                 )}
//             </table>
//         </div>
//     );
// };

const OfficeRent = ({ idDescription, descriptionData, projectData, props, id, getOfficeRent, officeRent, logData, getLogData, logid, setLogId, groupedByRandomChange, selectedGroup, buffer }) => {

    const role = sessionStorage.getItem('sitemanagement_role');

    const officeRentId = officeRent.map(e => e.id);
    const rentChangeReason = officeRent[0]?.reason_of_change || "";

    const officeRentData = logData.filter(item =>
        officeRentId.includes(item.object_id)
    );

    const isEotDataTrue = selectedGroup.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );

    const eotLengths = Math.max(
        ...selectedGroup.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );

    const descriptionOption = descriptionData.map((i) => ({
        value: i.id,
        label: i.description_name
    }));

    const [filterDescription, setFilterDescription] = useState("null");

    useEffect(() => {
        if (descriptionOption.length > 0 && filterDescription === "null") {
            setFilterDescription(descriptionOption[descriptionOption.length - 1].value);
        }
    }, [descriptionOption]);

    const handleSelectedDescription = (selectionOption) => {
        if (!selectionOption) {
            setFilterDescription("null");
        } else {
            setFilterDescription(selectionOption.value);
        }
    };

    const [data, setData] = useState("");

    useEffect(() => {
        if (!filterDescription || filterDescription === "null") {
            setData("");
        } else {
            const filteredData = descriptionData.find((item) => item.id === filterDescription);
            console.log("filteredData", filteredData);
            const descriptionText = filteredData.description_details;
            if (filteredData) {
                setData(descriptionText);
            } else {
                setData("");
            }
        }
    }, [filterDescription, descriptionData]);

    return (
        <>
            <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>

                <div className="boc-modern-card">

                    {/* ===== HEADER SECTION ===== */}
                    <div className="boc-modern-header bocx-modern-footer-total">
                        <div className="boc-modern-header-content">
                            <div className="boc-modern-project-info">
                                <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
                                <div className="boc-modern-project-meta">
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Client:</span>
                                        <span className="boc-modern-meta-value">{projectData?.client_name}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Consultant (AE):</span>
                                        <span className="boc-modern-meta-value">
                                            {projectData?.lead}
                                            {projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}
                                            {projectData?.association ? ` Association with ${projectData?.association}` : ""}
                                        </span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">GSTIN:</span>
                                        <span className="boc-modern-meta-value">{projectData?.gst_no}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">PAN:</span>
                                        <span className="boc-modern-meta-value">{projectData?.pan_no}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Bid Due:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Agreement:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Start:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ===== CONTROLS SECTION ===== */}
                    <div className="boc-modern-controls-wrapper">
                        <div className="boc-modern-controls">
                            <div className="boc-modern-controls-left">
                                <h3 className="boc-modern-main-heading">5. Office Rent (Fixed Costs)</h3>
                                <p className="boc-modern-transport-note">
                                    (Minimum 200 sqm area of office shall be rented. The rent cost includes electricity and water charges, maintenance, cleaning, repairs, etc. complete.)
                                </p>
                            </div>
                            {role !== "SiteManagement" && (
                                <div className="boc-modern-controls-right justify-end" style={{ width: "100%" }}>
                                    <div className="flex-row justify-end" style={{ width: "24%" }}>
                                        {(officeRent.length > 0 && officeRentData.length >= 1) ? (
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label">BOQ Version</label>
                                                <select
                                                    value={logid}
                                                    onChange={(e) => setLogId(e.target.value)}
                                                    className="boc-modern-select"
                                                >
                                                    <option value="null">
                                                        BOQ {groupedByRandomChange.length + 1}- {rentChangeReason}
                                                    </option>
                                                    {groupedByRandomChange.map(([groupKey, items], index) => {
                                                        const reasons = [...new Set(
                                                            items
                                                                .map(i => i.data?.reason_of_change)
                                                                .filter(reason =>
                                                                    reason !== null &&
                                                                    reason !== "null" &&
                                                                    reason?.trim() !== ""
                                                                )
                                                        )];
                                                        return (
                                                            <option key={groupKey} value={index}>
                                                                BOQ {groupedByRandomChange.length - index}
                                                                {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        ) : (
                                            <div className="boc-modern-control-group"></div>
                                        )}
                                    </div>

                                    <div className="boc-modern-action-buttons" style={{ float: "right" }}>
                                        <div className="boc-modern-control-group">
                                            <label className="boc-modern-control-label">Description</label>
                                            <Select
                                                options={descriptionOption}
                                                value={
                                                    filterDescription !== "null"
                                                        ? descriptionOption.find((item) => item.value === filterDescription)
                                                        : "null"
                                                }
                                                onChange={handleSelectedDescription}
                                                isClearable
                                                placeholder="Select Description"
                                                styles={CSSForSelectModern15VWWidth}
                                            />
                                        </div>

                                        {logid === "null" && (
                                            <>
                                                <div className="boc-modern-control-group">
                                                    <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                    <AddDescription
                                                        idDescription={idDescription}
                                                        descriptionList={descriptionData}
                                                        usedFor="Office Rent"
                                                        descriptionType="BOQOfficeRent"
                                                        projectId={id}
                                                    />
                                                </div>
                                                <div className="boc-modern-control-group">
                                                    <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                    <AddOfficeRent id={id} getOfficeRent={getOfficeRent} officeRentList={officeRent} />
                                                </div>
                                                <div className="boc-modern-control-group">
                                                    <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                    <BulkUpdateOfficeRentData
                                                        boqOfficeRentList={selectedGroup}
                                                        id={id}
                                                        getData={getOfficeRent}
                                                        getLogData={getLogData}
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* ===== DESCRIPTION SECTION ===== */}
                    <div className="boc-modern-description-section" style={{ padding: "10px 10px" }}>
                        <DescriptionList data={data} />
                    </div>

                    {/* ===== TABLE SECTION ===== */}
                    <div className="boc-modern-table-wrapper">
                        <div className="boc-modern-table-scroll">
                            <table className="boc-modern-table">
                                <thead>
                                    <tr className="boc-modern-table-header">
                                        <th className="boc-modern-th text-center" rowSpan="4">Sr.No</th>
                                        <th className="boc-modern-th text-center" colSpan="5">Contract Values</th>
                                        {isEotDataTrue && (
                                            <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>
                                                Revised Contract Values (after COS/EOT)
                                            </th>
                                        )}
                                        {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                            <th className="boc-modern-th text-center" rowSpan="4">Action</th>
                                        )}
                                    </tr>
                                    <tr className="boc-modern-table-subheader">
                                        <th rowSpan="2" className="boc-modern-th">Const</th>
                                        <th rowSpan="2" className="boc-modern-th">Maint</th>
                                        <th rowSpan="2" className="boc-modern-th">Const & Maint</th>
                                        <th rowSpan="2" className="boc-modern-th">Rate</th>
                                        <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                        {Array.from({ length: eotLengths }).map((_, idx) => (
                                            <th key={idx} className="boc-modern-th text-center" colSpan={5}>
                                                {`EOT ${idx + 1}`}
                                            </th>
                                        ))}
                                    </tr>
                                    <tr className="boc-modern-table-subheader">
                                        {Array.from({ length: eotLengths }).map((_, idx) => (
                                            <React.Fragment key={idx}>
                                                <th rowSpan="2" className="boc-modern-th">Const</th>
                                                <th rowSpan="2" className="boc-modern-th">Maint</th>
                                                <th rowSpan="2" className="boc-modern-th">Const & Maint</th>
                                                <th rowSpan="2" className="boc-modern-th">Rate</th>
                                                <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                </thead>
                                {buffer ? (
                                    <tbody>
                                        <tr>
                                            <td colSpan="20">
                                                <div className="boc-modern-loading">
                                                    <div className="boc-modern-spinner"></div>
                                                    <span>Loading data...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                ) : (
                                    <>
                                        <tbody>
                                            {selectedGroup.map((item, index) => (
                                                <tr key={item.id} className="boc-modern-row">
                                                    <td className="boc-modern-td text-center">{index + 1}</td>
                                                    <td className="boc-modern-td text-right">
                                                        {item.during_construction_period ?? item.data?.during_construction_period}
                                                    </td>
                                                    <td className="boc-modern-td text-right">
                                                        {item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period}
                                                    </td>
                                                    <td className="boc-modern-td text-right">
                                                        {item.num_of_months ?? item.data?.num_of_months}
                                                    </td>
                                                    <td className="boc-modern-td text-right boc-modern-currency">
                                                        ₹{formatCurrencyIndian(Number(item.rate_per_month ?? item.data?.rate_per_month))}
                                                    </td>
                                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-total-highlight">
                                                        ₹{formatCurrencyIndian(
                                                            Number(item.num_of_months ?? item.data?.num_of_months) *
                                                            Number(item.rate_per_month ?? item.data?.rate_per_month)
                                                        )}
                                                    </td>
                                                    {item.eot_details?.length > 0 ? (
                                                        item.eot_details.map((i, idx) => (
                                                            <React.Fragment key={idx}>
                                                                <td className="boc-modern-td text-right">{i.cp}</td>
                                                                <td className="boc-modern-td text-right">{i.dlp}</td>
                                                                <td className="boc-modern-td text-right">{i.t_month}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(i.rate)}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(i.total_amount)}</td>
                                                            </React.Fragment>
                                                        ))
                                                    ) : (
                                                        item.data?.eot_details?.map((i, idx) => (
                                                            <React.Fragment key={idx}>
                                                                <td className="boc-modern-td text-right">{i.cp}</td>
                                                                <td className="boc-modern-td text-right">{i.dlp}</td>
                                                                <td className="boc-modern-td text-right">{i.t_month}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(i.rate)}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(i.total_amount)}</td>
                                                            </React.Fragment>
                                                        ))
                                                    )}
                                                    {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                        <td className="boc-modern-td text-center">
                                                            {role !== "BD" && role !== "Account" && (
                                                                <DeleteOfficeRent i={item} getOfficeRent={getOfficeRent} />
                                                            )}
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr className="boc-modern-footer">
                                                <td colSpan="5" className="boc-modern-footer-label">Total:</td>
                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                    ₹{formatCurrencyIndian(
                                                        selectedGroup.reduce((total, item) => {
                                                            const rate = Number(item.rate_per_month ?? item.data?.rate_per_month ?? 0);
                                                            const months = Number(item.num_of_months ?? item.data?.num_of_months ?? 0);
                                                            return total + (rate * months);
                                                        }, 0)
                                                    )}
                                                </td>
                                                {isEotDataTrue && (
                                                    <>
                                                        {Array.from({ length: eotLengths }).map((_, eotIdx) => {
                                                            const subTotal = selectedGroup.reduce((sum, emp) => {
                                                                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                                                                const eot = details[eotIdx];
                                                                return sum + (Number(eot?.total_amount) || 0);
                                                            }, 0);
                                                            return (
                                                                <React.Fragment key={eotIdx}>
                                                                    <td colSpan="4" className="boc-modern-footer-label"></td>
                                                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                                        ₹{formatCurrencyIndian(subTotal)}
                                                                    </td>
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </>
                                                )}
                                                {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                    <td className="boc-modern-td"></td>
                                                )}
                                            </tr>
                                        </tfoot>
                                    </>
                                )}
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

const OfficeSuppliess = ({ idDescription, descriptionData, projectData, props, id, officeSupplies, getOfficeSupplies, logData, getLogData, logid, setLogId, groupedByRandomChange, selectedGroup }) => {
    const role = sessionStorage.getItem('sitemanagement_role');
    const officeSuppliesId = officeSupplies.map(e => e.id);
    const suppliesChangeReason = officeSupplies[0]?.reason_of_change || "";
    const [buffer, setBuffering] = useState(false)

    const officeSuppliesData = logData.filter(item =>
        officeSuppliesId.includes(item.object_id)
    );

    const isEotDataTrue = selectedGroup.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );





    const eotLengths = Math.max(
        ...selectedGroup.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );


    const descriptionOption = descriptionData.map((i) => ({
        value: i.id,
        label: i.description_name
    }));


    const [filterDescription, setFilterDescription] = useState("null");

    useEffect(() => {
        if (descriptionOption.length > 0 && filterDescription === "null") {
            setFilterDescription(descriptionOption[descriptionOption.length - 1].value);
        }
    }, [descriptionOption]);

    const handleSelectedDescription = (selectionOption) => {
        if (!selectionOption) {
            setFilterDescription("null");
        }
        else {
            setFilterDescription(selectionOption.value)
        }
    }
    const [data, setData] = useState("");

    useEffect(() => {
        if (!filterDescription || filterDescription === "null") {
            setData("");
        }
        else {
            const filteredData = descriptionData.find((item) => item.id === filterDescription);

            console.log("filteredData", filteredData);
            const descriptionText = filteredData.description_details
            if (filteredData) {
                setData(descriptionText);
            } else {
                setData("");
            }
        }



    }, [filterDescription, descriptionData]);


    // return (
    //     <>
    //         <div className="table-css-background">
    //             <div className='heading-conslt'>
    //                 <div className='flex-column'>
    //                     <div>
    //                         <h3 style={{ fontSize: "15px", textAlign: "justify" }}>{projectData?.project_name}</h3>
    //                     </div>
    //                     <div className='flex-row justify-between' style={{ width: "90vw" }}>

    //                         <div className='consultant-heading'>
    //                             <h6>Client Name:{projectData?.client_name}</h6>
    //                             <h6>Consultant (AE):{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</h6>
    //                             <h6>GSTIN No:{projectData?.gst_no}</h6>
    //                             <h6>PAN No:{projectData?.pan_no}</h6>
    //                             <h6>Bid Due Submission Date:{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</h6>
    //                             <div className='flex-row justify-between' style={{ width: "86vw" }}>
    //                                 <div>
    //                                     <h6>Agreement Date:{formatDateDD_MM_YYYY(projectData?.agreement_date)}</h6>
    //                                     <h6>Project Start Date:{formatDateDD_MM_YYYY(projectData?.commencement_date)}</h6>
    //                                 </div>


    //                             </div>
    //                         </div>

    //                     </div>

    //                 </div>
    //                 {/* <AddSupportStaff id={id} getSupportStaff={getBreakdownCost}/> */}
    //             </div>
    //             <div className='heads-div'>
    //                 <h2 className="font-size-1-5rem">6. Office Supplies, Utilities and
    //                     Communication (Fixed Costs)</h2>
    //             </div>
    //             <div className='heads-div'>


    //                 <div style={{ width: "100%" }} className="flex-row justify-end hide-on-print">

    //                     <div>
    //                         {(officeSupplies.length > 0 && officeSuppliesData.length >= 1) && (
    //                             <select
    //                                 value={logid}
    //                                 onChange={(e) => setLogId(e.target.value)}
    //                                 className="dropdown font-size-subheading navbar-inputt"
    //                             >
    //                                 <option value="null">
    //                                     BOQ {groupedByRandomChange.length + 1}- {suppliesChangeReason}
    //                                 </option>

    //                                 {groupedByRandomChange.map(([groupKey, items], index) => {
    //                                     const reasons = [...new Set(
    //                                         items
    //                                             .map(i => i.data?.reason_of_change)
    //                                             .filter(reason =>
    //                                                 reason !== null &&
    //                                                 reason !== "null" &&
    //                                                 reason?.trim() !== ""
    //                                             )
    //                                     )];

    //                                     return (
    //                                         <option key={groupKey} value={index}>
    //                                             BOQ {groupedByRandomChange.length - index}
    //                                             {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
    //                                         </option>
    //                                     );
    //                                 })}




    //                             </select>
    //                         )}
    //                     </div>
    //                     {role !== "SiteManagement" &&
    //                         <div className="hide-on-print flex-row">
    //                             <Select
    //                                 options={descriptionOption}
    //                                 value={
    //                                     filterDescription !== "null"
    //                                         ? descriptionOption.find((item) => item.value === filterDescription)
    //                                         : "null"  // ✅ null instead of "null" - React Select expects null for empty state
    //                                 }
    //                                 onChange={handleSelectedDescription}
    //                                 isClearable
    //                                 placeholder="Select Description"
    //                                 styles={CSSForFilterDropdown}
    //                             />
    //                             <AddDescription idDescription={idDescription} descriptionList={descriptionData} usedFor="Office Supplies" descriptionType="BOQOfficeSupplies" projectId={id} />

    //                             <AddOfficeSupplies id={id} getOfficeSupplies={getOfficeSupplies} officeSuppliesList={officeSupplies} />
    //                             <BulkUpdateOfficeSuppliesData boqOfficeSuppliesList={selectedGroup} id={id} getData={getOfficeSupplies} getLogData={getLogData} />

    //                         </div>
    //                     }

    //                 </div>
    //             </div>
    //             <DescriptionList data={data} />

    //             <table className="nested-table-lightblue">
    //                 <thead>
    //                     <tr className='theading'>
    //                         <th className='table-heading-text text-center' rowSpan="4">Sr.No</th>
    //                         <th className='table-heading-text text-center' rowSpan="4">Item</th>
    //                         <th className='table-heading-text text-center' colSpan="5">Contract Values</th>
    //                         {isEotDataTrue &&

    //                             <th
    //                                 className="table-heading-text text-center"
    //                                 colSpan={eotLengths * 5 || 1}
    //                             >
    //                                 Revised Contract Values (after COS/EOT)
    //                             </th>
    //                         }

    //                         {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                             <th className="hide-on-print align-center" rowSpan="4">Action</th>
    //                         }
    //                     </tr>
    //                     <tr className='nested-heading'>
    //                         <th rowSpan="2" className='table-heading-text'>Const</th>
    //                         <th rowSpan="2" className='table-heading-text'>Maint</th>
    //                         <th rowSpan="2" className='table-heading-text'>Const & Maint</th>
    //                         <th rowSpan="2" className='table-heading-text'>Rate</th>
    //                         <th rowSpan="2" className='table-heading-text'>Total Amount</th>

    //                         {/* Dynamically add EOT headers */}
    //                         {Array.from({ length: eotLengths }).map((_, idx) => (
    //                             <th key={idx} className="table-heading-text text-center" colSpan={5}>
    //                                 {`EOT ${idx + 1}`}
    //                             </th>
    //                         ))}

    //                     </tr>

    //                     <tr className='nested-heading'>
    //                         {Array.from({ length: eotLengths }).map((_, idx) => (
    //                             <React.Fragment key={idx}>
    //                                 <th rowSpan="2" className='table-heading-text'>Const</th>
    //                                 <th rowSpan="2" className='table-heading-text'>Maint</th>
    //                                 <th rowSpan="2" className='table-heading-text'>Const & Maint</th>
    //                                 <th rowSpan="2" className='table-heading-text'>Rate</th>
    //                                 <th rowSpan="2" className='table-heading-text'>Total Amount</th>
    //                             </React.Fragment>
    //                         ))}

    //                     </tr>

    //                 </thead>
    //                 {/* <thead>
    //                     <tr>
    //                         <th rowSpan="2">Sr.No</th>
    //                         <th rowSpan="2">Item</th>
    //                         <th colSpan="2">No. of Months</th>
    //                         <th rowSpan="2">Total</th>
    //                         <th rowSpan="2">Monthly Rate (Rs.)</th>
    //                         <th rowSpan="2">Amount (Rs.)</th>
    //                         {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                             <th rowSpan="2" className="hide-on-print align-center">Action</th>
    //                         }
    //                     </tr>
    //                     <tr>
    //                         <th>During Construction Period</th>
    //                         <th>During DLP and O&M Period</th>
    //                     </tr>
    //                 </thead> */}
    //                 <tbody>
    //                     {selectedGroup.map((item, index) => (
    //                         <tr>
    //                             <td>{index + 1}</td>
    //                             <td>{item.item ?? item.data?.item}</td>
    //                             <td>{item.during_construction_period ?? item.data?.during_construction_period}</td>
    //                             <td>{item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period}</td>
    //                             <td>{item.months ?? item.data?.months}</td>
    //                             <td className="align-right">₹{formatCurrencyIndian(Number(item.monthly_rate ?? item.data?.monthly_rate))}</td>
    //                             <td className="align-right">₹{formatCurrencyIndian(
    //                                 (Number(item.months ?? item.data?.months) * Number(item.monthly_rate ?? item.data?.monthly_rate)
    //                                 ))}</td>
    //                             {item.eot_details?.length > 0 ?
    //                                 <>
    //                                     {item.eot_details?.map((i) => (
    //                                         <>
    //                                             <td className="align-right">{i.cp} </td>
    //                                             <td className="align-right">{i.dlp} </td>
    //                                             <td className="align-right">{i.t_month} </td>
    //                                             <td className="align-right">₹{formatCurrencyIndian(i.rate)} </td>
    //                                             <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
    //                                         </>
    //                                     ))}
    //                                 </> :
    //                                 <>
    //                                     {item.data?.eot_details?.map((i) => (
    //                                         <>
    //                                             <td className="align-right">{i.cp} </td>
    //                                             <td className="align-right">{i.dlp} </td>
    //                                             <td className="align-right">{i.t_month} </td>
    //                                             <td className="align-right">₹{formatCurrencyIndian(i.rate)} </td>
    //                                             <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
    //                                         </>
    //                                     ))}
    //                                 </>
    //                             }
    //                             {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                                 <td className="hide-on-print flex-row  border-single justify-center">
    //                                     {role === "BD" || role === "Account" ? "" :
    //                                         <DeleteOfficeSupplies i={item} getOfficeSupplies={getOfficeSupplies} />
    //                                     }
    //                                 </td>

    //                             }
    //                         </tr>
    //                     ))}

    //                 </tbody>
    //                 <tfoot>
    //                     <tr>
    //                         <td colSpan="6" className="total-label">Total:</td>
    //                         <td className="align-right">
    //                             ₹{formatCurrencyIndian(
    //                                 selectedGroup.reduce((total, item) => {
    //                                     const rate = Number(item.monthly_rate ?? item.data?.monthly_rate ?? 0);
    //                                     const months = Number(item.months ?? item.data?.months ?? 0);
    //                                     return total + (rate * months);
    //                                 }, 0)
    //                             )}
    //                         </td>
    //                         {isEotDataTrue && (
    //                             <>
    //                                 {Array.from({ length: eotLengths }).map((_, eotIdx) => {
    //                                     // sum this EOT index across all employees
    //                                     const subTotal = selectedGroup.reduce((sum, emp) => {
    //                                         const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
    //                                         const eot = details[eotIdx];
    //                                         return sum + (Number(eot?.total_amount) || 0);
    //                                     }, 0);

    //                                     return (
    //                                         <React.Fragment key={eotIdx}>
    //                                             <td colSpan="4" className="total-label"></td>
    //                                             <td className="align-right">
    //                                                 ₹{formatCurrencyIndian(subTotal)}
    //                                             </td>
    //                                         </React.Fragment>
    //                                     );
    //                                 })}
    //                             </>
    //                         )}
    //                         {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                             <td className="hide-on-print"></td>
    //                         }
    //                     </tr>
    //                 </tfoot>
    //             </table>
    //         </div>
    //     </>
    // );

    return (
        <>
            <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>

                <div className="boc-modern-card">

                    {/* ===== HEADER SECTION ===== */}
                    <div className="boc-modern-header bocx-modern-footer-total">
                        <div className="boc-modern-header-content">
                            <div className="boc-modern-project-info">
                                <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
                                <div className="boc-modern-project-meta">
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Client:</span>
                                        <span className="boc-modern-meta-value">{projectData?.client_name}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Consultant (AE):</span>
                                        <span className="boc-modern-meta-value">
                                            {projectData?.lead}
                                            {projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}
                                            {projectData?.association ? ` Association with ${projectData?.association}` : ""}
                                        </span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">GSTIN:</span>
                                        <span className="boc-modern-meta-value">{projectData?.gst_no}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">PAN:</span>
                                        <span className="boc-modern-meta-value">{projectData?.pan_no}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Bid Due:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Agreement:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Start:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ===== CONTROLS SECTION ===== */}
                    <div className="boc-modern-controls-wrapper">
                        <div className="boc-modern-controls">
                            <div className="boc-modern-controls-left">
                                <h3 className="boc-modern-main-heading">6. Office Supplies, Utilities and Communication (Fixed Costs)</h3>
                            </div>
                            {role !== "SiteManagement" && (
                                <div className="boc-modern-controls-right justify-end" style={{ width: "100%" }}>
                                    <div className="flex-row justify-end" style={{ width: "24%" }}>
                                        {(officeSupplies.length > 0 && officeSuppliesData.length >= 1) ? (
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label">BOQ Version</label>
                                                <select
                                                    value={logid}
                                                    onChange={(e) => setLogId(e.target.value)}
                                                    className="boc-modern-select"
                                                >
                                                    <option value="null">
                                                        BOQ {groupedByRandomChange.length + 1}- {suppliesChangeReason}
                                                    </option>
                                                    {groupedByRandomChange.map(([groupKey, items], index) => {
                                                        const reasons = [...new Set(
                                                            items
                                                                .map(i => i.data?.reason_of_change)
                                                                .filter(reason =>
                                                                    reason !== null &&
                                                                    reason !== "null" &&
                                                                    reason?.trim() !== ""
                                                                )
                                                        )];
                                                        return (
                                                            <option key={groupKey} value={index}>
                                                                BOQ {groupedByRandomChange.length - index}
                                                                {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        ) : (
                                            <div className="boc-modern-control-group"></div>
                                        )}
                                    </div>

                                    <div className="boc-modern-action-buttons" style={{ float: "right" }}>
                                        <div className="boc-modern-control-group">
                                            <label className="boc-modern-control-label">Description</label>
                                            <Select
                                                options={descriptionOption}
                                                value={
                                                    filterDescription !== "null"
                                                        ? descriptionOption.find((item) => item.value === filterDescription)
                                                        : "null"
                                                }
                                                onChange={handleSelectedDescription}
                                                isClearable
                                                placeholder="Select Description"
                                                styles={CSSForSelectModern15VWWidth}
                                            />
                                        </div>

                                        {logid === "null" && (
                                            <>
                                                <div className="boc-modern-control-group">
                                                    <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                    <AddDescription
                                                        idDescription={idDescription}
                                                        descriptionList={descriptionData}
                                                        usedFor="Office Supplies"
                                                        descriptionType="BOQOfficeSupplies"
                                                        projectId={id}
                                                    />
                                                </div>
                                                <div className="boc-modern-control-group">
                                                    <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                    <AddOfficeSupplies id={id} getOfficeSupplies={getOfficeSupplies} officeSuppliesList={officeSupplies} />
                                                </div>
                                                <div className="boc-modern-control-group">
                                                    <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                    <BulkUpdateOfficeSuppliesData
                                                        boqOfficeSuppliesList={selectedGroup}
                                                        id={id}
                                                        getData={getOfficeSupplies}
                                                        getLogData={getLogData}
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* ===== DESCRIPTION SECTION ===== */}
                    <div className="boc-modern-description-section" style={{ padding: "10px 10px" }}>
                        <DescriptionList data={data} />
                    </div>

                    {/* ===== TABLE SECTION ===== */}
                    <div className="boc-modern-table-wrapper">
                        <div className="boc-modern-table-scroll">
                            <table className="boc-modern-table">
                                <thead>
                                    <tr className="boc-modern-table-header">
                                        <th className="boc-modern-th text-center" rowSpan="4">Sr.No</th>
                                        <th className="boc-modern-th text-center" rowSpan="4">Item</th>
                                        <th className="boc-modern-th text-center" colSpan="5">Contract Values</th>
                                        {isEotDataTrue && (
                                            <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>
                                                Revised Contract Values (after COS/EOT)
                                            </th>
                                        )}
                                        {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                            <th className="boc-modern-th text-center" rowSpan="4">Action</th>
                                        )}
                                    </tr>
                                    <tr className="boc-modern-table-subheader">
                                        <th rowSpan="2" className="boc-modern-th">Const</th>
                                        <th rowSpan="2" className="boc-modern-th">Maint</th>
                                        <th rowSpan="2" className="boc-modern-th">Const & Maint</th>
                                        <th rowSpan="2" className="boc-modern-th">Rate</th>
                                        <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                        {Array.from({ length: eotLengths }).map((_, idx) => (
                                            <th key={idx} className="boc-modern-th text-center" colSpan={5}>
                                                {`EOT ${idx + 1}`}
                                            </th>
                                        ))}
                                    </tr>
                                    <tr className="boc-modern-table-subheader">
                                        {Array.from({ length: eotLengths }).map((_, idx) => (
                                            <React.Fragment key={idx}>
                                                <th rowSpan="2" className="boc-modern-th">Const</th>
                                                <th rowSpan="2" className="boc-modern-th">Maint</th>
                                                <th rowSpan="2" className="boc-modern-th">Const & Maint</th>
                                                <th rowSpan="2" className="boc-modern-th">Rate</th>
                                                <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                </thead>
                                {buffer ? (
                                    <tbody>
                                        <tr>
                                            <td colSpan="20">
                                                <div className="boc-modern-loading">
                                                    <div className="boc-modern-spinner"></div>
                                                    <span>Loading data...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                ) : (
                                    <>
                                        <tbody>
                                            {selectedGroup.map((item, index) => (
                                                <tr key={item.id} className="boc-modern-row">
                                                    <td className="boc-modern-td text-center">{index + 1}</td>
                                                    <td className="boc-modern-td">
                                                        {item.item ?? item.data?.item}
                                                    </td>
                                                    <td className="boc-modern-td text-right">
                                                        {item.during_construction_period ?? item.data?.during_construction_period}
                                                    </td>
                                                    <td className="boc-modern-td text-right">
                                                        {item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period}
                                                    </td>
                                                    <td className="boc-modern-td text-right">
                                                        {item.months ?? item.data?.months}
                                                    </td>
                                                    <td className="boc-modern-td text-right boc-modern-currency">
                                                        ₹{formatCurrencyIndian(Number(item.monthly_rate ?? item.data?.monthly_rate))}
                                                    </td>
                                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-total-highlight">
                                                        ₹{formatCurrencyIndian(
                                                            Number(item.months ?? item.data?.months) *
                                                            Number(item.monthly_rate ?? item.data?.monthly_rate)
                                                        )}
                                                    </td>
                                                    {item.eot_details?.length > 0 ? (
                                                        item.eot_details.map((i, idx) => (
                                                            <React.Fragment key={idx}>
                                                                <td className="boc-modern-td text-right">{i.cp}</td>
                                                                <td className="boc-modern-td text-right">{i.dlp}</td>
                                                                <td className="boc-modern-td text-right">{i.t_month}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(i.rate)}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(i.total_amount)}</td>
                                                            </React.Fragment>
                                                        ))
                                                    ) : (
                                                        item.data?.eot_details?.map((i, idx) => (
                                                            <React.Fragment key={idx}>
                                                                <td className="boc-modern-td text-right">{i.cp}</td>
                                                                <td className="boc-modern-td text-right">{i.dlp}</td>
                                                                <td className="boc-modern-td text-right">{i.t_month}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(i.rate)}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(i.total_amount)}</td>
                                                            </React.Fragment>
                                                        ))
                                                    )}
                                                    {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                        <td className="boc-modern-td text-center">
                                                            {role !== "BD" && role !== "Account" && (
                                                                <DeleteOfficeSupplies i={item} getOfficeSupplies={getOfficeSupplies} />
                                                            )}
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr className="boc-modern-footer">
                                                <td colSpan="6" className="boc-modern-footer-label">Total:</td>
                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                    ₹{formatCurrencyIndian(
                                                        selectedGroup.reduce((total, item) => {
                                                            const rate = Number(item.monthly_rate ?? item.data?.monthly_rate ?? 0);
                                                            const months = Number(item.months ?? item.data?.months ?? 0);
                                                            return total + (rate * months);
                                                        }, 0)
                                                    )}
                                                </td>
                                                {isEotDataTrue && (
                                                    <>
                                                        {Array.from({ length: eotLengths }).map((_, eotIdx) => {
                                                            const subTotal = selectedGroup.reduce((sum, emp) => {
                                                                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                                                                const eot = details[eotIdx];
                                                                return sum + (Number(eot?.total_amount) || 0);
                                                            }, 0);
                                                            return (
                                                                <React.Fragment key={eotIdx}>
                                                                    <td colSpan="4" className="boc-modern-footer-label"></td>
                                                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                                        ₹{formatCurrencyIndian(subTotal)}
                                                                    </td>
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </>
                                                )}
                                                {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                    <td className="boc-modern-td"></td>
                                                )}
                                            </tr>
                                        </tfoot>
                                    </>
                                )}
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};


const OfficeFurniture = ({ idDescription, descriptionData, projectData, props, id, officeFurniture, officeFurnitureheading, getOfficeFurniture, getOfficeFurnitureheading, logData, getLogData, logid, setLogId, groupedByRandomChange, selectedGroup }) => {
    const role = sessionStorage.getItem('sitemanagement_role');
    const officeFurnitureId = officeFurniture.map(e => e.id);
    const furnitureChangeReason = officeFurniture[0]?.reason_of_change || "";
    const [buffer, setBuffering] = useState(false)

    const officeFurnitureData = logData.filter(item =>
        officeFurnitureId.includes(item.object_id)
    );



    const isEotDataTrue = selectedGroup.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );





    const eotLengths = Math.max(
        ...selectedGroup.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );



    const descriptionOption = descriptionData.map((i) => ({
        value: i.id,
        label: i.description_name
    }));


    const [filterDescription, setFilterDescription] = useState("null");

    useEffect(() => {
        if (descriptionOption.length > 0 && filterDescription === "null") {
            setFilterDescription(descriptionOption[descriptionOption.length - 1].value);
        }
    }, [descriptionOption]);

    const handleSelectedDescription = (selectionOption) => {
        if (!selectionOption) {
            setFilterDescription("null");
        }
        else {
            setFilterDescription(selectionOption.value)
        }
    }
    const [data, setData] = useState("");

    useEffect(() => {
        if (!filterDescription || filterDescription === "null") {
            setData("");
        }
        else {
            const filteredData = descriptionData.find((item) => item.id === filterDescription);

            console.log("filteredData", filteredData);
            const descriptionText = filteredData.description_details
            if (filteredData) {
                setData(descriptionText);
            } else {
                setData("");
            }
        }



    }, [filterDescription, descriptionData]);




    return (
        <>
            <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>
                <div className="boc-modern-card">

                    {/* ===== HEADER SECTION ===== */}
                    <div className="boc-modern-header bocx-modern-footer-total">
                        <div className="boc-modern-header-content">
                            <div className="boc-modern-project-info">
                                <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
                                <div className="boc-modern-project-meta">
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Client:</span>
                                        <span className="boc-modern-meta-value">{projectData?.client_name}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Consultant (AE):</span>
                                        <span className="boc-modern-meta-value">
                                            {projectData?.lead}
                                            {projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}
                                            {projectData?.association ? ` Association with ${projectData?.association}` : ""}
                                        </span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">GSTIN:</span>
                                        <span className="boc-modern-meta-value">{projectData?.gst_no}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">PAN:</span>
                                        <span className="boc-modern-meta-value">{projectData?.pan_no}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Bid Due:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Agreement:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Start:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ===== CONTROLS SECTION ===== */}
                    <div className="boc-modern-controls-wrapper">
                        <div className="boc-modern-controls">
                            <div className="boc-modern-controls-left">
                                <h3 className="boc-modern-main-heading">
                                    7. Office Furniture and Equipment (Rental) [Fixed Monthly Cost]
                                </h3>
                                {officeFurnitureheading[0]?.BOQoffice_furnitur_equipment && (
                                    <p className="boc-modern-transport-note">
                                        {officeFurnitureheading[0]?.BOQoffice_furnitur_equipment}
                                    </p>
                                )}
                            </div>
                            {role !== "SiteManagement" && (
                                <div className="boc-modern-controls-right justify-end" style={{ width: "100%" }}>
                                    <div className="flex-row justify-end" style={{ width: "24%" }}>
                                        {(officeFurniture.length > 0 && officeFurnitureData.length >= 1) ? (
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label">BOQ Version</label>
                                                <select
                                                    value={logid}
                                                    onChange={(e) => setLogId(e.target.value)}
                                                    className="boc-modern-select"
                                                >
                                                    <option value="null">
                                                        BOQ {groupedByRandomChange.length + 1}- {furnitureChangeReason}
                                                    </option>
                                                    {groupedByRandomChange.map(([groupKey, items], index) => {
                                                        const reasons = [...new Set(
                                                            items
                                                                .map(i => i.data?.reason_of_change)
                                                                .filter(reason =>
                                                                    reason !== null &&
                                                                    reason !== "null" &&
                                                                    reason?.trim() !== ""
                                                                )
                                                        )];
                                                        return (
                                                            <option key={groupKey} value={index}>
                                                                BOQ {groupedByRandomChange.length - index}
                                                                {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        ) : (
                                            <div className="boc-modern-control-group"></div>
                                        )}
                                    </div>

                                    <div className="boc-modern-action-buttons" style={{ float: "right" }}>
                                        <div className="boc-modern-control-group">
                                            <label className="boc-modern-control-label">Description</label>
                                            <Select
                                                options={descriptionOption}
                                                value={
                                                    filterDescription !== "null"
                                                        ? descriptionOption.find((item) => item.value === filterDescription)
                                                        : "null"
                                                }
                                                onChange={handleSelectedDescription}
                                                isClearable
                                                placeholder="Select Description"
                                                styles={CSSForSelectModern15VWWidth}
                                            />
                                        </div>

                                        {logid === "null" && (
                                            <>
                                                <div className="boc-modern-control-group">
                                                    <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                    <AddDescription
                                                        idDescription={idDescription}
                                                        descriptionList={descriptionData}
                                                        usedFor="Office Furniture"
                                                        descriptionType="BOQOfficeFurnitureAndEquipment"
                                                        projectId={id}
                                                    />
                                                </div>
                                                <div className="boc-modern-control-group">
                                                    <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                    <AddOfficeFurniture
                                                        id={id}
                                                        getOfficeFurniture={getOfficeFurniture}
                                                        officefurnitureList={officeFurniture}
                                                        logData={logData}
                                                    />
                                                </div>
                                                <div className="boc-modern-control-group">
                                                    <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                    <BulkUpdateOfficeFurnitureData
                                                        boqOfficeFurnitureList={selectedGroup}
                                                        id={id}
                                                        getData={getOfficeFurniture}
                                                        getLogData={getLogData}
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* ===== DESCRIPTION SECTION ===== */}
                    <div className="boc-modern-description-section" style={{ padding: "10px 10px" }}>
                        <DescriptionList data={data} />
                    </div>

                    {/* ===== TABLE SECTION ===== */}
                    <div className="boc-modern-table-wrapper">
                        <div className="boc-modern-table-scroll">
                            <table className="boc-modern-table">
                                <thead>
                                    <tr className="boc-modern-table-header">
                                        <th className="boc-modern-th text-center" rowSpan="4">Sr.No</th>
                                        <th className="boc-modern-th text-center" colSpan="5">Contract Values</th>
                                        {isEotDataTrue && (
                                            <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>
                                                Revised Contract Values (after COS/EOT)
                                            </th>
                                        )}
                                        {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                            <th className="boc-modern-th text-center" rowSpan="4">Action</th>
                                        )}
                                    </tr>
                                    <tr className="boc-modern-table-subheader">
                                        <th rowSpan="2" className="boc-modern-th">Const</th>
                                        <th rowSpan="2" className="boc-modern-th">Maint</th>
                                        <th rowSpan="2" className="boc-modern-th">Const & Maint</th>
                                        <th rowSpan="2" className="boc-modern-th">Rate</th>
                                        <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                        {Array.from({ length: eotLengths }).map((_, idx) => (
                                            <th key={idx} className="boc-modern-th text-center" colSpan={5}>
                                                {`EOT ${idx + 1}`}
                                            </th>
                                        ))}
                                    </tr>
                                    <tr className="boc-modern-table-subheader">
                                        {Array.from({ length: eotLengths }).map((_, idx) => (
                                            <React.Fragment key={idx}>
                                                <th rowSpan="2" className="boc-modern-th">Const</th>
                                                <th rowSpan="2" className="boc-modern-th">Maint</th>
                                                <th rowSpan="2" className="boc-modern-th">Const & Maint</th>
                                                <th rowSpan="2" className="boc-modern-th">Rate</th>
                                                <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                </thead>
                                {buffer ? (
                                    <tbody>
                                        <tr>
                                            <td colSpan="20">
                                                <div className="boc-modern-loading">
                                                    <div className="boc-modern-spinner"></div>
                                                    <span>Loading data...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                ) : (
                                    <>
                                        <tbody>
                                            {selectedGroup.map((item, index) => (
                                                <tr key={item.id} className="boc-modern-row">
                                                    <td className="boc-modern-td text-center">{index + 1}</td>
                                                    <td className="boc-modern-td text-right">
                                                        {item.during_construction_period ?? item.data?.during_construction_period}
                                                    </td>
                                                    <td className="boc-modern-td text-right">
                                                        {item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period}
                                                    </td>
                                                    <td className="boc-modern-td text-right">
                                                        {item.num_of_months ?? item.data?.num_of_months}
                                                    </td>
                                                    <td className="boc-modern-td text-right boc-modern-currency">
                                                        ₹{formatCurrencyIndian(Number(item.rate_per_month ?? item.data?.rate_per_month))}
                                                    </td>
                                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-total-highlight">
                                                        ₹{formatCurrencyIndian(
                                                            Number(item.num_of_months ?? item.data?.num_of_months) *
                                                            Number(item.rate_per_month ?? item.data?.rate_per_month)
                                                        )}
                                                    </td>
                                                    {item.eot_details?.length > 0 ? (
                                                        item.eot_details.map((i, idx) => (
                                                            <React.Fragment key={idx}>
                                                                <td className="boc-modern-td text-right">{i.cp}</td>
                                                                <td className="boc-modern-td text-right">{i.dlp}</td>
                                                                <td className="boc-modern-td text-right">{i.t_month}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(i.rate)}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(i.total_amount)}</td>
                                                            </React.Fragment>
                                                        ))
                                                    ) : (
                                                        item.data?.eot_details?.map((i, idx) => (
                                                            <React.Fragment key={idx}>
                                                                <td className="boc-modern-td text-right">{i.cp}</td>
                                                                <td className="boc-modern-td text-right">{i.dlp}</td>
                                                                <td className="boc-modern-td text-right">{i.t_month}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(i.rate)}</td>
                                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(i.total_amount)}</td>
                                                            </React.Fragment>
                                                        ))
                                                    )}
                                                    {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                        <td className="boc-modern-td text-center">
                                                            {role !== "BD" && role !== "Account" && (
                                                                <DeleteOfficeFurniture i={item} getOfficeFurniture={getOfficeFurniture} />
                                                            )}
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr className="boc-modern-footer">
                                                <td colSpan="5" className="boc-modern-footer-label">Total:</td>
                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                    ₹{formatCurrencyIndian(
                                                        selectedGroup.reduce((total, item) => {
                                                            const rate = Number(item.rate_per_month ?? item.data?.rate_per_month ?? 0);
                                                            const months = Number(item.num_of_months ?? item.data?.num_of_months ?? 0);
                                                            return total + (rate * months);
                                                        }, 0)
                                                    )}
                                                </td>
                                                {isEotDataTrue && (
                                                    <>
                                                        {Array.from({ length: eotLengths }).map((_, eotIdx) => {
                                                            const subTotal = selectedGroup.reduce((sum, emp) => {
                                                                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                                                                const eot = details[eotIdx];
                                                                return sum + (Number(eot?.total_amount) || 0);
                                                            }, 0);
                                                            return (
                                                                <React.Fragment key={eotIdx}>
                                                                    <td colSpan="4" className="boc-modern-footer-label"></td>
                                                                    <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                                        ₹{formatCurrencyIndian(subTotal)}
                                                                    </td>
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </>
                                                )}
                                                {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                    <td className="boc-modern-td"></td>
                                                )}
                                            </tr>
                                        </tfoot>
                                    </>
                                )}
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};


const ReportsPrinting = ({ idDescription, descriptionData, projectData, props, id, reportsPrinting, getReportsPrinting, logData, getLogData, logid, setLogId, groupedByRandomChange, selectedGroup }) => {
    const [buffer, setBuffering] = useState(false)
    const role = sessionStorage.getItem('sitemanagement_role');
    const reportId = reportsPrinting.map(e => e.id);
    const reportChange = reportsPrinting[0]?.reason_of_change || "";
    const reportData = logData.filter(item =>
        reportId.includes(item.object_id)
    );



    const isEotDataTrue = selectedGroup.some(i =>
        (i.revised?.length > 0) || (i.data?.revised?.length > 0)
    );

    console.log("isEotDataTrue rEPORTS")
    console.log(isEotDataTrue)





    const eotLengths = Math.max(
        ...selectedGroup.map(i => i?.revised?.length || i?.data?.revised?.length || 0),
        0
    );

    const descriptionOption = descriptionData.map((i) => ({
        value: i.id,
        label: i.description_name
    }));


    const [filterDescription, setFilterDescription] = useState("null");

    useEffect(() => {
        if (descriptionOption.length > 0 && filterDescription === "null") {
            setFilterDescription(descriptionOption[descriptionOption.length - 1].value);
        }
    }, [descriptionOption]);

    const handleSelectedDescription = (selectionOption) => {
        if (!selectionOption) {
            setFilterDescription("null");
        }
        else {
            setFilterDescription(selectionOption.value)
        }
    }
    const [data, setData] = useState("");

    useEffect(() => {
        if (!filterDescription || filterDescription === "null") {
            setData("");
        }
        else {
            const filteredData = descriptionData.find((item) => item.id === filterDescription);

            console.log("filteredData", filteredData);
            const descriptionText = filteredData.description_details
            if (filteredData) {
                setData(descriptionText);
            } else {
                setData("");
            }
        }



    }, [filterDescription, descriptionData]);




    // return (
    //     <div className="table-css-background">
    //         <div className='heading-conslt'>
    //             <div className='flex-column'>
    //                 <div>
    //                     <h3 style={{ fontSize: "15px", textAlign: "justify" }}>{projectData?.project_name}</h3>
    //                 </div>
    //                 <div className='flex-row justify-between' style={{ width: "90vw" }}>

    //                     <div className='consultant-heading'>
    //                         <h6>Client Name:{projectData?.client_name}</h6>
    //                         <h6>Consultant (AE):{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</h6>
    //                         <h6>GSTIN No:{projectData?.gst_no}</h6>
    //                         <h6>PAN No:{projectData?.pan_no}</h6>
    //                         <h6>Bid Due Submission Date:{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</h6>
    //                         <div className='flex-row justify-between' style={{ width: "86vw" }}>
    //                             <div>
    //                                 <h6>Agreement Date:{formatDateDD_MM_YYYY(projectData?.agreement_date)}</h6>
    //                                 <h6>Project Start Date:{formatDateDD_MM_YYYY(projectData?.commencement_date)}</h6>
    //                             </div>


    //                         </div>
    //                     </div>

    //                 </div>

    //             </div>
    //             {/* <AddSupportStaff id={id} getSupportStaff={getBreakdownCost}/> */}
    //         </div>
    //         <div className='heads-div'>
    //             <h2 className="font-size-1-5rem">8. Reports and Document Printing</h2>
    //         </div>
    //         <div className="flex-row justify-between">

    //             <div style={{ width: "100%" }} className="flex-row justify-end hide-on-print">
    //                 <div>
    //                     {(reportsPrinting.length > 0 && reportData.length >= 1) && (
    //                         <select
    //                             value={logid}
    //                             onChange={(e) => setLogId(e.target.value)}
    //                             className="dropdown font-size-subheading navbar-inputt"
    //                         >
    //                             <option value="null">
    //                                 BOQ {groupedByRandomChange.length + 1}- {reportChange}
    //                             </option>

    //                             {groupedByRandomChange.map(([groupKey, items], index) => {
    //                                 const reasons = [...new Set(
    //                                     items
    //                                         .map(i => i.data?.reason_of_change)
    //                                         .filter(reason =>
    //                                             reason !== null &&
    //                                             reason !== "null" &&
    //                                             reason?.trim() !== ""
    //                                         )
    //                                 )];

    //                                 return (
    //                                     <option key={groupKey} value={index}>
    //                                         BOQ {groupedByRandomChange.length - index}
    //                                         {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
    //                                     </option>
    //                                 );
    //                             })}




    //                         </select>
    //                     )}
    //                 </div>
    //                 {role !== "SiteManagement" &&
    //                     <div className="hide-on-print flex-row">
    //                         <Select
    //                             options={descriptionOption}
    //                             value={
    //                                 filterDescription !== "null"
    //                                     ? descriptionOption.find((item) => item.value === filterDescription)
    //                                     : "null"  // ✅ null instead of "null" - React Select expects null for empty state
    //                             }
    //                             onChange={handleSelectedDescription}
    //                             isClearable
    //                             placeholder="Select Description"
    //                             styles={CSSForFilterDropdown}
    //                         />
    //                         <AddDescription idDescription={idDescription} descriptionList={descriptionData} usedFor="Reports" descriptionType="BOQReports" projectId={id} />

    //                         <AddReportsPrinting id={id} getReportsPrinting={getReportsPrinting} reportPageList={reportsPrinting} />

    //                         <BulkUpdateReportsData boqReportsList={selectedGroup} id={id} getData={getReportsPrinting} getLogData={getLogData} />

    //                     </div>
    //                 }
    //             </div>
    //         </div>

    //         <DescriptionList data={data} />


    //         <table className="nested-table-lightblue">

    //             <thead>
    //                 <tr className='theading'>
    //                     <th className='table-heading-text text-center' rowSpan="4">Sr.No</th>
    //                     <th className='table-heading-text text-center' rowSpan="4">Description</th>
    //                     <th className='table-heading-text text-center' colSpan="5">Contract Values</th>
    //                     {isEotDataTrue &&

    //                         <th
    //                             className="table-heading-text text-center"
    //                             colSpan={eotLengths * 5 || 1}
    //                         >
    //                             Revised Contract Values (after COS/EOT)
    //                         </th>
    //                     }

    //                     {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                         <th className="hide-on-print align-center" rowSpan="4">Action</th>
    //                     }
    //                 </tr>
    //                 <tr className='nested-heading'>
    //                     <th rowSpan="2" className='table-heading-text'>No. of reports</th>
    //                     <th rowSpan="2" className='table-heading-text'>No. of copies per report</th>
    //                     <th rowSpan="2" className='table-heading-text'>Total Copies</th>
    //                     <th rowSpan="2" className='table-heading-text'>Rate per copy</th>
    //                     <th rowSpan="2" className='table-heading-text'>Total Amount</th>

    //                     {/* Dynamically add EOT headers */}
    //                     {Array.from({ length: eotLengths }).map((_, idx) => (
    //                         <th key={idx} className="table-heading-text text-center" colSpan={5}>
    //                             {`EOT ${idx + 1}`}
    //                         </th>
    //                     ))}

    //                 </tr>

    //                 <tr className='nested-heading'>
    //                     {Array.from({ length: eotLengths }).map((_, idx) => (
    //                         <React.Fragment key={idx}>
    //                             <th rowSpan="2" className='table-heading-text'>No. of reports</th>
    //                             <th rowSpan="2" className='table-heading-text'>No. of copies per report</th>
    //                             <th rowSpan="2" className='table-heading-text'>Total Copies</th>
    //                             <th rowSpan="2" className='table-heading-text'>Rate per copy</th>
    //                             <th rowSpan="2" className='table-heading-text'>Total Amount</th>
    //                         </React.Fragment>
    //                     ))}

    //                 </tr>
    //                 {/* <div className='pre-heading'>
    //                     A. Key Personal
    //                 </div> */}
    //             </thead>
    //             <tbody>
    //                 {selectedGroup.map((item, index) => (
    //                     <tr key={item.id}>
    //                         <td>{index + 1}</td>
    //                         <td>{item.description ?? item.data?.description}</td>
    //                         <td>{item.num_of_reports ?? item.data?.num_of_reports}</td>
    //                         <td>{item.num_of_copies_per_report ?? item.data?.num_of_copies_per_report}</td>
    //                         <td>{(item.num_of_reports ?? item.data?.num_of_reports) * (item.num_of_copies_per_report ?? item.data?.num_of_copies_per_report)}</td>
    //                         <td className="text-end">₹{formatCurrencyIndian(Number(item.rate_per_copy ?? item.data?.rate_per_copy))}</td>
    //                         <td className="align-right">₹{formatCurrencyIndian((Number(item.num_of_reports ?? item.data?.num_of_reports) * Number(item.num_of_copies_per_report ?? item.data?.num_of_copies_per_report)) * Number(item.rate_per_copy ?? item.data?.rate_per_copy))}</td>

    //                         {item.revised?.length > 0 ?
    //                             <>
    //                                 {item.revised?.map((i) => (
    //                                     <>
    //                                         <td className="align-right">{i.num_of_reports} </td>
    //                                         <td className="align-right">{i.num_of_copies_per_report} </td>
    //                                         <td className="align-right">{i.t_reports} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.rate_per_copy)} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
    //                                     </>
    //                                 ))}
    //                             </> :
    //                             <>
    //                                 {item.data?.revised?.map((i) => (
    //                                     <>
    //                                         <td className="align-right">{i.num_of_reports} </td>
    //                                         <td className="align-right">{i.num_of_copies_per_report} </td>
    //                                         <td className="align-right">{i.t_reports} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.rate_per_copy)} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
    //                                     </>
    //                                 ))}
    //                             </>
    //                         } {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                             <td className="hide-on-print flex-row  border-single justify-center">
    //                                 {role === "BD" || role === "Account" ? "" :
    //                                     <DeleteReportsPrinting i={item} getReportsPrinting={getReportsPrinting} />
    //                                 }
    //                             </td>
    //                         }
    //                     </tr>
    //                 ))}
    //             </tbody>
    //             <tfoot>
    //                 <tr>
    //                     <td colSpan="6" className="total-label">Total:</td>
    //                     <td className="align-right">
    //                         ₹{formatCurrencyIndian(
    //                             selectedGroup.reduce((total, item) => {
    //                                 const rate = Number(item.rate_per_copy ?? item.data?.rate_per_copy ?? 0);
    //                                 const Reports = Number(item.num_of_reports ?? item.data?.num_of_reports ?? 0);
    //                                 const Copies = Number(item.num_of_copies_per_report ?? item.data?.num_of_copies_per_report ?? 0);
    //                                 return total + rate * (Reports * Copies);
    //                             }, 0)
    //                         )}
    //                     </td>
    //                     {isEotDataTrue && (
    //                         <>
    //                             {Array.from({ length: eotLengths }).map((_, eotIdx) => {
    //                                 // sum this EOT index across all employees
    //                                 const subTotal = selectedGroup.reduce((sum, emp) => {
    //                                     const details = emp.revised?.length > 0 ? emp.revised : emp.data?.revised || [];
    //                                     const eot = details[eotIdx];
    //                                     return sum + (Number(eot?.total_amount) || 0);
    //                                 }, 0);

    //                                 return (
    //                                     <React.Fragment key={eotIdx}>
    //                                         <td colSpan="4" className="total-label"></td>
    //                                         <td className="align-right">
    //                                             ₹{formatCurrencyIndian(subTotal)}
    //                                         </td>
    //                                     </React.Fragment>
    //                                 );
    //                             })}
    //                         </>
    //                     )}
    //                     {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                         <td className="hide-on-print"></td>
    //                     }
    //                 </tr>
    //             </tfoot >
    //         </table >
    //     </div >
    // );
    return (
        <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>
            <div className="boc-modern-card">

                {/* ===== HEADER SECTION ===== */}
                <div className="boc-modern-header bocx-modern-footer-total">
                    <div className="boc-modern-header-content">
                        <div className="boc-modern-project-info">
                            <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
                            <div className="boc-modern-project-meta">
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Client:</span>
                                    <span className="boc-modern-meta-value">{projectData?.client_name}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Consultant (AE):</span>
                                    <span className="boc-modern-meta-value">
                                        {projectData?.lead}
                                        {projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}
                                        {projectData?.association ? ` Association with ${projectData?.association}` : ""}
                                    </span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">GSTIN:</span>
                                    <span className="boc-modern-meta-value">{projectData?.gst_no}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">PAN:</span>
                                    <span className="boc-modern-meta-value">{projectData?.pan_no}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Bid Due:</span>
                                    <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Agreement:</span>
                                    <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Start:</span>
                                    <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ===== CONTROLS SECTION ===== */}
                <div className="boc-modern-controls-wrapper">
                    <div className="boc-modern-controls">
                        <div className="boc-modern-controls-left">
                            <h3 className="boc-modern-main-heading">8. Reports and Document Printing</h3>
                        </div>
                        {role !== "SiteManagement" && (
                            <div className="boc-modern-controls-right justify-end" style={{ width: "100%" }}>
                                <div className="flex-row justify-end" style={{ width: "24%" }}>
                                    {(reportsPrinting.length > 0 && reportData.length >= 1) ? (
                                        <div className="boc-modern-control-group">
                                            <label className="boc-modern-control-label">BOQ Version</label>
                                            <select
                                                value={logid}
                                                onChange={(e) => setLogId(e.target.value)}
                                                className="boc-modern-select"
                                            >
                                                <option value="null">
                                                    BOQ {groupedByRandomChange.length + 1}- {reportChange}
                                                </option>
                                                {groupedByRandomChange.map(([groupKey, items], index) => {
                                                    const reasons = [...new Set(
                                                        items
                                                            .map(i => i.data?.reason_of_change)
                                                            .filter(reason =>
                                                                reason !== null &&
                                                                reason !== "null" &&
                                                                reason?.trim() !== ""
                                                            )
                                                    )];
                                                    return (
                                                        <option key={groupKey} value={index}>
                                                            BOQ {groupedByRandomChange.length - index}
                                                            {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    ) : (
                                        <div className="boc-modern-control-group"></div>
                                    )}
                                </div>

                                <div className="boc-modern-action-buttons" style={{ float: "right" }}>
                                    <div className="boc-modern-control-group">
                                        <label className="boc-modern-control-label">Description</label>
                                        <Select
                                            options={descriptionOption}
                                            value={
                                                filterDescription !== "null"
                                                    ? descriptionOption.find((item) => item.value === filterDescription)
                                                    : "null"
                                            }
                                            onChange={handleSelectedDescription}
                                            isClearable
                                            placeholder="Select Description"
                                            styles={CSSForSelectModern15VWWidth}
                                        />
                                    </div>

                                    {logid === "null" && (
                                        <>
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                <AddDescription
                                                    idDescription={idDescription}
                                                    descriptionList={descriptionData}
                                                    usedFor="Reports"
                                                    descriptionType="BOQReports"
                                                    projectId={id}
                                                />
                                            </div>
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                <AddReportsPrinting
                                                    id={id}
                                                    getReportsPrinting={getReportsPrinting}
                                                    reportPageList={reportsPrinting}
                                                />
                                            </div>
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                <BulkUpdateReportsData
                                                    boqReportsList={selectedGroup}
                                                    id={id}
                                                    getData={getReportsPrinting}
                                                    getLogData={getLogData}
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ===== DESCRIPTION SECTION ===== */}
                <div className="boc-modern-description-section" style={{ padding: "10px 10px" }}>
                    <DescriptionList data={data} />
                </div>

                {/* ===== TABLE SECTION ===== */}
                <div className="boc-modern-table-wrapper">
                    <div className="boc-modern-table-scroll">
                        <table className="boc-modern-table">
                            <thead>
                                <tr className="boc-modern-table-header">
                                    <th className="boc-modern-th text-center" rowSpan="4">Sr.No</th>
                                    <th className="boc-modern-th text-center" rowSpan="4">Description</th>
                                    <th className="boc-modern-th text-center" colSpan="5">Contract Values</th>
                                    {isEotDataTrue && (
                                        <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>
                                            Revised Contract Values (after COS/EOT)
                                        </th>
                                    )}
                                    {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                        <th className="boc-modern-th text-center" rowSpan="4">Action</th>
                                    )}
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    <th rowSpan="2" className="boc-modern-th">No. of Reports</th>
                                    <th rowSpan="2" className="boc-modern-th">No. of Copies per Report</th>
                                    <th rowSpan="2" className="boc-modern-th">Total Copies</th>
                                    <th rowSpan="2" className="boc-modern-th">Rate per Copy</th>
                                    <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <th key={idx} className="boc-modern-th text-center" colSpan={5}>
                                            {`EOT ${idx + 1}`}
                                        </th>
                                    ))}
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <React.Fragment key={idx}>
                                            <th rowSpan="2" className="boc-modern-th">No. of Reports</th>
                                            <th rowSpan="2" className="boc-modern-th">No. of Copies per Report</th>
                                            <th rowSpan="2" className="boc-modern-th">Total Copies</th>
                                            <th rowSpan="2" className="boc-modern-th">Rate per Copy</th>
                                            <th rowSpan="2" className="boc-modern-th">Total Amount</th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>
                            {buffer ? (
                                <tbody>
                                    <tr>
                                        <td colSpan="20">
                                            <div className="boc-modern-loading">
                                                <div className="boc-modern-spinner"></div>
                                                <span>Loading data...</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            ) : (
                                <>
                                    <tbody>
                                        {selectedGroup.map((item, index) => (
                                            <tr key={item.id} className="boc-modern-row">
                                                <td className="boc-modern-td text-center">{index + 1}</td>
                                                <td className="boc-modern-td">
                                                    {item.description ?? item.data?.description}
                                                </td>
                                                <td className="boc-modern-td text-right">
                                                    {item.num_of_reports ?? item.data?.num_of_reports}
                                                </td>
                                                <td className="boc-modern-td text-right">
                                                    {item.num_of_copies_per_report ?? item.data?.num_of_copies_per_report}
                                                </td>
                                                <td className="boc-modern-td text-right">
                                                    {(item.num_of_reports ?? item.data?.num_of_reports) *
                                                        (item.num_of_copies_per_report ?? item.data?.num_of_copies_per_report)}
                                                </td>
                                                <td className="boc-modern-td text-right boc-modern-currency">
                                                    ₹{formatCurrencyIndian(Number(item.rate_per_copy ?? item.data?.rate_per_copy))}
                                                </td>
                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-total-highlight">
                                                    ₹{formatCurrencyIndian(
                                                        (Number(item.num_of_reports ?? item.data?.num_of_reports) *
                                                            Number(item.num_of_copies_per_report ?? item.data?.num_of_copies_per_report)) *
                                                        Number(item.rate_per_copy ?? item.data?.rate_per_copy)
                                                    )}
                                                </td>
                                                {item.revised?.length > 0 ? (
                                                    item.revised.map((i, idx) => (
                                                        <React.Fragment key={idx}>
                                                            <td className="boc-modern-td text-right">{i.num_of_reports}</td>
                                                            <td className="boc-modern-td text-right">{i.num_of_copies_per_report}</td>
                                                            <td className="boc-modern-td text-right">{i.t_reports}</td>
                                                            <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(i.rate_per_copy)}</td>
                                                            <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(i.total_amount)}</td>
                                                        </React.Fragment>
                                                    ))
                                                ) : (
                                                    item.data?.revised?.map((i, idx) => (
                                                        <React.Fragment key={idx}>
                                                            <td className="boc-modern-td text-right">{i.num_of_reports}</td>
                                                            <td className="boc-modern-td text-right">{i.num_of_copies_per_report}</td>
                                                            <td className="boc-modern-td text-right">{i.t_reports}</td>
                                                            <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(i.rate_per_copy)}</td>
                                                            <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(i.total_amount)}</td>
                                                        </React.Fragment>
                                                    ))
                                                )}
                                                {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                    <td className="boc-modern-td text-center">
                                                        {role !== "BD" && role !== "Account" && (
                                                            <DeleteReportsPrinting i={item} getReportsPrinting={getReportsPrinting} />
                                                        )}
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr className="boc-modern-footer">
                                            <td colSpan="6" className="boc-modern-footer-label">Total:</td>
                                            <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(
                                                    selectedGroup.reduce((total, item) => {
                                                        const rate = Number(item.rate_per_copy ?? item.data?.rate_per_copy ?? 0);
                                                        const reports = Number(item.num_of_reports ?? item.data?.num_of_reports ?? 0);
                                                        const copies = Number(item.num_of_copies_per_report ?? item.data?.num_of_copies_per_report ?? 0);
                                                        return total + rate * (reports * copies);
                                                    }, 0)
                                                )}
                                            </td>
                                            {isEotDataTrue && (
                                                <>
                                                    {Array.from({ length: eotLengths }).map((_, eotIdx) => {
                                                        const subTotal = selectedGroup.reduce((sum, emp) => {
                                                            const details = emp.revised?.length > 0 ? emp.revised : emp.data?.revised || [];
                                                            const eot = details[eotIdx];
                                                            return sum + (Number(eot?.total_amount) || 0);
                                                        }, 0);
                                                        return (
                                                            <React.Fragment key={eotIdx}>
                                                                <td colSpan="4" className="boc-modern-footer-label"></td>
                                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                                    ₹{formatCurrencyIndian(subTotal)}
                                                                </td>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </>
                                            )}
                                            {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                <td className="boc-modern-td"></td>
                                            )}
                                        </tr>
                                    </tfoot>
                                </>
                            )}
                        </table>
                    </div>
                </div>

            </div>
        </div>
    );
};


const RoadSurveyEquipment = ({ idDescription, descriptionData, projectData, id, roadSurveyEquipment, getRoadSurveyEquipment, toggle, logData, getLogData, logid, setLogId, groupedByRandomChange, selectedGroup }) => {
    const role = sessionStorage.getItem('sitemanagement_role');
    const roadsurveyId = roadSurveyEquipment.map(e => e.id);
    const sureveyChange = roadSurveyEquipment[0]?.reason_of_change || "";
    const [buffer, setBuffering] = useState(false)

    const roadsurveyData = logData.filter(item =>
        roadsurveyId.includes(item.object_id)
    );

    const isEotDataTrue = selectedGroup.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );





    const eotLengths = Math.max(
        ...selectedGroup.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );

    const descriptionOption = descriptionData.map((i) => ({
        value: i.id,
        label: i.description_name
    }));


    const [filterDescription, setFilterDescription] = useState("null");

    useEffect(() => {
        if (descriptionOption.length > 0 && filterDescription === "null") {
            setFilterDescription(descriptionOption[descriptionOption.length - 1].value);
        }
    }, [descriptionOption]);

    const handleSelectedDescription = (selectionOption) => {
        if (!selectionOption) {
            setFilterDescription("null");
        }
        else {
            setFilterDescription(selectionOption.value)
        }
    }
    const [data, setData] = useState("");

    useEffect(() => {
        if (!filterDescription || filterDescription === "null") {
            setData("");
        }
        else {
            const filteredData = descriptionData.find((item) => item.id === filterDescription);

            console.log("filteredData", filteredData);
            const descriptionText = filteredData.description_details
            if (filteredData) {
                setData(descriptionText);
            } else {
                setData("");
            }
        }



    }, [filterDescription, descriptionData]);




    // return (
    //     <div className="table-css-background box-outline">
    //         <div className='heading-conslt'>
    //             <div className='flex-column'>
    //                 <div>
    //                     <h3 style={{ fontSize: "15px", textAlign: "justify" }}>{projectData?.project_name}</h3>
    //                 </div>
    //                 <div className='flex-row justify-between' style={{ width: "90vw" }}>

    //                     <div className='consultant-heading'>
    //                         <h6>Client Name:{projectData?.client_name}</h6>
    //                         <h6>Consultant (AE):{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</h6>
    //                         <h6>GSTIN No:{projectData?.gst_no}</h6>
    //                         <h6>PAN No:{projectData?.pan_no}</h6>
    //                         <h6>Bid Due Submission Date:{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</h6>
    //                         <div className='flex-row justify-between' style={{ width: "86vw" }}>
    //                             <div>
    //                                 <h6>Agreement Date:{formatDateDD_MM_YYYY(projectData?.agreement_date)}</h6>
    //                                 <h6>Project Start Date:{formatDateDD_MM_YYYY(projectData?.commencement_date)}</h6>
    //                             </div>


    //                         </div>
    //                     </div>

    //                 </div>

    //             </div>
    //             {/* <AddSupportStaff id={id} getSupportStaff={getBreakdownCost}/> */}
    //         </div>
    //         <div className='heads-div'>
    //             <h2 className="font-size-1-5rem">9. Road Survey Equipment</h2>
    //         </div>
    //         <div className="flex-row justify-between">

    //             <div style={{ width: "100%" }} className="flex-row justify-end hide-on-print">
    //                 <div>
    //                     {(roadSurveyEquipment.length > 0 && roadsurveyData.length >= 1) && (
    //                         <select
    //                             value={logid}
    //                             onChange={(e) => setLogId(e.target.value)}
    //                             className="dropdown font-size-subheading navbar-inputt"
    //                         >
    //                             <option value="null">
    //                                 BOQ {groupedByRandomChange.length + 1}- {sureveyChange}
    //                             </option>

    //                             {groupedByRandomChange.map(([groupKey, items], index) => {
    //                                 const reasons = [...new Set(
    //                                     items
    //                                         .map(i => i.data?.reason_of_change)
    //                                         .filter(reason =>
    //                                             reason !== null &&
    //                                             reason !== "null" &&
    //                                             reason?.trim() !== ""
    //                                         )
    //                                 )];

    //                                 return (
    //                                     <option key={groupKey} value={index}>
    //                                         BOQ {groupedByRandomChange.length - index}
    //                                         {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
    //                                     </option>
    //                                 );
    //                             })}




    //                         </select>
    //                     )}
    //                 </div>
    //                 {role !== "SiteManagement" &&
    //                     <div className="hide-on-print flex-row">

    //                         <Select
    //                             options={descriptionOption}
    //                             value={
    //                                 filterDescription !== "null"
    //                                     ? descriptionOption.find((item) => item.value === filterDescription)
    //                                     : "null"  // ✅ null instead of "null" - React Select expects null for empty state
    //                             }
    //                             onChange={handleSelectedDescription}
    //                             isClearable
    //                             placeholder="Select Description"
    //                             styles={CSSForFilterDropdown}
    //                         />
    //                         <AddDescription idDescription={idDescription} descriptionList={descriptionData} usedFor="Road Survey" descriptionType="BOQSurvey" projectId={id} />

    //                         <AddRoadSurveyEquipment id={id} getRoadSurveyEquipment={getRoadSurveyEquipment} roadSureveyList={roadSurveyEquipment} />

    //                         <BulkUpdateRoadSurveyData boqSurveyList={selectedGroup} id={id} getData={getRoadSurveyEquipment} getLogData={getLogData} />

    //                     </div>
    //                 }
    //             </div>
    //         </div>

    //         <DescriptionList data={data} />


    //         <table className="nested-table-lightblue">
    //             <thead>

    //                 <tr className='theading'>
    //                     <th className='table-heading-text text-center' rowSpan="4">Sr.No</th>
    //                     <th className='table-heading-text text-center' rowSpan="4">Description</th>
    //                     <th className='table-heading-text text-center' colSpan="4">Contract Values</th>
    //                     {isEotDataTrue &&

    //                         <th
    //                             className="table-heading-text text-center"
    //                             colSpan={eotLengths * 4 || 1}
    //                         >
    //                             Revised Contract Values (after COS/EOT)
    //                         </th>
    //                     }


    //                     {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                         <th className="hide-on-print align-center" rowSpan="4">Action</th>
    //                     }
    //                 </tr>
    //                 <tr className='nested-heading'>
    //                     <th rowSpan="2" className='table-heading-text'>KM</th>
    //                     <th rowSpan="2" className='table-heading-text'>Nos. of times survey to be concluded	</th>
    //                     <th rowSpan="2" className='table-heading-text'>Rate per No. of times* survey to be conducted (Rs.)</th>
    //                     <th rowSpan="2" className='table-heading-text'>Total Amount (Rs.)</th>
    //                     {/* Dynamically add EOT headers */}
    //                     {Array.from({ length: eotLengths }).map((_, idx) => (
    //                         <th key={idx} className="table-heading-text text-center" colSpan={4}>
    //                             {`EOT ${idx + 1}`}
    //                         </th>
    //                     ))}

    //                 </tr>
    //                 <tr className='nested-heading'>
    //                     {Array.from({ length: eotLengths }).map((_, idx) => (
    //                         <React.Fragment key={idx}>
    //                             <th rowSpan="2" className='table-heading-text'>KM</th>
    //                             <th rowSpan="2" className='table-heading-text'>Nos. of times survey to be concluded	</th>
    //                             <th rowSpan="2" className='table-heading-text'>Rate per No. of times* survey to be conducted (Rs.)</th>
    //                             <th rowSpan="2" className='table-heading-text'>Total Amount (Rs.)</th>
    //                         </React.Fragment>
    //                     ))}

    //                 </tr>

    //             </thead>

    //             <tbody>
    //                 {selectedGroup.map((item, index) => (
    //                     <tr key={item.id}>
    //                         <td>{index + 1}</td>
    //                         <td>{item.description ?? item.data?.description}</td>
    //                         {!toggle && <td>{item.KM ?? item.data?.KM}</td>} {/* Only show 'KM' cell if toggle is false */}
    //                         <td>{item.num_of_times_survey_concluded ?? item.data?.num_of_times_survey_concluded}</td>
    //                         <td className="align-right">₹{formatCurrencyIndian(Number(item.rate_per_km_times ?? item.data?.rate_per_km_times))}</td>
    //                         <td className="align-right">
    //                             ₹ {toggle
    //                                 ? formatCurrencyIndian(Number(item.num_of_times_survey_concluded ?? item.data?.num_of_times_survey_concluded) * Number(item.rate_per_km_times ?? item.data?.rate_per_km_times))
    //                                 : formatCurrencyIndian(Number(item.KM ?? item.data?.KM) * Number(item.num_of_times_survey_concluded ?? item.data?.num_of_times_survey_concluded) * Number(item.rate_per_km_times ?? item.data?.rate_per_km_times))
    //                             }
    //                         </td>
    //                         {item.eot_details?.length > 0 ?
    //                             <>
    //                                 {item.eot_details?.map((i) => (
    //                                     <>
    //                                         <td className="align-right">{i.KM} </td>
    //                                         <td className="align-right">{i.num_of_times_survey_concluded} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.rate_per_km_times)} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
    //                                     </>
    //                                 ))}
    //                             </> :
    //                             <>
    //                                 {item.data?.eot_details?.map((i) => (
    //                                     <>
    //                                         <td className="align-right">{i.KM} </td>
    //                                         <td className="align-right">{i.num_of_times_survey_concluded} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.rate_per_km_times)} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.total_amount)} </td>
    //                                     </>
    //                                 ))}
    //                             </>
    //                         }
    //                         {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                             <td className="hide-on-print flex-row  border-single justify-center">
    //                                 {role === "BD" || role === "Account" ? "" :
    //                                     <DeleteRoadSurveyEquipment i={item} getRoadSurveyEquipment={getRoadSurveyEquipment} />
    //                                 }
    //                             </td>
    //                         }
    //                     </tr>
    //                 ))}
    //             </tbody>
    //             <tfoot>
    //                 <tr>
    //                     <td colSpan={toggle ? 4 : 5} className="total-label">Total:</td>
    //                     <td className="align-right">

    //                         ₹ {toggle ?

    //                             formatCurrencyIndian(
    //                                 selectedGroup.reduce((total, item) => {
    //                                     const SUREVYDONE = Number(item.num_of_times_survey_concluded ?? item.data?.num_of_times_survey_concluded ?? 0);
    //                                     const RATEPERSURVEY = Number(item.rate_per_km_times ?? item.data?.rate_per_km_times ?? 0);
    //                                     return total + (SUREVYDONE * RATEPERSURVEY);
    //                                 }, 0)
    //                             )

    //                             :

    //                             formatCurrencyIndian(
    //                                 selectedGroup.reduce((total, item) => {
    //                                     const SUREVYDONE = Number(item.num_of_times_survey_concluded ?? item.data?.num_of_times_survey_concluded ?? 0);
    //                                     const RATEPERSURVEY = Number(item.rate_per_km_times ?? item.data?.rate_per_km_times ?? 0);
    //                                     const LENGTH = Number(item.KM ?? item.data?.KM ?? 0);
    //                                     return total + LENGTH * (SUREVYDONE * RATEPERSURVEY);
    //                                 }, 0)
    //                             )


    //                         }

    //                     </td>
    //                     {isEotDataTrue && (
    //                         <>
    //                             {Array.from({ length: eotLengths }).map((_, eotIdx) => {
    //                                 // sum this EOT index across all employees
    //                                 const subTotal = selectedGroup.reduce((sum, emp) => {
    //                                     const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
    //                                     const eot = details[eotIdx];
    //                                     return sum + (Number(eot?.total_amount) || 0);
    //                                 }, 0);

    //                                 return (
    //                                     <React.Fragment key={eotIdx}>
    //                                         <td colSpan="3" className="total-label"></td>
    //                                         <td className="align-right">
    //                                             ₹{formatCurrencyIndian(subTotal)}
    //                                         </td>
    //                                     </React.Fragment>
    //                                 );
    //                             })}
    //                         </>
    //                     )}
    //                     {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                         <td className="hide-on-print"></td>
    //                     }
    //                 </tr>
    //             </tfoot>
    //         </table>
    //         <p className="note">
    //             * Proportional reduction w.r.t. total length and actual done at site
    //         </p>
    //     </div>
    // );


    return (
        <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>
            <div className="boc-modern-card">

                {/* ===== HEADER SECTION ===== */}
                <div className="boc-modern-header bocx-modern-footer-total">
                    <div className="boc-modern-header-content">
                        <div className="boc-modern-project-info">
                            <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
                            <div className="boc-modern-project-meta">
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Client:</span>
                                    <span className="boc-modern-meta-value">{projectData?.client_name}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Consultant (AE):</span>
                                    <span className="boc-modern-meta-value">
                                        {projectData?.lead}
                                        {projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}
                                        {projectData?.association ? ` Association with ${projectData?.association}` : ""}
                                    </span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">GSTIN:</span>
                                    <span className="boc-modern-meta-value">{projectData?.gst_no}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">PAN:</span>
                                    <span className="boc-modern-meta-value">{projectData?.pan_no}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Bid Due:</span>
                                    <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Agreement:</span>
                                    <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Start:</span>
                                    <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ===== CONTROLS SECTION ===== */}
                <div className="boc-modern-controls-wrapper">
                    <div className="boc-modern-controls">
                        <div className="boc-modern-controls-left">
                            <h3 className="boc-modern-main-heading">9. Road Survey Equipment</h3>
                        </div>
                        {role !== "SiteManagement" && (
                            <div className="boc-modern-controls-right justify-end" style={{ width: "100%" }}>
                                <div className="flex-row justify-end" style={{ width: "24%" }}>
                                    {(roadSurveyEquipment.length > 0 && roadsurveyData.length >= 1) ? (
                                        <div className="boc-modern-control-group">
                                            <label className="boc-modern-control-label">BOQ Version</label>
                                            <select
                                                value={logid}
                                                onChange={(e) => setLogId(e.target.value)}
                                                className="boc-modern-select"
                                            >
                                                <option value="null">
                                                    BOQ {groupedByRandomChange.length + 1}- {sureveyChange}
                                                </option>
                                                {groupedByRandomChange.map(([groupKey, items], index) => {
                                                    const reasons = [...new Set(
                                                        items
                                                            .map(i => i.data?.reason_of_change)
                                                            .filter(reason =>
                                                                reason !== null &&
                                                                reason !== "null" &&
                                                                reason?.trim() !== ""
                                                            )
                                                    )];
                                                    return (
                                                        <option key={groupKey} value={index}>
                                                            BOQ {groupedByRandomChange.length - index}
                                                            {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    ) : (
                                        <div className="boc-modern-control-group"></div>
                                    )}
                                </div>

                                <div className="boc-modern-action-buttons" style={{ float: "right" }}>
                                    <div className="boc-modern-control-group">
                                        <label className="boc-modern-control-label">Description</label>
                                        <Select
                                            options={descriptionOption}
                                            value={
                                                filterDescription !== "null"
                                                    ? descriptionOption.find((item) => item.value === filterDescription)
                                                    : "null"
                                            }
                                            onChange={handleSelectedDescription}
                                            isClearable
                                            placeholder="Select Description"
                                            styles={CSSForSelectModern15VWWidth}
                                        />
                                    </div>

                                    {logid === "null" && (
                                        <>
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                <AddDescription
                                                    idDescription={idDescription}
                                                    descriptionList={descriptionData}
                                                    usedFor="Road Survey"
                                                    descriptionType="BOQSurvey"
                                                    projectId={id}
                                                />
                                            </div>
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                <AddRoadSurveyEquipment
                                                    id={id}
                                                    getRoadSurveyEquipment={getRoadSurveyEquipment}
                                                    roadSureveyList={roadSurveyEquipment}
                                                />
                                            </div>
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                <BulkUpdateRoadSurveyData
                                                    boqSurveyList={selectedGroup}
                                                    id={id}
                                                    getData={getRoadSurveyEquipment}
                                                    getLogData={getLogData}
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ===== DESCRIPTION SECTION ===== */}
                <div className="boc-modern-description-section" style={{ padding: "10px 10px" }}>
                    <DescriptionList data={data} />
                </div>

                {/* ===== TABLE SECTION ===== */}
                <div className="boc-modern-table-wrapper">
                    <div className="boc-modern-table-scroll">
                        <table className="boc-modern-table">
                            <thead>
                                <tr className="boc-modern-table-header">
                                    <th className="boc-modern-th text-center" rowSpan="4">Sr.No</th>
                                    <th className="boc-modern-th text-center" rowSpan="4">Description</th>
                                    <th className="boc-modern-th text-center" colSpan="4">Contract Values</th>
                                    {isEotDataTrue && (
                                        <th className="boc-modern-th text-center" colSpan={eotLengths * 4 || 1}>
                                            Revised Contract Values (after COS/EOT)
                                        </th>
                                    )}
                                    {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                        <th className="boc-modern-th text-center" rowSpan="4">Action</th>
                                    )}
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    <th rowSpan="2" className="boc-modern-th">KM</th>
                                    <th rowSpan="2" className="boc-modern-th">Nos. of times survey to be concluded</th>
                                    <th rowSpan="2" className="boc-modern-th">Rate per No. of times* survey to be conducted (Rs.)</th>
                                    <th rowSpan="2" className="boc-modern-th">Total Amount (Rs.)</th>
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <th key={idx} className="boc-modern-th text-center" colSpan={4}>
                                            {`EOT ${idx + 1}`}
                                        </th>
                                    ))}
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <React.Fragment key={idx}>
                                            <th rowSpan="2" className="boc-modern-th">KM</th>
                                            <th rowSpan="2" className="boc-modern-th">Nos. of times survey to be concluded</th>
                                            <th rowSpan="2" className="boc-modern-th">Rate per No. of times* survey to be conducted (Rs.)</th>
                                            <th rowSpan="2" className="boc-modern-th">Total Amount (Rs.)</th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>

                            {buffer ? (
                                <tbody>
                                    <tr>
                                        <td colSpan="20">
                                            <div className="boc-modern-loading">
                                                <div className="boc-modern-spinner"></div>
                                                <span>Loading data...</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            ) : (
                                <>
                                    <tbody>
                                        {selectedGroup.map((item, index) => (
                                            <tr key={item.id} className="boc-modern-row">
                                                <td className="boc-modern-td text-center">{index + 1}</td>
                                                <td className="boc-modern-td">
                                                    {item.description ?? item.data?.description}
                                                </td>
                                                {!toggle && (
                                                    <td className="boc-modern-td text-right">
                                                        {item.KM ?? item.data?.KM}
                                                    </td>
                                                )}
                                                <td className="boc-modern-td text-right">
                                                    {item.num_of_times_survey_concluded ?? item.data?.num_of_times_survey_concluded}
                                                </td>
                                                <td className="boc-modern-td text-right boc-modern-currency">
                                                    ₹{formatCurrencyIndian(Number(item.rate_per_km_times ?? item.data?.rate_per_km_times))}
                                                </td>
                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-total-highlight">
                                                    ₹{toggle
                                                        ? formatCurrencyIndian(
                                                            Number(item.num_of_times_survey_concluded ?? item.data?.num_of_times_survey_concluded) *
                                                            Number(item.rate_per_km_times ?? item.data?.rate_per_km_times)
                                                        )
                                                        : formatCurrencyIndian(
                                                            Number(item.KM ?? item.data?.KM) *
                                                            Number(item.num_of_times_survey_concluded ?? item.data?.num_of_times_survey_concluded) *
                                                            Number(item.rate_per_km_times ?? item.data?.rate_per_km_times)
                                                        )
                                                    }
                                                </td>
                                                {item.eot_details?.length > 0 ? (
                                                    item.eot_details.map((i, idx) => (
                                                        <React.Fragment key={idx}>
                                                            <td className="boc-modern-td text-right">{i.KM}</td>
                                                            <td className="boc-modern-td text-right">{i.num_of_times_survey_concluded}</td>
                                                            <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(i.rate_per_km_times)}</td>
                                                            <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(i.total_amount)}</td>
                                                        </React.Fragment>
                                                    ))
                                                ) : (
                                                    item.data?.eot_details?.map((i, idx) => (
                                                        <React.Fragment key={idx}>
                                                            <td className="boc-modern-td text-right">{i.KM}</td>
                                                            <td className="boc-modern-td text-right">{i.num_of_times_survey_concluded}</td>
                                                            <td className="boc-modern-td text-right boc-modern-currency">₹{formatCurrencyIndian(i.rate_per_km_times)}</td>
                                                            <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">₹{formatCurrencyIndian(i.total_amount)}</td>
                                                        </React.Fragment>
                                                    ))
                                                )}
                                                {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                    <td className="boc-modern-td text-center">
                                                        {role !== "BD" && role !== "Account" && (
                                                            <DeleteRoadSurveyEquipment i={item} getRoadSurveyEquipment={getRoadSurveyEquipment} />
                                                        )}
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr className="boc-modern-footer">
                                            <td colSpan={toggle ? 4 : 5} className="boc-modern-footer-label">Total:</td>
                                            <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                ₹{toggle
                                                    ? formatCurrencyIndian(
                                                        selectedGroup.reduce((total, item) => {
                                                            const surveys = Number(item.num_of_times_survey_concluded ?? item.data?.num_of_times_survey_concluded ?? 0);
                                                            const rate = Number(item.rate_per_km_times ?? item.data?.rate_per_km_times ?? 0);
                                                            return total + (surveys * rate);
                                                        }, 0)
                                                    )
                                                    : formatCurrencyIndian(
                                                        selectedGroup.reduce((total, item) => {
                                                            const km = Number(item.KM ?? item.data?.KM ?? 0);
                                                            const surveys = Number(item.num_of_times_survey_concluded ?? item.data?.num_of_times_survey_concluded ?? 0);
                                                            const rate = Number(item.rate_per_km_times ?? item.data?.rate_per_km_times ?? 0);
                                                            return total + km * surveys * rate;
                                                        }, 0)
                                                    )
                                                }
                                            </td>
                                            {isEotDataTrue && (
                                                <>
                                                    {Array.from({ length: eotLengths }).map((_, eotIdx) => {
                                                        const subTotal = selectedGroup.reduce((sum, emp) => {
                                                            const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                                                            const eot = details[eotIdx];
                                                            return sum + (Number(eot?.total_amount) || 0);
                                                        }, 0);
                                                        return (
                                                            <React.Fragment key={eotIdx}>
                                                                <td colSpan="3" className="boc-modern-footer-label"></td>
                                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                                    ₹{formatCurrencyIndian(subTotal)}
                                                                </td>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </>
                                            )}
                                            {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                <td className="boc-modern-td"></td>
                                            )}
                                        </tr>
                                    </tfoot>
                                </>
                            )}
                        </table>
                    </div>
                </div>

                <p className="note" style={{ padding: "8px 16px", fontSize: "12px", color: "#718096" }}>
                    * Proportional reduction w.r.t. total length and actual done at site
                </p>

            </div>
        </div>
    );
};

const Contingencies = ({ projectData, idDescription, descriptionData, props, id, contingencies, getContingencies, logData, getLogData, logid, setLogId, groupedByRandomChange, selectedGroup }) => {
    const [buffer, setBuffering] = useState(false);
    const role = sessionStorage.getItem('sitemanagement_role');
    const contingenciesId = contingencies.map(e => e.id);
    const contingenciesChange = contingencies[0]?.reason_of_change || "";
    const contingenciesData = logData.filter(item =>
        contingenciesId.includes(item.object_id)
    );
    const isEotDataTrue = selectedGroup.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );





    const eotLengths = Math.max(
        ...selectedGroup.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );


    const descriptionOption = descriptionData.map((i) => ({
        value: i.id,
        label: i.description_name
    }));


    const [filterDescription, setFilterDescription] = useState("null");

    useEffect(() => {
        if (descriptionOption.length > 0 && filterDescription === "null") {
            setFilterDescription(descriptionOption[descriptionOption.length - 1].value);
        }
    }, [descriptionOption]);

    const handleSelectedDescription = (selectionOption) => {
        if (!selectionOption) {
            setFilterDescription("null");
        }
        else {
            setFilterDescription(selectionOption.value)
        }
    }
    const [data, setData] = useState("");

    useEffect(() => {
        if (!filterDescription || filterDescription === "null") {
            setData("");
        }
        else {
            const filteredData = descriptionData.find((item) => item.id === filterDescription);

            console.log("filteredData", filteredData);
            const descriptionText = filteredData.description_details
            if (filteredData) {
                setData(descriptionText);
            } else {
                setData("");
            }
        }



    }, [filterDescription, descriptionData]);



    // return (
    //     <div className="table-css-background">
    //         <div className='heads-div'>
    //             <h2 className="font-size-1-5rem">10. Contingencies</h2>
    //         </div>
    //         <div className="flex-row justify-between">

    //             <div style={{ width: "100%" }} className="flex-row justify-end hide-on-print">
    //                 <div>
    //                     {(contingencies.length > 0 && contingenciesData.length >= 1) && (
    //                         <select
    //                             value={logid}
    //                             onChange={(e) => setLogId(e.target.value)}
    //                             className="dropdown font-size-subheading navbar-inputt"
    //                         >
    //                             <option value="null">
    //                                 BOQ {groupedByRandomChange.length + 1}- {contingenciesChange}
    //                             </option>

    //                             {groupedByRandomChange.map(([groupKey, items], index) => {
    //                                 const reasons = [...new Set(
    //                                     items
    //                                         .map(i => i.data?.reason_of_change)
    //                                         .filter(reason =>
    //                                             reason !== null &&
    //                                             reason !== "null" &&
    //                                             reason?.trim() !== ""
    //                                         )
    //                                 )];

    //                                 return (
    //                                     <option key={groupKey} value={index}>
    //                                         BOQ {groupedByRandomChange.length - index}
    //                                         {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
    //                                     </option>
    //                                 );
    //                             })}




    //                         </select>
    //                     )}
    //                 </div>
    //                 {role !== "SiteManagement" &&
    //                     <div className="hide-on-print flex-row">
    //                         <Select
    //                             options={descriptionOption}
    //                             value={
    //                                 filterDescription !== "null"
    //                                     ? descriptionOption.find((item) => item.value === filterDescription)
    //                                     : "null"  // ✅ null instead of "null" - React Select expects null for empty state
    //                             }
    //                             onChange={handleSelectedDescription}
    //                             isClearable
    //                             placeholder="Select Description"
    //                             styles={CSSForFilterDropdown}
    //                         />
    //                         <AddDescription idDescription={idDescription} descriptionList={descriptionData} usedFor="Contingencies" descriptionType="BOQContingencies" projectId={id} />

    //                         <AddContingencies id={id} getContingencies={getContingencies} contilist={contingencies} />

    //                         <BulkUpdateContieneous boqContieneousList={selectedGroup} id={id} getData={getContingencies} getLogData={getLogData} />

    //                     </div>
    //                 }
    //             </div>
    //         </div>
    //         <p>
    //             A fixed amount of Indian Rupees ONE MILLION shall be included in the Financial Proposal. The provisions of Contingency shall be operated with the specific approval from the Authority.
    //         </p>
    //         {/* <div className='heads-div'>
    //             <h2 className="font-size-1-5rem">10. Contingencies</h2>
    //             {role !== "SiteManagement" &&
    //                 <div className="hide-on-print">
    //                     <AddContingencies id={id} getContingencies={getContingencies} />
    //                 </div>
    //             }            </div>
    //         <p>
    //             A fixed amount of Indian Rupees ONE MILLION shall be included in the Financial Proposal. The provisions of Contingency shall be operated with the specific approval from the Authority.
    //         </p> */}
    //         <DescriptionList data={data} />

    //         <table className="nested-table-lightblue">
    //             <thead>
    //                 <tr>
    //                     <th className='table-heading-text text-center' rowSpan="4">Sr.No</th>
    //                     <th className='table-heading-text text-center' rowSpan="4">Description</th>
    //                     <th className='table-heading-text text-center' colSpan="2">Contract Values</th>
    //                     {isEotDataTrue &&

    //                         <th
    //                             className="table-heading-text text-center"
    //                             colSpan={eotLengths * 2 || 1}
    //                         >
    //                             Revised Contract Values (after COS/EOT)
    //                         </th>
    //                     }


    //                     {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                         <th className="hide-on-print align-center" rowSpan="4">Action</th>
    //                     }
    //                 </tr>
    //                 <tr className='nested-heading'>
    //                     <th rowSpan="2" className='table-heading-text'>Unit</th>
    //                     <th rowSpan="2" className='table-heading-text'>Amount	</th>
    //                     {Array.from({ length: eotLengths }).map((_, idx) => (
    //                         <th key={idx} className="table-heading-text text-center" colSpan={2}>
    //                             {`EOT ${idx + 1}`}
    //                         </th>
    //                     ))}

    //                 </tr>
    //                 <tr className='nested-heading'>
    //                     {Array.from({ length: eotLengths }).map((_, idx) => (
    //                         <React.Fragment key={idx}>
    //                             <th rowSpan="2" className='table-heading-text'>Unit</th>
    //                             <th rowSpan="2" className='table-heading-text'>Amount	</th>
    //                         </React.Fragment>
    //                     ))}

    //                 </tr>
    //             </thead>
    //             <tbody>
    //                 {selectedGroup.map((item, index) => (
    //                     <tr key={item.id}>
    //                         <td>{index + 1}</td>
    //                         <td>{item.description ?? item.data.description}</td>
    //                         <td>{item.unit ?? item.data.unit}</td>
    //                         <td className="align-right">₹{formatCurrencyIndian(item.ammount ?? item.data.ammount)}</td>
    //                         {item.eot_details?.length > 0 ?
    //                             <>
    //                                 {item.eot_details?.map((i) => (
    //                                     <>
    //                                         <td className="align-right">{i.unit} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.ammount)} </td>
    //                                     </>
    //                                 ))}
    //                             </> :
    //                             <>
    //                                 {item.data?.eot_details?.map((i) => (
    //                                     <>
    //                                         <td className="align-right">{i.unit} </td>
    //                                         <td className="align-right">₹{formatCurrencyIndian(i.ammount)} </td>
    //                                     </>
    //                                 ))}
    //                             </>
    //                         }
    //                         {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                             <td className="hide-on-print flex-row  border-single justify-center">
    //                                 {role === "BD" || role === "Account" ? "" :
    //                                     <DeleteUpdateContingenciest i={item} getContingencies={getContingencies} />
    //                                 }
    //                             </td>
    //                         }
    //                     </tr>
    //                 ))}
    //             </tbody>
    //             <tfoot>
    //                 <tr>
    //                     <td colSpan="3" className="total-label">Total:</td>
    //                     <td className="align-right">
    //                         ₹{formatCurrencyIndian(selectedGroup.reduce((total, item) => total + parseFloat(item.ammount ?? item.data.ammount), 0))}
    //                     </td>
    //                     {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                         <td className="hide-on-print"></td>
    //                     }
    //                     {isEotDataTrue && (
    //                         <>
    //                             {Array.from({ length: eotLengths }).map((_, eotIdx) => {
    //                                 // sum this EOT index across all employees
    //                                 const subTotal = selectedGroup.reduce((sum, emp) => {
    //                                     const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
    //                                     const eot = details[eotIdx];
    //                                     return sum + (Number(eot?.ammount) || 0);
    //                                 }, 0);

    //                                 return (
    //                                     <React.Fragment key={eotIdx}>
    //                                         <td className="align-right">
    //                                             ₹{formatCurrencyIndian(subTotal)}
    //                                         </td>
    //                                     </React.Fragment>
    //                                 );
    //                             })}

    //                         </>
    //                     )}
    //                     {(role !== "SiteManagement" && logid === "null" && role !== "Checker") &&
    //                         <td className="hide-on-print"></td>
    //                     }
    //                 </tr>

    //             </tfoot>
    //         </table>
    //     </div>
    // );

    return (
        <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>
            <div className="boc-modern-card">

                {/* ===== HEADER SECTION ===== */}
                <div className="boc-modern-header bocx-modern-footer-total">
                    <div className="boc-modern-header-content">
                        <div className="boc-modern-project-info">
                            <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
                            <div className="boc-modern-project-meta">
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Client:</span>
                                    <span className="boc-modern-meta-value">{projectData?.client_name}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Consultant (AE):</span>
                                    <span className="boc-modern-meta-value">
                                        {projectData?.lead}
                                        {projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}
                                        {projectData?.association ? ` Association with ${projectData?.association}` : ""}
                                    </span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">GSTIN:</span>
                                    <span className="boc-modern-meta-value">{projectData?.gst_no}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">PAN:</span>
                                    <span className="boc-modern-meta-value">{projectData?.pan_no}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Bid Due:</span>
                                    <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Agreement:</span>
                                    <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Start:</span>
                                    <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ===== CONTROLS SECTION ===== */}
                <div className="boc-modern-controls-wrapper">
                    <div className="boc-modern-controls">
                        <div className="boc-modern-controls-left">
                            <h3 className="boc-modern-main-heading">10. Contingencies</h3>
                        </div>
                        {role !== "SiteManagement" && (
                            <div className="boc-modern-controls-right justify-end" style={{ width: "100%" }}>
                                <div className="flex-row justify-end" style={{ width: "24%" }}>
                                    {(contingencies.length > 0 && contingenciesData.length >= 1) ? (
                                        <div className="boc-modern-control-group">
                                            <label className="boc-modern-control-label">BOQ Version</label>
                                            <select
                                                value={logid}
                                                onChange={(e) => setLogId(e.target.value)}
                                                className="boc-modern-select"
                                            >
                                                <option value="null">
                                                    BOQ {groupedByRandomChange.length + 1}- {contingenciesChange}
                                                </option>
                                                {groupedByRandomChange.map(([groupKey, items], index) => {
                                                    const reasons = [...new Set(
                                                        items
                                                            .map(i => i.data?.reason_of_change)
                                                            .filter(reason =>
                                                                reason !== null &&
                                                                reason !== "null" &&
                                                                reason?.trim() !== ""
                                                            )
                                                    )];
                                                    return (
                                                        <option key={groupKey} value={index}>
                                                            BOQ {groupedByRandomChange.length - index}
                                                            {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    ) : (
                                        <div className="boc-modern-control-group"></div>
                                    )}
                                </div>

                                <div className="boc-modern-action-buttons" style={{ float: "right" }}>
                                    <div className="boc-modern-control-group">
                                        <label className="boc-modern-control-label">Description</label>
                                        <Select
                                            options={descriptionOption}
                                            value={
                                                filterDescription !== "null"
                                                    ? descriptionOption.find((item) => item.value === filterDescription)
                                                    : "null"
                                            }
                                            onChange={handleSelectedDescription}
                                            isClearable
                                            placeholder="Select Description"
                                            styles={CSSForSelectModern15VWWidth}
                                        />
                                    </div>

                                    {logid === "null" && (
                                        <>
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                <AddDescription
                                                    idDescription={idDescription}
                                                    descriptionList={descriptionData}
                                                    usedFor="Contingencies"
                                                    descriptionType="BOQContingencies"
                                                    projectId={id}
                                                />
                                            </div>
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                <AddContingencies
                                                    id={id}
                                                    getContingencies={getContingencies}
                                                    contilist={contingencies}
                                                />
                                            </div>
                                            <div className="boc-modern-control-group">
                                                <label className="boc-modern-control-label" style={{ marginBottom: "15px" }}></label>
                                                <BulkUpdateContieneous
                                                    boqContieneousList={selectedGroup}
                                                    id={id}
                                                    getData={getContingencies}
                                                    getLogData={getLogData}
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ===== NOTE SECTION ===== */}
                <div style={{ padding: "8px 20px 0px 20px" }}>
                    <p style={{ fontSize: "13px", color: "#4a5568", margin: "0" }}>
                        A fixed amount of Indian Rupees ONE MILLION shall be included in the Financial Proposal.
                        The provisions of Contingency shall be operated with the specific approval from the Authority.
                    </p>
                </div>

                {/* ===== DESCRIPTION SECTION ===== */}
                <div className="boc-modern-description-section" style={{ padding: "10px 10px" }}>
                    <DescriptionList data={data} />
                </div>

                {/* ===== TABLE SECTION ===== */}
                <div className="boc-modern-table-wrapper">
                    <div className="boc-modern-table-scroll">
                        <table className="boc-modern-table">
                            <thead>
                                <tr className="boc-modern-table-header">
                                    <th className="boc-modern-th text-center" rowSpan="4">Sr.No</th>
                                    <th className="boc-modern-th text-center" rowSpan="4">Description</th>
                                    <th className="boc-modern-th text-center" colSpan="2">Contract Values</th>
                                    {isEotDataTrue && (
                                        <th className="boc-modern-th text-center" colSpan={eotLengths * 2 || 1}>
                                            Revised Contract Values (after COS/EOT)
                                        </th>
                                    )}
                                    {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                        <th className="boc-modern-th text-center" rowSpan="4">Action</th>
                                    )}
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    <th rowSpan="2" className="boc-modern-th">Unit</th>
                                    <th rowSpan="2" className="boc-modern-th">Amount</th>
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <th key={idx} className="boc-modern-th text-center" colSpan={2}>
                                            {`EOT ${idx + 1}`}
                                        </th>
                                    ))}
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <React.Fragment key={idx}>
                                            <th rowSpan="2" className="boc-modern-th">Unit</th>
                                            <th rowSpan="2" className="boc-modern-th">Amount</th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>

                            {buffer ? (
                                <tbody>
                                    <tr>
                                        <td colSpan="20">
                                            <div className="boc-modern-loading">
                                                <div className="boc-modern-spinner"></div>
                                                <span>Loading data...</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            ) : (
                                <>
                                    <tbody>
                                        {selectedGroup.map((item, index) => (
                                            <tr key={item.id} className="boc-modern-row">
                                                <td className="boc-modern-td text-center">{index + 1}</td>
                                                <td className="boc-modern-td">
                                                    {item.description ?? item.data?.description}
                                                </td>
                                                <td className="boc-modern-td text-right">
                                                    {item.unit ?? item.data?.unit}
                                                </td>
                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-total-highlight">
                                                    ₹{formatCurrencyIndian(item.ammount ?? item.data?.ammount)}
                                                </td>
                                                {item.eot_details?.length > 0 ? (
                                                    item.eot_details.map((i, idx) => (
                                                        <React.Fragment key={idx}>
                                                            <td className="boc-modern-td text-right">{i.unit}</td>
                                                            <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">
                                                                ₹{formatCurrencyIndian(i.ammount)}
                                                            </td>
                                                        </React.Fragment>
                                                    ))
                                                ) : (
                                                    item.data?.eot_details?.map((i, idx) => (
                                                        <React.Fragment key={idx}>
                                                            <td className="boc-modern-td text-right">{i.unit}</td>
                                                            <td className="boc-modern-td text-right boc-modern-currency boc-modern-eot-total">
                                                                ₹{formatCurrencyIndian(i.ammount)}
                                                            </td>
                                                        </React.Fragment>
                                                    ))
                                                )}
                                                {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                    <td className="boc-modern-td text-center">
                                                        {role !== "BD" && role !== "Account" && (
                                                            <DeleteUpdateContingenciest
                                                                i={item}
                                                                getContingencies={getContingencies}
                                                            />
                                                        )}
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr className="boc-modern-footer">
                                            <td colSpan="3" className="boc-modern-footer-label">Total:</td>
                                            <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(
                                                    selectedGroup.reduce((total, item) =>
                                                        total + parseFloat(item.ammount ?? item.data?.ammount ?? 0), 0)
                                                )}
                                            </td>
                                            {isEotDataTrue && (
                                                <>
                                                    {Array.from({ length: eotLengths }).map((_, eotIdx) => {
                                                        const subTotal = selectedGroup.reduce((sum, emp) => {
                                                            const details = emp.eot_details?.length > 0
                                                                ? emp.eot_details
                                                                : emp.data?.eot_details || [];
                                                            const eot = details[eotIdx];
                                                            return sum + (Number(eot?.ammount) || 0);
                                                        }, 0);
                                                        return (
                                                            <React.Fragment key={eotIdx}>
                                                                <td className="boc-modern-footer-label"></td>
                                                                <td className="boc-modern-td text-right boc-modern-currency boc-modern-footer-total">
                                                                    ₹{formatCurrencyIndian(subTotal)}
                                                                </td>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </>
                                            )}
                                            {(role !== "SiteManagement" && logid === "null" && role !== "Checker") && (
                                                <td className="boc-modern-td"></td>
                                            )}
                                        </tr>
                                    </tfoot>
                                </>
                            )}
                        </table>
                    </div>
                </div>

            </div>
        </div>
    );
};









const PrintBOQformat = React.forwardRef((props, ref) => {
    let { id } = useParams();
    const projectID = sessionStorage.getItem('sitemanagement_project')
    console.log("props")
    console.log(props)

    const [projectbyid, setprojectbyid] = useState({});
    const getProjectById = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/project/${id ? id : projectID}/`);
            setprojectbyid(response.data);
        } catch (error) {
            console.error("Error fetching project by ID:", error);
            handleErrorToast(error);
        }
    };

    useEffect(() => {
        getProjectById();
    }, [id, projectID]);

    const [logChange, setlogChange] = useState([]);
    const getLogData = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/unifiedChangeLog/`);
            setlogChange(
                [...res.data].sort((a, b) => {
                    const dateA = new Date(a.data.created_at);
                    const dateB = new Date(b.data.created_at);
                    return dateB - dateA; // descending
                })
            );


        } catch (error) {
            console.error("Error fetching Log cost", error);

        }
    };

    useEffect(() => {
        getLogData();
    }, []);

    const filterBOQEmployeeeLogChange = logChange.filter(i => i.model_name === "BOQEmployee" && (i.data.project === id || i.data.project === projectID));
    const filterBOQTransportationLogChange = logChange.filter(i => i.model_name === "BOQTransportation" && (i.data.project === id || i.data.project === projectID));
    const filterBOQOfficeFurnitureAndEquipmentLogChange = logChange.filter(i => i.model_name === "BOQOfficeFurnitureAndEquipment" && (i.data.project === id || i.data.project === projectID));
    const filterBOQDutyTravelLogChange = logChange.filter(i => i.model_name === "BOQDutyTravel" && (i.data.project === id || i.data.project === projectID));
    const filterBOQOfficeSuppliesLogChange = logChange.filter(i => i.model_name === "BOQOfficeSupplies" && (i.data.project === id || i.data.project === projectID));
    const filterBOQReportsAndDocumentPrintingLogChange = logChange.filter(i => i.model_name === "BOQReportsAndDocumentPrinting" && (i.data.project === id || i.data.project === projectID));
    const filterBOQOfficeRentLogChange = logChange.filter(i => i.model_name === "BOQOfficeRent" && (i.data.project === id || i.data.project === projectID));
    const filterBOQRoadSurveyEquipmentLogChange = logChange.filter(i => i.model_name === "BOQRoadSurveyEquipment" && (i.data.project === id || i.data.project === projectID));
    const filterBOQContingenciesLogChange = logChange.filter(i => i.model_name === "BOQContingencies" && (i.data.project === id || i.data.project === projectID));
    const [buffer, setBuffering] = useState(false);
    const [buffer1, setBuffering1] = useState(false);



    const [breakdown, setBreakdown] = useState([]);
    const [index, setIndex] = useState("")
    const getBreakdownCost = async () => {
        setBuffering(true);

        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqemployeebyproject/${projectID ? projectID : id}/`
            );
            const professionPriority = {
                "Key Professional": 1,
                "Sub Professional": 2,
                "Support Staff": 3,
            };

            setBreakdown([...res.data].sort((a, b) => {
                const priorityA = professionPriority[a.professional_type] || 4;
                const priorityB = professionPriority[b.professional_type] || 4;

                if (priorityA !== priorityB) {
                    return priorityA - priorityB; // lower value means higher priority
                }

                // If same profession type, sort by created_at descending
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                return dateB - dateA;
            }));

        } catch (err) {
            console.error("Error fetching breakdown cost", err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getBreakdownCost();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const [transportation, setTransportation] = useState([]);

    const getTransportation = async () => {
        setBuffering1(true);

        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqtransportbyproject/${projectID ? projectID : id}/`);
            setTransportation([...res.data].sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                return dateB - dateA; // descending
            }));


        } catch (err) { }
        finally {
            setBuffering1(false);
        }
    };

    useEffect(() => {

        // getdocument();
        getTransportation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [employee, setEmployee] = useState([]);
    const getEmployee = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqemployeebyproject/${projectID ? projectID : id}/`);
            setEmployee([...res.data].sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                return dateB - dateA; // descending
            }));
        } catch (err) { }
    };

    useEffect(() => {
        getEmployee();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const [dutyTravel, setDutyTravel] = useState([]);

    const getDutyTravel = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqtravelbyproject/${projectID ? projectID : id}/`
            );
            setDutyTravel([...res.data].sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                return dateB - dateA; // descending
            }));
        } catch (err) { }
    };

    useEffect(() => {

        // getdocument();
        getDutyTravel();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const [officeRent, setOfficeRent] = useState([]);

    const getOfficeRent = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqofficerentbyproject/${projectID ? projectID : id}/`
            );
            setOfficeRent([...res.data].sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                return dateB - dateA; // descending
            }));
        } catch (err) { }
    };

    useEffect(() => {

        // getdocument();
        getOfficeRent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const [officeSupplies, setOfficeSupplies] = useState([]);

    const getOfficeSupplies = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqofficesuppliesbyproject/${projectID ? projectID : id}/`);
            setOfficeSupplies([...res.data].sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                return dateB - dateA; // descending
            }));
        } catch (err) { }
    };

    useEffect(() => {

        // getdocument();
        getOfficeSupplies();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const [officeFurniture, setOfficeFurniture] = useState([]);
    const [officeFurnitureheading, setOfficeFurnitureheading] = useState([]);

    const getOfficeFurniture = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqofficefurnitureandequipmentbyproject/${projectID ? projectID : id}/`);
            setOfficeFurniture([...res.data].sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                return dateB - dateA; // descending
            }));
        } catch (err) { }
    };

    const getOfficeFurnitureheading = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqheadingtablebyproject/${projectID ? projectID : id}/`);
            setOfficeFurnitureheading([...res.data].sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                return dateB - dateA; // descending
            }));
        } catch (err) { }
    };
    useEffect(() => {

        // getdocument();
        getOfficeFurniture();
        getOfficeFurnitureheading();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const [reportsPrinting, setReportsPrinting] = useState([]);

    const getReportsPrinting = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqreportsanddocprintbyproject/${projectID ? projectID : id}/`);
            setReportsPrinting([...res.data].sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                return dateB - dateA; // descending
            }));
        } catch (err) { }
    };

    useEffect(() => {

        // getdocument();
        getReportsPrinting();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const [roadSurveyEquipment, setRoadSurveyEquipment] = useState([]);
    const [toggle, settoggle] = useState(false);

    const getRoadSurveyEquipment = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqroadsurveyequipmentbyproject/${projectID ? projectID : id}/`
            );
            setRoadSurveyEquipment([...res.data].sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                return dateB - dateA; // descending
            }));
            settoggle(res.data.some(road => Number(road.KM) === 0))

        } catch (err) { }
    };

    useEffect(() => {
        getRoadSurveyEquipment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toggle]);



    const [contingencies, setContingencies] = useState([]);

    const getContingencies = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqcontingenciesbyproject/${projectID ? projectID : id}/`
            );
            setContingencies([...res.data].sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                return dateB - dateA; // descending
            }));
        } catch (err) { }
    };

    useEffect(() => {

        // getdocument();
        getContingencies();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // ***************************** Merge Data*********************************************

    const brakdownList = breakdown.filter(e => e.professional_type === "Key Professional");
    const breakdownIds = brakdownList.map(e => e.id);
    const [logid, setLogId] = useState("null");
    const [transportLogid, settransportLogId] = useState("null");
    const [dutyTravelLogid, setdutyTravelLogId] = useState("null");
    const [rentLogid, setRentLogId] = useState("null");
    const [suppliesLogid, setsuppliesLogid] = useState("null");
    const [furniturelogid, setfurnitureLogId] = useState("null");
    const [reportlogid, setreportLogId] = useState("null");
    const [roadSurveylogid, setroadSurveyLogId] = useState("null");
    const [Contingencieslogid, setContingenciesLogId] = useState("null");


    const keyProfessional = filterBOQEmployeeeLogChange.filter(
        i => i.data.professional_type === "Key Professional" &&
            breakdownIds.includes(i.object_id)
    );

    const groupedByRandomChange = Object.entries(
        keyProfessional.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup = logid === "null" ? brakdownList : groupedByRandomChange[parseInt(logid)]?.[1] || [];
    const isEotDataTrue = selectedGroup.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );

    const eotLengths = Math.max(
        ...selectedGroup.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );





    const subProfessionalList = breakdown.filter(e => e.professional_type === "Sub Professional");
    const subProfessionalIds = subProfessionalList.map(e => e.id);

    const subProfessional = filterBOQEmployeeeLogChange.filter(
        i => i.data.professional_type === "Sub Professional" &&
            subProfessionalIds.includes(i.object_id)
    );

    const groupedByRandomChangeSub = Object.entries(
        subProfessional.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroupsub = logid === "null" ? subProfessionalList : groupedByRandomChangeSub[parseInt(logid)]?.[1] || [];

    const isEotDataSubTrue = selectedGroupsub.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );

    const eotSubLengths = Math.max(
        ...selectedGroupsub.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );

    const supportStaffList = breakdown.filter(e => e.professional_type === "Support Staff");
    const supportStaffIds = supportStaffList.map(e => e.id);

    const supportStaff = filterBOQEmployeeeLogChange.filter(
        i => i.data.professional_type === "Support Staff" &&
            supportStaffIds.includes(i.object_id)
    );

    const groupedByRandomChangeSupport = Object.entries(
        supportStaff.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroupsupport = logid === "null" ? supportStaffList : groupedByRandomChangeSupport[parseInt(logid)]?.[1] || [];



    const transportID = transportation.map(e => e.id);


    const transportData = filterBOQTransportationLogChange.filter(item =>
        transportID.includes(item.object_id)
    );


    const groupedByRandomChangeTransport = Object.entries(
        transportData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroupTransPort = transportLogid === "null"
        ? transportation
        : groupedByRandomChangeTransport[parseInt(transportLogid)]?.[1] || [];



    const dutyTravelID = dutyTravel.map(e => e.id);

    const dutyTravelData = filterBOQDutyTravelLogChange.filter(item =>
        dutyTravelID.includes(item.object_id)
    );

    const groupedByRandomChangeDuty = Object.entries(
        dutyTravelData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroupDuty = dutyTravelLogid === "null" ? dutyTravel : groupedByRandomChangeDuty[parseInt(dutyTravelLogid)]?.[1] || [];


    const officeRentId = officeRent.map(e => e.id);
    const officeRentData = filterBOQOfficeRentLogChange.filter(item => officeRentId.includes(item.object_id));


    const groupedByRandomChangeOfficeRent = Object.entries(
        officeRentData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroupRent = rentLogid === "null" ? officeRent : groupedByRandomChangeOfficeRent[parseInt(rentLogid)]?.[1] || [];


    const officeSuppliesId = officeSupplies.map(e => e.id);


    const officeSuppliesData = filterBOQOfficeSuppliesLogChange.filter(item =>
        officeSuppliesId.includes(item.object_id)
    );


    const groupedByRandomChangeSupplies = Object.entries(
        officeSuppliesData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroupSupplies = suppliesLogid === "null" ? officeSupplies : groupedByRandomChangeSupplies[parseInt(suppliesLogid)]?.[1] || [];

    const officeFurnitureId = officeFurniture.map(e => e.id);


    const officeFurnitureData = filterBOQOfficeFurnitureAndEquipmentLogChange.filter(item =>
        officeFurnitureId.includes(item.object_id)
    );


    const groupedByRandomChangeFurniture = Object.entries(
        officeFurnitureData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroupFurniture = furniturelogid === "null"
        ? officeFurniture
        : groupedByRandomChangeFurniture[parseInt(furniturelogid)]?.[1] || [];

    const reportId = reportsPrinting.map(e => e.id);
    const reportChange = reportsPrinting[0]?.reason_of_change || "";


    const reportData = filterBOQReportsAndDocumentPrintingLogChange.filter(item =>
        reportId.includes(item.object_id)
    );


    const groupedByRandomChangeReports = Object.entries(
        reportData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroupReport = reportlogid === "null" ? reportsPrinting : groupedByRandomChangeReports[parseInt(reportlogid)]?.[1] || [];

    const roadsurveyId = roadSurveyEquipment.map(e => e.id);

    const roadsurveyData = filterBOQRoadSurveyEquipmentLogChange.filter(item =>
        roadsurveyId.includes(item.object_id)
    );


    const groupedByRandomChangeRoadSurvey = Object.entries(
        roadsurveyData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroupRoadSurvey = roadSurveylogid === "null"
        ? roadSurveyEquipment
        : groupedByRandomChangeRoadSurvey[parseInt(roadSurveylogid)]?.[1] || [];


    const ContingenciesId = contingencies.map(e => e.id);

    const ContingenciesData = filterBOQContingenciesLogChange.filter(item =>
        ContingenciesId.includes(item.object_id)
    );


    const groupedByRandomChangeContingencies = Object.entries(
        ContingenciesData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroupContingencies = Contingencieslogid === "null"
        ? contingencies
        : groupedByRandomChangeContingencies[parseInt(Contingencieslogid)]?.[1] || [];


    const KeyPROFESSIONALTotal = selectedGroup.reduce((total, item) => {
        const rate = Number(item.rate ?? item.data?.rate ?? 0);
        const mmConstruction = Number(item.MM_construction_period ?? item.data?.MM_construction_period ?? 0);
        const mmOM = Number(item.MM_OM_period ?? item.data?.MM_OM_period ?? 0);
        return total + rate * (mmConstruction + mmOM);
    }, 0)
    let eotSubTotals = [];

    if (isEotDataTrue) {
        eotSubTotals = Array.from({ length: eotLengths }).map((_, eotIdx) => {
            // sum this EOT index across all employees
            return selectedGroup.reduce((sum, emp) => {
                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                const eot = details[eotIdx];
                return sum + (Number(eot?.total_amount) || 0);
            }, 0);
        });
    }














    console.log("KeyPROFESSIONALeotTotal", eotSubTotals);

    const SubProfessionalTotal = selectedGroupsub.reduce((total, item) => {
        const rate = Number(item.rate ?? item.data?.rate ?? 0);
        const mmConstruction = Number(item.MM_construction_period ?? item.data?.MM_construction_period ?? 0);
        const mmOM = Number(item.MM_OM_period ?? item.data?.MM_OM_period ?? 0);
        return total + rate * (mmConstruction + mmOM);
    }, 0)

    let eotSubProfessionalTotals = [];

    if (isEotDataSubTrue) {
        eotSubProfessionalTotals = Array.from({ length: eotSubLengths }).map((_, eotIdx) => {
            // sum this EOT index across all employees
            return selectedGroupsub.reduce((sum, emp) => {
                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                const eot = details[eotIdx];
                return sum + (Number(eot?.total_amount) || 0);
            }, 0);
        });
    }

    console.log("SubPROFESSIONALeotTotal", eotSubProfessionalTotals);

    const maxLength = Math.max(
        eotLengths,
        eotSubLengths
    );

    const total = Array.from({ length: maxLength }, (_, idx) => {
        const keyVal = eotSubTotals[idx] || 0;
        const subVal = eotSubProfessionalTotals[idx] || 0;
        return keyVal + subVal;
    });

    console.log(total);


    const SupportStaffTotal = selectedGroupsupport.reduce((total, item) => {
        const rate = Number(item.rate ?? item.data?.rate ?? 0);
        const mmConstruction = Number(item.MM_construction_period ?? item.data?.MM_construction_period ?? 0);
        const mmOM = Number(item.MM_OM_period ?? item.data?.MM_OM_period ?? 0);
        return total + rate * (mmConstruction + mmOM);
    }, 0)


    const isEotSupportDataTrue = selectedGroupsupport.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );

    const eotSupportLengths = Math.max(
        ...selectedGroupsupport.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );


    let eotSupportStaffTotals = [];

    if (isEotSupportDataTrue) {
        eotSupportStaffTotals = Array.from({ length: eotSupportLengths }).map((_, eotIdx) => {
            // sum this EOT index across all employees
            return selectedGroupsupport.reduce((sum, emp) => {
                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                const eot = details[eotIdx];
                return sum + (Number(eot?.total_amount) || 0);
            }, 0);
        });
    }

    console.log("SupportStaff Total", eotSupportStaffTotals);
    const TransportationTotal = selectedGroupTransPort.reduce((total, item) => {
        const rate = Number(item.rate ?? item.data?.rate ?? 0);
        const mmConstruction = Number(item.during_construction_period ?? item.data?.during_construction_period ?? 0);
        const mmOM = Number(item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period ?? 0);
        return total + rate * (mmConstruction + mmOM);
    }, 0)





    const DutyTotal = selectedGroupDuty.reduce((total, item) => {
        const rate = Number(item.rate_per_trip ?? item.data?.rate_per_trip ?? 0);
        const totalTrips = Number(item.num_of_min_trip ?? item.data?.num_of_min_trip ?? 0);
        return total + (rate * totalTrips);
    }, 0)
    const isEotDutyTrue = selectedGroupDuty.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );

    const eotDutyLength = Math.max(
        ...selectedGroupDuty.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );


    let eotTotalduty = [];

    if (isEotDutyTrue) {
        eotTotalduty = Array.from({ length: eotDutyLength }).map((_, eotIdx) => {
            // sum this EOT index across all employees
            return selectedGroupDuty.reduce((sum, emp) => {
                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                const eot = details[eotIdx];
                return sum + (Number(eot?.total_amount) || 0);
            }, 0);
        });
    }

    console.log("Eot Total", eotTotalduty);

    const OfficeRentTotal = selectedGroupRent.reduce((total, item) => {
        const rate = Number(item.rate_per_month ?? item.data?.rate_per_month ?? 0);
        const months = Number(item.num_of_months ?? item.data?.num_of_months ?? 0);
        return total + (rate * months);
    }, 0)

    const isEotRentTrue = selectedGroupRent.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );

    const eotRentLength = Math.max(
        ...selectedGroupRent.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );


    let eotTotalRent = [];

    if (isEotRentTrue) {
        eotTotalRent = Array.from({ length: eotRentLength }).map((_, eotIdx) => {
            // sum this EOT index across all employees
            return selectedGroupRent.reduce((sum, emp) => {
                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                const eot = details[eotIdx];
                return sum + (Number(eot?.total_amount) || 0);
            }, 0);
        });
    }

    console.log("Eot Rent Total", eotTotalRent);

    const OfficeSupplies = selectedGroupSupplies.reduce((total, item) => {
        const rate = Number(item.monthly_rate ?? item.data?.monthly_rate ?? 0);
        const months = Number(item.months ?? item.data?.months ?? 0);
        return total + (rate * months);
    }, 0)

    const isEotSuppliesTrue = selectedGroupSupplies.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );

    const eotSuppliesLength = Math.max(
        ...selectedGroupSupplies.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );


    let eotTotalSupplies = [];

    if (isEotSuppliesTrue) {
        eotTotalSupplies = Array.from({ length: eotSuppliesLength }).map((_, eotIdx) => {
            // sum this EOT index across all employees
            return selectedGroupSupplies.reduce((sum, emp) => {
                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                const eot = details[eotIdx];
                return sum + (Number(eot?.total_amount) || 0);
            }, 0);
        });
    }

    console.log("Eot Total", eotTotalSupplies);
    const OfficeFurnitureTotal = selectedGroupFurniture.reduce((total, item) => {
        const rate = Number(item.rate_per_month ?? item.data?.rate_per_month ?? 0);
        const months = Number(item.num_of_months ?? item.data?.num_of_months ?? 0);
        return total + (rate * months);
    }, 0)


    const isEotFurnitureTrue = selectedGroupFurniture.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );

    const eotFurnitureLength = Math.max(
        ...selectedGroupFurniture.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );


    let eotTotalFurniture = [];

    if (isEotFurnitureTrue) {
        eotTotalFurniture = Array.from({ length: eotFurnitureLength }).map((_, eotIdx) => {
            // sum this EOT index across all employees
            return selectedGroupFurniture.reduce((sum, emp) => {
                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                const eot = details[eotIdx];
                return sum + (Number(eot?.total_amount) || 0);
            }, 0);
        });
    }

    console.log("Eot Total", eotTotalFurniture);

    const Reportsprinting = selectedGroupReport.reduce((total, item) => {
        const rate = Number(item.rate_per_copy ?? item.data?.rate_per_copy ?? 0);
        const Reports = Number(item.num_of_reports ?? item.data?.num_of_reports ?? 0);
        const Copies = Number(item.num_of_copies_per_report ?? item.data?.num_of_copies_per_report ?? 0);
        return total + rate * (Reports * Copies);
    }, 0)


    const isEotReportTrue = selectedGroupReport.some(i =>
        (i.revised?.length > 0) || (i.data?.revised?.length > 0)
    );

    const eotReportLength = Math.max(
        ...selectedGroupReport.map(i => i?.revised?.length || i?.data?.revised?.length || 0),
        0
    );


    let eotTotalReports = [];

    if (isEotReportTrue) {
        eotTotalReports = Array.from({ length: eotReportLength }).map((_, eotIdx) => {
            // sum this EOT index across all employees
            return selectedGroupReport.reduce((sum, emp) => {
                const details = emp.revised?.length > 0 ? emp.revised : emp.data?.revised || [];
                const eot = details[eotIdx];
                return sum + (Number(eot?.total_amount) || 0);
            }, 0);
        });
    }

    const RoadSurveyEquipmentTotal = toggle ? selectedGroupRoadSurvey.reduce((total, item) => {
        const SUREVYDONE = Number(item.num_of_times_survey_concluded ?? item.data?.num_of_times_survey_concluded ?? 0);
        const RATEPERSURVEY = Number(item.rate_per_km_times ?? item.data?.rate_per_km_times ?? 0);
        return total + (SUREVYDONE * RATEPERSURVEY);
    }, 0)
        :
        selectedGroupRoadSurvey.reduce((total, item) => {
            const SUREVYDONE = Number(item.num_of_times_survey_concluded ?? item.data?.num_of_times_survey_concluded ?? 0);
            const RATEPERSURVEY = Number(item.rate_per_km_times ?? item.data?.rate_per_km_times ?? 0);
            const LENGTH = Number(item.KM ?? item.data?.KM ?? 0);
            return total + LENGTH * (SUREVYDONE * RATEPERSURVEY);
        }, 0)

    const isEotSurveyTrue = selectedGroupRoadSurvey.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );

    const eotSurveyLength = Math.max(
        ...selectedGroupRoadSurvey.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );


    let eotTotalSurvey = [];

    if (isEotSurveyTrue) {
        eotTotalSurvey = Array.from({ length: eotSurveyLength }).map((_, eotIdx) => {
            // sum this EOT index across all employees
            return selectedGroupRoadSurvey.reduce((sum, emp) => {
                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                const eot = details[eotIdx];
                return sum + (Number(eot?.total_amount) || 0);
            }, 0);
        });
    }

    console.log("Eot Total", eotTotalSurvey);

    const ContingenciesTotal = selectedGroupContingencies.reduce((total, item) => {
        const rate = Number(item.ammount ?? item.data?.ammount ?? 0);

        return total + rate;
    }, 0)

    const isEotContieneous = selectedGroupContingencies.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );

    const eotContieneous = Math.max(
        ...selectedGroupContingencies.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );


    let eotCont = [];

    if (isEotContieneous) {
        eotCont = Array.from({ length: eotContieneous }).map((_, eotIdx) => {
            // sum this EOT index across all employees
            return selectedGroupContingencies.reduce((sum, emp) => {
                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                const eot = details[eotIdx];
                return sum + (Number(eot?.total_amount) || 0);
            }, 0);
        });
    }

    console.log("Eot Total", eotCont);


    const maxEotLength = Math.max(
        eotContieneous,
        maxLength,
        eotDutyLength,
        eotRentLength,
        eotSubLengths,
        eotFurnitureLength,
        eotReportLength,
        eotSurveyLength,
        eotSupportLengths
    )

    // const ContingenciesTotal = contingencies.reduce((total, item) => total + parseFloat(item.ammount || 0), 0)



    // Sample data from the image
    const costData = [
        { description: 'Remuneration for Local Professional Staff', amount: KeyPROFESSIONALTotal + SubProfessionalTotal, eot: total },
        { description: 'Supporting Staff', amount: SupportStaffTotal, eot: eotSupportStaffTotals },
        { description: 'Transportation', amount: TransportationTotal },
        { description: 'Duty Travel to Site', amount: DutyTotal, eot: eotTotalduty },
        { description: 'Office Rent', amount: OfficeRentTotal, eot: eotTotalRent },
        { description: 'Office Supplies, Utilities, and Communication', amount: OfficeSupplies, eot: eotTotalSupplies },
        { description: 'Office Furniture and Equipment', amount: OfficeFurnitureTotal, eot: eotTotalFurniture },
        { description: 'Reports and Document Printing', amount: Reportsprinting, eot: eotTotalReports },
        { description: 'Road Survey Equipment', amount: RoadSurveyEquipmentTotal, eot: eotTotalSurvey },
        { description: 'Contingencies', amount: ContingenciesTotal, eot: eotCont },
    ];

    const subTotal = costData.reduce((total, item) => total + item.amount, 0);
    // find the max length among all eot arrays
    const maxLengthh = Math.max(
        ...costData.map(item => item.eot?.length || 0)
    );

    // compute column-wise totals
    const eotTotals = Array.from({ length: maxLengthh }).map((_, idx) =>
        costData.reduce((sum, row) => sum + (row.eot?.[idx] || 0), 0)
    );

    console.log("eotTotals");
    console.log(eotTotals);

    const tax = Math.round(subTotal * 0.18); // returns a number


    const totalCost = subTotal + tax;
    const eotGST = eotTotals.map(val => val * 0.18);

    // column-wise total including GST
    const eotWithGST = eotTotals.map((val, idx) => val + eotGST[idx]);

    const [descriptionByProject, setDescriptionByProject] = useState([]);

    const getDescription = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/descriptionfilterss/${projectID ? projectID : id}/`);
            setDescriptionByProject(res.data);
        } catch (error) {
            console.error("Error fetching description by project:", error);
        }
    }

    useEffect(() => {
        getDescription();
    }, [projectID, id])

    const filterByDescriptionType = (data, type) => {
        return data
            .filter((item) =>
                item.description.some((desc) => desc.description_type === type)
            )
            .map((item) => ({
                ...item,
                description: item.description.filter(
                    (desc) => desc.description_type === type
                ),
            }));
    };

    const filteredEmployeeDescription = filterByDescriptionType(descriptionByProject, "BOQEmployee");
    const employeeDescriptionData = filteredEmployeeDescription.flatMap(item =>
        item.description
    );

    const filteridEmployeeDescriptionId = filteredEmployeeDescription.flatMap(i => i.id)
    const filteredTransportDescription = filterByDescriptionType(descriptionByProject, "BOQTransportation");
    const TransportDescriptionData = filteredTransportDescription.flatMap(item =>
        item.description
    );

    const filteridTransportDescriptionId = filteredTransportDescription.flatMap(i => i.id)


    const filteredDutyDescription = filterByDescriptionType(descriptionByProject, "BOQDutyTravel");
    const DutyDescriptionData = filteredDutyDescription.flatMap(item =>
        item.description
    );

    const filteridDutyDescriptionId = filteredDutyDescription.flatMap(i => i.id)
    const filteredRentDescription = filterByDescriptionType(descriptionByProject, "BOQOfficeRent");
    const RentDescriptionData = filteredRentDescription.flatMap(item =>
        item.description
    );

    const filteridRentDescriptionId = filteredRentDescription.flatMap(i => i.id)

    const filteredSuppliesDescription = filterByDescriptionType(descriptionByProject, "BOQOfficeSupplies");
    const SuppliesDescriptionData = filteredSuppliesDescription.flatMap(item =>
        item.description
    );

    const filteridSuppliesDescriptionId = filteredSuppliesDescription.flatMap(i => i.id)


    const filteredfurnitureDescription = filterByDescriptionType(descriptionByProject, "BOQOfficeFurnitureAndEquipment");
    const FurnitureDescriptionData = filteredfurnitureDescription.flatMap(item =>
        item.description
    );

    const filteridFurnitureDescriptionId = filteredfurnitureDescription.flatMap(i => i.id)

    const filteredReportsDescription = filterByDescriptionType(descriptionByProject, "BOQReports");

    const ReportsDescriptionData = filteredReportsDescription.flatMap(item =>
        item.description
    );

    const filteridReportsDescriptionId = filteredReportsDescription.flatMap(i => i.id)
    const filteredSurveyDescription = filterByDescriptionType(descriptionByProject, "BOQSurvey");

    const SurveyDescriptionData = filteredSurveyDescription.flatMap(item =>
        item.description
    );

    const filteridSurveyDescriptionId = filteredSurveyDescription.flatMap(i => i.id)
    const filteredContigeniousDescription = filterByDescriptionType(descriptionByProject, "BOQContingencies");

    const ContigeniousDescriptionData = filteredContigeniousDescription.flatMap(item =>
        item.description
    );

    const filteridContigeniousDescriptionId = filteredContigeniousDescription.flatMap(i => i.id)
    const selectedRandomKey = logid !== "null"
        ? groupedByRandomChange[parseInt(logid)]?.[0]
        : "null";

    return (
        <div className='printSlip-container' ref={ref}>

            <div className="page-break"> <SummaryTable projectData={projectbyid} costData={costData} subTotal={subTotal} tax={tax} totalCost={totalCost} length={maxEotLength} eotTotals={eotTotals} eotWithGST={eotWithGST} eotGST={eotGST} /></div>
            <div className="page-break">

                <BreakdownOfCosts setIndex={setIndex} descriptionData={employeeDescriptionData} idDescription={filteridEmployeeDescriptionId} projectData={projectbyid} getLogData={getLogData} logData={filterBOQEmployeeeLogChange} id={id} breakdown={breakdown} getBreakdownCost={getBreakdownCost} props={props} logid={logid} setLogId={setLogId} buffer={buffer} />

                <SubprofessionalStaff index={index} projectData={projectbyid} getLogData={getLogData} logData={filterBOQEmployeeeLogChange} id={id} breakdown={breakdown} getBreakdownCost={getBreakdownCost} props={props} logid={logid} setLogId={setLogId} />
                <SupportStaff index={index} projectData={projectbyid} getLogData={getLogData} logData={filterBOQEmployeeeLogChange} id={id} breakdown={breakdown} getBreakdownCost={getBreakdownCost} props={props} logid={logid} setLogId={setLogId} /></div>
            <div className="page-break">     <Transportation descriptionData={TransportDescriptionData} idDescription={filteridTransportDescriptionId} projectData={projectbyid} getLogData={getLogData} logData={filterBOQTransportationLogChange} props={props} id={id} transportation={transportation} getTransportation={getTransportation} logid={transportLogid} setLogId={settransportLogId} groupedByRandomChange={groupedByRandomChangeTransport} selectedGroup={selectedGroupTransPort} /></div>

            <div className="page-break"> <DutyTravel descriptionData={DutyDescriptionData} idDescription={filteridDutyDescriptionId} props={props} id={id} dutyTravel={dutyTravel} getDutyTravel={getDutyTravel} logData={filterBOQDutyTravelLogChange} projectData={projectbyid} getLogData={getLogData} logid={dutyTravelLogid} setLogId={setdutyTravelLogId} groupedByRandomChange={groupedByRandomChangeDuty} selectedGroup={selectedGroupDuty} /></div>
            <div className="page-break">  <OfficeRent descriptionData={RentDescriptionData} idDescription={filteridRentDescriptionId} props={props} id={id} officeRent={officeRent} getOfficeRent={getOfficeRent} logData={filterBOQOfficeRentLogChange} projectData={projectbyid} getLogData={getLogData} logid={rentLogid} setLogId={setRentLogId} groupedByRandomChange={groupedByRandomChangeOfficeRent} selectedGroup={selectedGroupRent} /></div>
            <div className="page-break"> <OfficeSuppliess descriptionData={SuppliesDescriptionData} idDescription={filteridSuppliesDescriptionId} props={props} id={id} officeSupplies={officeSupplies} getOfficeSupplies={getOfficeSupplies} logData={filterBOQOfficeSuppliesLogChange} projectData={projectbyid} getLogData={getLogData} logid={suppliesLogid} setLogId={setsuppliesLogid} groupedByRandomChange={groupedByRandomChangeSupplies} selectedGroup={selectedGroupSupplies} /></div>
            <div className="page-break">  <OfficeFurniture descriptionData={FurnitureDescriptionData} idDescription={filteridFurnitureDescriptionId} props={props} id={id} officeFurniture={officeFurniture} officeFurnitureheading={officeFurnitureheading} getOfficeFurniture={getOfficeFurniture} getOfficeFurnitureheading={getOfficeFurnitureheading} logData={filterBOQOfficeFurnitureAndEquipmentLogChange} projectData={projectbyid} getLogData={getLogData} logid={furniturelogid} setLogId={setfurnitureLogId} groupedByRandomChange={groupedByRandomChangeFurniture} selectedGroup={selectedGroupFurniture} /></div>
            <div className="page-break"> <ReportsPrinting descriptionData={ReportsDescriptionData} idDescription={filteridReportsDescriptionId} props={props} id={id} reportsPrinting={reportsPrinting} getReportsPrinting={getReportsPrinting} logData={filterBOQReportsAndDocumentPrintingLogChange} projectData={projectbyid} getLogData={getLogData} logid={reportlogid} setLogId={setreportLogId} groupedByRandomChange={groupedByRandomChangeReports} selectedGroup={selectedGroupReport} /></div>
            <div className="page-break">  <RoadSurveyEquipment descriptionData={SurveyDescriptionData} idDescription={filteridSurveyDescriptionId} props={props} id={id} roadSurveyEquipment={roadSurveyEquipment} toggle={toggle} getRoadSurveyEquipment={getRoadSurveyEquipment} logData={filterBOQRoadSurveyEquipmentLogChange} projectData={projectbyid} getLogData={getLogData} logid={roadSurveylogid} setLogId={setroadSurveyLogId} groupedByRandomChange={groupedByRandomChangeRoadSurvey} selectedGroup={selectedGroupRoadSurvey} /> </div>
            <div className="page-break"> <Contingencies descriptionData={ContigeniousDescriptionData} idDescription={filteridContigeniousDescriptionId} props={props} id={id} contingencies={contingencies} getContingencies={getContingencies} logData={filterBOQContingenciesLogChange} getLogData={getLogData} projectData={projectbyid} logid={Contingencieslogid} setLogId={setContingenciesLogId} groupedByRandomChange={groupedByRandomChangeContingencies} selectedGroup={selectedGroupContingencies} /></div>
        </div>
    )
});

const Invoiceformate = (i) => {
    const ref = useRef();
    const [isPrinting, setIsPrinting] = useState(false);

    const handleBeforePrint = () => {
        setIsPrinting(true);
    };

    const handleAfterPrint = () => {
        setIsPrinting(false);
    };
    console.log("isPrinting")
    console.log(isPrinting)

    return (
        <div className='flex-column flex-center  slip-container'>
            {/* <div className='printSlip-width flex-row justify-evenly button-margin'>
                <ReactToPrint
                    bodyClass="print-agreement"
                    content={() => ref.current}
                    onBeforeGetContent={handleBeforePrint}
                    onAfterPrint={handleAfterPrint}
                    trigger={() => (
                        <button className="model-button model-button-black">
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 20 18" fill="none">
                                <path d="M17 5H3C1.34 5 0 6.34 0 8V12C0 13.1 0.9 14 2 14H4V16C4 17.1 4.9 18 6 18H14C15.1 18 16 17.1 16 16V14H18C19.1 14 20 13.1 20 12V8C20 6.34 18.66 5 17 5ZM13 16H7C6.45 16 6 15.55 6 15V11H14V15C14 15.55 13.55 16 13 16ZM17 9C16.45 9 16 8.55 16 8C16 7.45 16.45 7 17 7C17.55 7 18 7.45 18 8C18 8.55 17.55 9 17 9ZM15 0H5C4.45 0 4 0.45 4 1V3C4 3.55 4.45 4 5 4H15C15.55 4 16 3.55 16 3V1C16 0.45 15.55 0 15 0Z" fill="white" />
                            </svg> Print
                        </button>
                    )}
                />
            </div> */}
            <PrintBOQformat ref={ref} isPrinting={isPrinting} />
        </div>
    );
}



export { Invoiceformate, PrintBOQformat }
